module.exports = {
	"el": {
		"moet-core": {
			"select_language": {
				"title": "Επιλέξτε γλώσσα",
				"paragraph": "Αυτή θα είναι η προεπιλεγμένη γλώσσα σας.",
				"submit": "Εντάξει"
			},
			"products": {
				"mandatory": "Περιλαμβάνεται πάντα",
				"kco": {
					"name": {
						"default": "Ολοκλήρωση αγορών"
					},
					"description": {
						"default": "Προσφέρετε όλες τις μεθόδους πληρωμής μας."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Πληρωμή τώρα"
							},
							"description": {
								"default": "Προσφέρετε άμεσες πληρωμές με κάρτα ή τραπεζική μεταφορά."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Πληρωμή σε 30 ημέρες"
							},
							"description": {
								"default": "Προσφέρετε 30 ημέρες για πληρωμή. Άτοκα."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Χρηματοδότηση"
							},
							"description": {
								"default": "Προσφορά για πληρωμή σε διάστημα 6-36 μηνών.",
								"DE": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών",
								"AT": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 3 άτοκες δόσεις.",
								"GB": "Προσφέρετε 3 άτοκες δόσεις."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Χωρίστε τις σε 4 δόσεις",
								"US": "Δόσεις",
								"AU": "Πληρωμή σε 4 δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 4 άτοκες δόσεις.",
								"GB": "Προσφέρετε 4 άτοκες δόσεις."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Μέθοδοι πληρωμής"
					},
					"description": {
						"default": "Επιλέξτε από τις αυτόνομες λύσεις πληρωμών μας. Επιλέξτε μία, ή συνδυάστε πολλές. Απλή, μοναδική ενσωμάτωση, ανεξάρτητα από το τι επιλέγετε."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Πληρωμή τώρα"
							},
							"description": {
								"default": "Προσφέρετε άμεσες πληρωμές με κάρτα ή τραπεζική μεταφορά."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Πληρωμή σε 30 ημέρες"
							},
							"description": {
								"default": "Προσφέρετε 30 ημέρες για πληρωμή. Άτοκα."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Χρηματοδότηση"
							},
							"description": {
								"default": "Προσφορά για πληρωμή σε διάστημα 6-36 μηνών.",
								"DE": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών",
								"AT": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 3 άτοκες δόσεις.",
								"GB": "Προσφέρετε 3 άτοκες δόσεις."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Χωρίστε τις σε 4 δόσεις",
								"US": "4 Πληρωμές",
								"CA": "4 πληρωμές",
								"AU": "Πληρωμή σε 4 δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 4 άτοκες δόσεις.",
								"GB": "Προσφέρετε 4 άτοκες δόσεις.",
								"US": "Οι παραγγελίες από 35 $ έως 1000 $ μπορούν να χωριστούν σε 4 άτοκες πληρωμές, που οφείλονται κάθε 2 εβδομάδες.",
								"CA": "Οι παραγγελίες από 35 $ έως 1000 $ μπορούν να χωριστούν σε 4 άτοκες πληρωμές, με προθεσμία πληρωμής κάθε 2 εβδομάδες."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Ολοκλήρωση αγορών"
					},
					"description": {
						"default": "Αντικαταστήστε τη σελίδα πληρωμής του καταστήματός σας με τις ολοκληρωμένες υπηρεσίες πληρωμών της Klarna."
					},
					"description_expanded": {
						"default": "Αντικαταστήστε τη σελίδα πληρωμής του καταστήματός σας με τις ολοκληρωμένες υπηρεσίες πληρωμών της Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Μέθοδος πληρωμής"
					},
					"description": {
						"default": "Προσθέστε μεθόδους πληρωμής Klarna στην υπάρχουσα σελίδα πληρωμής σας"
					},
					"description_expanded": {
						"default": "Η προσφορά των μεθόδων πληρωμής Klarna οδηγεί σε μια μέση αύξηση κατά 30% στο conversion rate, 41% στη μέση αξία παραγγελίας (AOV) και 36% στη συχνότητα αγορών."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Αυτό το πεδίο απαιτείται για να συνεχίσετε",
					"generic": "Η παρεχόμενη τιμή δεν είναι έγκυρη",
					"required_suffix": "απαιτείται για να συνεχίσετε",
					"generic_suffix": "δεν είναι έγκυρο",
					"min_one": "Πρέπει να επιλέξετε τουλάχιστον ένα στοιχείο",
					"min": "Πρέπει να επιλέξετε τουλάχιστον {min} στοιχεία",
					"max": "Δεν μπορείτε να επιλέξετε περισσότερα από {max} στοιχεία",
					"given_name": "Λείπει το όνομα",
					"family_name": {
						"general": "Λείπει το επώνυμο",
						"too_short": "Καταχωρίστε ένα έγκυρο επώνυμο"
					},
					"date_of_birth": {
						"general": {
							"default": "Καταχωρίστε μια έγκυρη ημερομηνία γέννησης (ΗΗ/ΜΜ/ΕΕΕΕ)",
							"US": "Καταχωρίστε μια έγκυρη ημερομηνία γέννησης (ΜΜ/ΗΗ/ΕΕΕΕ)"
						},
						"too_young": "Όλα τα ενδιαφερόμενα μέρη πρέπει να είναι άνω των 16 ετών",
						"too_young_eighteen": "Πρέπει να είστε άνω των 18 ετών"
					},
					"street_address": "Καταχωρίστε μια διεύθυνση",
					"street_address2": "Καταχωρίστε μια έγκυρη γραμμή διεύθυνσης 2",
					"postal_code": "Καταχωρίστε έναν ταχυδρομικό κώδικα",
					"country": "Καταχωρίστε μια χώρα",
					"region": "Καταχωρίστε μια περιοχή",
					"state": "Καταχωρίστε μια πολιτεία",
					"iban": "Καταχωρίστε έναν αριθμό λογαριασμού (IBAN)",
					"companyName": "Καταχωρίστε μια επωνυμία εταιρείας",
					"email": "Καταχωρίστε μια έγκυρη διεύθυνση email",
					"contact_email": "Καταχωρίστε μια έγκυρη διεύθυνση email επικοινωνίας",
					"support_email": "Καταχωρίστε μια έγκυρη διεύθυνση email υποστήριξης πελατών",
					"support_phone": "Καταχωρίστε έναν έγκυρο τηλεφωνικό αριθμό υποστήριξης",
					"selling_countries": "Πρέπει να επιλέξετε τουλάχιστον μία χώρα",
					"store_category": "Πρέπει να επιλέξετε μία από τις επιλογές",
					"name": "Καταχωρίστε ένα όνομα καταστήματος",
					"legal_form": "Επιλέξτε ένα από τα αναφερόμενα είδη επιχείρησης",
					"generic_toggle_undefined": "Επιλέξτε μία από τις επιλογές",
					"website": "Καταχωρίστε μια έγκυρη διεύθυνση URL ιστότοπου",
					"bankAccounts": "Καταχωρίστε τουλάχιστον έναν τραπεζικό λογαριασμό",
					"product": "Επιλέξτε ένα προϊόν",
					"platform": "Επιλέξτε μια πλατφόρμα",
					"password": "Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης",
					"currency_code": "Καταχωρίστε έναν κωδικό νομίσματος",
					"account_holder": "Καταχωρίστε έναν κάτοχο τραπεζικού λογαριασμού",
					"account_type": "Καταχωρίστε ένα είδος τραπεζικού λογαριασμού",
					"routing_number": "Καταχωρίστε έναν έγκυρο αριθμό δρομολόγησης",
					"account_number": {
						"first": "Καταχωρίστε έναν έγκυρο αριθμό λογαριασμού για τον προεπιλεγμένο τραπεζικό λογαριασμό",
						"second": "Καταχωρίστε έναν έγκυρο αριθμό λογαριασμού για τον πρώτο επιπλέον τραπεζικό λογαριασμό",
						"third": "Καταχωρίστε έναν έγκυρο αριθμό λογαριασμού για τον δεύτερο επιπλέον τραπεζικό λογαριασμό",
						"fourth": "Καταχωρίστε έναν έγκυρο αριθμό λογαριασμού για τον τρίτο επιπλέον τραπεζικό λογαριασμό",
						"general": "Καταχωρίστε έναν έγκυρο αριθμό λογαριασμού"
					},
					"role": "Καταχωρίστε έναν ρόλο",
					"address": "Καταχωρίστε μια διεύθυνση",
					"political_exposed_person": "Καταχωρίστε πληροφορίες ΠΕΠ",
					"pep_position": "Καταχωρίστε πληροφορίες θέσης",
					"pep_relationship": "Καταχωρίστε πληροφορίες σχέσης με το άτομο ΠΕΠ",
					"goodsCategory": "Καταχωρίστε μια κατηγορία αγαθών",
					"registered": "Καταχωρίστε πληροφορίες σχετικά με την εγγραφή της επιχείρησής σας",
					"subjectToVat": "Καταχωρίστε έναν ΑΦΜ",
					"registrationCourt": "Καταχωρίστε ένα δικαστήριο εγγραφής",
					"registrationId": {
						"general": {
							"default": "Καταχωρίστε έναν έγκυρο αριθμό εγγραφής",
							"AT": "Καταχωρίστε έναν έγκυρο αριθμό εγγραφής",
							"AU": "Καταχωρίστε ένα έγκυρο ACN",
							"ES": "Καταχωρίστε ένα έγκυρο NIF/NIE/DNI εταιρείας",
							"GB": "Καταχωρίστε έναν έγκυρο αριθμό οργανισμού",
							"GR": "Εισαγάγετε έναν έγκυρο αριθμό Γ.Ε.ΜΗ.",
							"CA": "Καταχωρίστε έναν έγκυρο αριθμό επιχείρησης",
							"NZ": "Καταχωρίστε έναν έγκυρο αριθμό επιχείρησης",
							"US": "Καταχωρίστε έναν έγκυρο αριθμό αναγνώρισης εργοδότη"
						},
						"missing_leading_0_GB": "Καταχωρίστε έναν 8ψήφιο αριθμό οργανισμού. Μπορεί να λείπει το αρχικό 0 στον αριθμό του οργανισμού σας (π.χ. 03452678)",
						"invalid": {
							"default": "Καταχωρίστε έναν έγκυρο αριθμό εγγραφής",
							"AT": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 5 έως 11 χαρακτήρες. Λάβετε υπόψη ότι αυτό δεν είναι ο ΦΠΑ ή το αναγνωριστικό εμπόρου.",
							"AU": "Το ACN πρέπει να αποτελείται από 9 ψηφία, χωρίς κενά. Π.χ. 123456789",
							"BE": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 10 ψηφία. Π.χ. 1234567890",
							"CA": "Ο αριθμός επιχείρησης πρέπει να αποτελείται από 9 ψηφία. Π.χ. 123456789",
							"CZ": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 8 ψηφία. Π.χ. 12345678",
							"DE": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 6 έως 11 χαρακτήρες και πρέπει να ξεκινά με HRA, HRB, GnR, VR ή PR ακολουθούμενο από ένα κενό. Λάβετε υπόψη ότι αυτό δεν είναι ο ΦΠΑ ή το αναγνωριστικό εμπόρου.",
							"ES": "Το NIF/NIE/DNI πρέπει να αποτελείται από 8 ή 9 χαρακτήρες ξεκινώντας με 1 γράμμα/ψηφίο ακολουθούμενο από 6 ή 7 ψηφία και 1 γράμμα/ψηφίο",
							"FI": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 8 ψηφία με μια παύλα πριν από το τελευταίο, χωρίς κενά. Π.χ. 1234567-8",
							"FR": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 9 ψηφία, π.χ. 123 456 789 ή 123456789 (SIREN), ή 14 ψηφία, π.χ. 123 456 789 12345 ή 12345678912345 (SIRET).",
							"IE": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 2 γράμματα ακολουθούμενα από 6 ψηφία, ή μόνο 6 ψηφία εάν είστε ατομικός έμπορος (π.χ. AB123456).",
							"IT": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 11 ψηφία (π.χ. 01234567890) ή συνδυασμό 16 αριθμών και κεφαλαίων γραμμάτων (π.χ. ABCABC12A12A123A)",
							"GB": "Ο αριθμός οργανισμού πρέπει να αποτελείται από 8 ψηφία. Π.χ. 12345678, ή δύο γράμματα ακολουθούμενα από 6 ψηφία (SC123456), ή 1 γράμμα ακολουθούμενο από 7 ψηφία (S1234567)",
							"GR": "Ο αριθμός Γ.Ε.ΜΗ. πρέπει να αποτελείται από 12 ψηφία, π.χ. 012345678901",
							"NL": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 8 ψηφία. Π.χ. 12345678",
							"NO": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 9 ψηφία, χωρίς κενά. Π.χ. 123456789",
							"NZ": "Ο αριθμός επιχείρησης πρέπει να αποτελείται από 13 ψηφία. Π.χ. 1234567890123",
							"PL": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 10 ψηφία, χωρίς κενά. Π.χ. 1234561234",
							"PT": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 9 ψηφία, χωρίς κενά. Π.χ. 123123123",
							"SE": "Ο αριθμός εγγραφής πρέπει να αποτελείται από 10 ψηφία με παύλα, χωρίς κενά. Π.χ. 123456-1234",
							"US": "Ο αριθμός αναγνώρισης εργοδότη πρέπει να αποτελείται από 9 ψηφία με παύλα μετά τα δύο πρώτα. Π.χ. 12-3456789",
							"MX": "Το RFC θα πρέπει να αποτελείται από 12 χαρακτήρες, ξεκινώντας από τα αρχικά της εταιρείας, την 6ψήφια ημερομηνία σύστασης και την τιμή ελέγχου. Π.χ. ABC921010H20"
						}
					},
					"tocLink": "Κάτι πήγε στραβά με τους όρους και προϋποθέσεις. Δοκιμάστε ξανά αργότερα ή επικοινωνήστε με την υποστήριξη πελατών στο {supportEmail}",
					"vat": {
						"general": {
							"default": "Καταχωρίστε ένα έγκυρο ΑΦΜ",
							"AU": "Καταχωρίστε ένα έγκυρο ABN",
							"ES": "Καταχωρίστε ένα έγκυρο NIF/NIE/DNI εταιρείας",
							"NZ": "Καταχωρίστε έναν έγκυρο αριθμό GST"
						},
						"invalid": {
							"default": "Μη έγκυρο ΑΦΜ",
							"AT": "Ο ΑΦΜ πρέπει να είναι ATU ακολουθούμενος από 8 ψηφία. Π.χ. ATU12345678",
							"AU": "Το ABN πρέπει να είναι 11 ψηφία.",
							"CZ": "Ο ΑΦΜ πρέπει να είναι CZ ακολουθούμενος από 8, 9 ή 10 ψηφία. Π.χ. CZ123456789",
							"GR": "Ο ΑΦΜ πρέπει να αποτελείται από 9 ψηφία και πρέπει να ξεκινά με EL. Π.χ.: EL123456789",
							"DE": "Ο ΑΦΜ πρέπει να είναι DE ακολουθούμενος από 9 ψηφία. Π.χ. DE123456789",
							"ES": "Το NIF/NIE/DNI πρέπει να αποτελείται από 8 ή 9 χαρακτήρες ξεκινώντας με 1 γράμμα/ψηφίο ακολουθούμενο από 6 ή 7 ψηφία και 1 γράμμα/ψηφίο",
							"FR": "Ο ΑΦΜ πρέπει να είναι FR ακολουθούμενος από 2 γράμματα/ψηφία και 9 ψηφία (SIREN), π.χ. FRXX123456789",
							"GB": "Ο ΑΦΜ πρέπει να αποτελείται από 6 έως 15 χαρακτήρες.",
							"IE": "Ο ΑΦΜ πρέπει να είναι IE ακολουθούμενος από 8 ή 9 χαρακτήρες που περιλαμβάνουν 1 ή 2 γράμματα. Π.χ. IE1234567WA, IE1234567A",
							"IT": "Ο ΑΦΜ πρέπει να είναι IT ακολουθούμενος από 11 ψηφία. Π.χ. IT12345678912",
							"NL": "Ο ΑΦΜ πρέπει να είναι NL ακολουθούμενος από 9 ψηφία, ακολουθούμενο από B και 2 ψηφία. Π.χ. NL123456789B12",
							"NZ": "Ο αριθμός GST πρέπει να αποτελείται από 8 ψηφία (12345678) ή 9 ψηφία, με ή χωρίς παύλες κάθε 3 ψηφία (123-123-123 ή 123123123)",
							"PL": "Ο ΑΦΜ πρέπει να είναι PL ακολουθούμενος από 10 ψηφία. Π.χ. PL1234567890",
							"PT": "Ο ΑΦΜ πρέπει να είναι PT ακολουθούμενος από 9 ψηφία. Π.χ. PT123123123",
							"MX": "Το RFC πρέπει να ξεκινά με τα αρχικά της εταιρείας, την 6ψήφια ημερομηνία σύστασης και την τιμή ελέγχου. Π.χ. ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Καταχωρίστε τα τελευταία 4 ψηφία του SSN σας",
							"format": "Καταχωρίστε τα τελευταία 4 ψηφία του SSN σας"
						},
						"US_FULL_SSN": {
							"general": "Καταχωρίστε το πλήρες (9ψήφιο) SSN",
							"format": "Καταχωρίστε το πλήρες (9ψήφιο) SSN σας"
						},
						"CA": {
							"general": "Καταχωρίστε ένα έγκυρο SIN ή αριθμό διαβατηρίου",
							"format": "SIN: XXX-XXX-XXX / Αριθμός διαβατηρίου: ABXXXXXX"
						},
						"SE": {
							"general": "Καταχωρίστε έναν έγκυρο Προσωπικό Αριθμό Αναγνώρισης (PNO)",
							"format": "Καταχωρίστε τον PNO σε μορφή: ΕΕΕΕΜΜΗΗ-XXXX"
						},
						"FI": {
							"general": "Καταχωρίστε έναν έγκυρο Προσωπικό Κωδικό Αναγνώρισης (HETU)",
							"format": "Καταχωρίστε τον HETU σε μορφή: ΗΗΜΜΕΕSXXXX"
						},
						"NO": {
							"general": "Καταχωρίστε έναν έγκυρο Αριθμό Εθνικής Ταυτότητας",
							"format": "Καταχωρίστε σε μορφή: ΗΗΜΜΕΕXXXXX"
						},
						"DK": {
							"general": "Καταχωρίστε έναν έγκυρο Προσωπικό Αριθμό Αναγνώρισης (CPR)",
							"format": "Καταχωρίστε τον CPR σε μορφή: ΗΗΜΜΕΕ-XXXX"
						},
						"IT": {
							"general": "Καταχωρίστε έναν έγκυρο φορολογικό κωδικό",
							"format": "Καταχωρίστε τον φορολογικό κωδικό σε μορφή: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Καταχωρίστε έναν έγκυρο Προσωπικό Αριθμό Αναγνώρισης (DNI ή NIE)",
							"format": "Καταχωρίστε τον DNI ή NIE, π.χ. 12345678A"
						},
						"PL": {
							"general": "Καταχωρίστε έναν έγκυρο Προσωπικό Κωδικό Αναγνώρισης (PESEL)",
							"format": "Καταχωρίστε τον PESEL σε μορφή: ΕΕΜΜΗΗZZZXQ"
						},
						"default": {
							"general": "Καταχωρίστε έναν έγκυρο αριθμό διαβατηρίου"
						}
					},
					"store_name": "Καταχωρίστε ένα όνομα καταστήματος"
				},
				"errors_keys": {
					"correlationIdLabel": "Αναγνωριστικό συσχέτισης: {correlationId}",
					"decisionTaken": "Η απόφαση προαξιολόγησης έχει ήδη ληφθεί. Επαναφορτώστε τη σελίδα.",
					"maintenanceMode": "Η εφαρμογή μας είναι προς το παρόν εκτός λειτουργίας λόγω συντήρησης. Ελέγξτε ξανά αργότερα",
					"validation": {
						"storeName": {
							"invalidType": "Καταχωρίστε ένα έγκυρο όνομα καταστήματος."
						},
						"email": {
							"invalidType": "Καταχωρίστε μια έγκυρη διεύθυνση email."
						},
						"goodsCategory": {
							"invalidType": "Καταχωρίστε μια κατηγορία αγαθών."
						},
						"website": {
							"invalidType": "Καταχωρίστε έναν έγκυρο ιστότοπο."
						}
					}
				}
			},
			"general": {
				"yes": "Ναι",
				"no": "Όχι",
				"encrypted_text": "*******",
				"pricing_link_eu": "Προβολή όλων των τιμών ανά χώρα",
				"pricing_link_us": "Προβολή τιμών",
				"formFieldOptional": "προαιρετικό",
				"buttons": {
					"next": "Επόμενο",
					"back": "Επιστροφή",
					"continue": "Συνέχεια",
					"submit_application": {
						"default": "Ξεκινήστε",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Ξεκινήστε"
					},
					"add_aditional_item": "+ Προσθέστε επιπλέον προϊόν"
				},
				"unknown_step_title": "Καταχωρίστε τις απαιτούμενες πληροφορίες",
				"selected": "Επιλέχθηκε",
				"clear_all": "Διαγραφή όλων"
			},
			"errors": {
				"general": "Προέκυψε σφάλμα. Επικοινωνήστε με την υποστήριξή μας.",
				"salesforce": "Δοκιμάστε να ανανεώσετε τη σελίδα. Εάν το σφάλμα εξακολουθεί να υφίσταται, στείλτε το αναγνωριστικό σφάλματος στο κανάλι #smooothforce-support slack και θα σας βοηθήσουμε.",
				"managed_kyc": "Δοκιμάστε να ανανεώσετε τη σελίδα. Εάν το σφάλμα εξακολουθεί να υφίσταται, επικοινωνήστε με την υποστήριξη εμπόρων ή την επαφή πωλήσεών σας.",
				"copy": "Αντιγραφή",
				"noTermsAccepted": "Διαβάστε και αποδεχτείτε όλες τις αναφερόμενες συμφωνίες μας",
				"termsAlreadyAccepted": "Έχετε ήδη αποδεχτεί όλες τις αναφερόμενες συμφωνίες",
				"mandatoryField": " απαιτείται"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Ατομικός έμπορος",
					"PARTNERSHIP": "Συνεταιρισμός",
					"PUBLIC_LISTED_COMPANY": "Εισηγμένη εταιρεία",
					"PRIVATE_COMPANY": "Ιδιωτική εταιρεία"
				},
				"organization_entity_types": {
					"C_CORP": "Εταιρεία C",
					"S_CORP": "Εταιρεία S",
					"PARTNERSHIP": "Συνεταιρισμός",
					"TRUST_ESTATE": "Καταπίστευμα/περιουσία",
					"INDIVIDUAL": "Άτομο",
					"SOLE_PROPRIETORSHIP": "Ατομική επιχείρηση",
					"SOLE_TRADER": "Ατομικός έμπορος",
					"LIMITED_LIABILITY_COMPANY": "Εταιρεία περιορισμένης ευθύνης",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Μονοπρόσωπη ΕΠΕ"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Παπούτσια και ρούχα για ενήλικες",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Προϊόντα αυτοκινήτου - Ανταλλακτικά και αξεσουάρ αυτοκινήτου",
					"BAGS_AND_WALLETS": "Κοσμήματα & Αξεσουάρ - Τσάντες και πορτοφόλια",
					"BODY_AND_HAIR_CARE": "Υγεία & Ομορφιά - Περιποίηση σώματος και μαλλιών",
					"BOOK_AND_MAGAZINES": "Ψυχαγωγία - Βιβλία και περιοδικά",
					"CANDY": "Φαγητό & Ποτά - Γλυκά",
					"CAR_ELECTRONICS": "Ηλεκτρονικά - Ηλεκτρονικά αυτοκινήτων",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Παιδικά προϊόντα - Παιδικά ρούχα και προϊόντα περιποίησης",
					"CHILDREN_TOYS": "Παιδικά προϊόντα - Παιδικά παιχνίδια",
					"CLEANING_AND_SANITARY": "Σπίτι & Κήπος - Καθαριότητα και υγιεινή",
					"COLLECTIBLES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Συλλεκτικά αντικείμενα",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Καταστήματα Concept και διάφορα",
					"COSMETICS": "Υγεία & Ομορφιά - Καλλυντικά",
					"COSTUMES_AND_PARTY_SUPPLIES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Στολές και είδη πάρτι",
					"DATING_SERVICES": "Άυλα προϊόντα - Υπηρεσίες γνωριμιών",
					"DECORATION_AND_ART": "Σπίτι & Κήπος - Διακόσμηση και τέχνη",
					"DIETARY_SUPPLEMENTS": "Υγεία & Ομορφιά - Συμπληρώματα διατροφής",
					"DIGITAL_SERVICES": "Άυλα προϊόντα - Ψηφιακές υπηρεσίες",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Παιδικά προϊόντα - Διαφοροποιημένα παιδικά προϊόντα",
					"DIVERSIFIED_ELECTRONICS": "Ηλεκτρονικά - Διαφοροποιημένα ηλεκτρονικά προϊόντα",
					"DIVERSIFIED_ENTERTAINMENT": "Ψυχαγωγία - Διαφοροποιημένη ψυχαγωγία",
					"DIVERSIFIED_EROTIC_MATERIAL": "Ερωτικά υλικά - Διαφοροποιημένο ερωτικό υλικό",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Υγεία & Ομορφιά - Διαφοροποιημένα προϊόντα υγείας και ομορφιάς",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Σπίτι & Κήπος - Διαφοροποιημένα προϊόντα σπιτιού και κήπου",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Κοσμήματα & Αξεσουάρ - Διαφοροποιημένα κοσμήματα και αξεσουάρ",
					"EDUCATION": "Άυλα προϊόντα - Εκπαίδευση",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Ηλεκτρονικά - Ηλεκτρονικός εξοπλισμός και σχετικά αξεσουάρ",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Ερωτικά υλικά - Ερωτικά ρούχα και αξεσουάρ",
					"EVENT_TICKETS": "Άυλα προϊόντα - Εισιτήρια εκδηλώσεων",
					"FOOD_AND_BEVERAGE": "Φαγητό & Ποτά - Φαγητό και ποτά",
					"FRAGRANCES": "Υγεία & Ομορφιά - Αρώματα",
					"FURNITURE": "Σπίτι & Κήπος - Έπιπλα",
					"GENERAL_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Γενικά παπούτσια και ρούχα",
					"HOBBY_ARTICLES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Αντικείμενα για χόμπι",
					"HOUSEHOLD_ELECTRONICS": "Ηλεκτρονικά - Οικιακά ηλεκτρονικά προϊόντα",
					"JEWELRY_AND_WATCHES": "Κοσμήματα & Αξεσουάρ - Κοσμήματα και ρολόγια",
					"KITCHENWARE": "Σπίτι & Κήπος - Είδη κουζίνας",
					"MARKETPLACES": "Άυλα προϊόντα - Αγορές",
					"MUSIC_AND_MOVIES": "Ψυχαγωγία - Μουσική και ταινίες",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Μουσικά όργανα και εξοπλισμός",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Κοσμήματα & Αξεσουάρ - Μη συνταγογραφούμενα γυαλιά ηλίου και φακοί επαφής",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Ηλεκτρονικά - Μηχανήματα γραφείου και σχετικά αξεσουάρ",
					"OTHER_SERVICES": "Άυλα προϊόντα - Άλλες υπηρεσίες",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Υγεία & Ομορφιά - Προσωπική φροντίδα και βελτίωση σώματος",
					"PET_SUPPLIES": "Σπίτι & Κήπος - Προμήθειες για κατοικίδια",
					"PHARMACEUTICAL_PRODUCTS": "Υγεία & Ομορφιά - Φαρμακευτικά προϊόντα",
					"PLANTS_AND_FLOWERS": "Σπίτι & Κήπος - Φυτά και λουλούδια",
					"PRESCRIPTION_OPTICS": "Υγεία & Ομορφιά - Συνταγογραφούμενα οπτικά είδη",
					"PRINTS_AND_PHOTOS": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Εκτυπώσεις και φωτογραφίες",
					"SAFETY_PRODUCTS": "Σπίτι & Κήπος - Προϊόντα ασφάλειας",
					"SEX_TOYS": "Ερωτικά υλικά - Σεξουαλικά παιχνίδια",
					"SPORTS_GEAR_AND_OUTDOOR": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Αθλητικός εξοπλισμός και προϊόντα εξωτερικού χώρου",
					"TOBACCO": "Φαγητό & Ποτά - Είδη καπνιστού",
					"TOOLS_AND_HOME_IMPROVEMENT": "Σπίτι & Κήπος - Εργαλεία και ανακαίνιση",
					"TRAVEL_SERVICES": "Άυλα προϊόντα - Ταξιδιωτικές υπηρεσίες",
					"UNDERWEAR": "Ρούχα & Παπούτσια - Εσώρουχα",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Ψυχαγωγία - Βιντεοπαιχνίδια και σχετικά αξεσουάρ",
					"WHEELS_AND_TIRES": "Προϊόντα αυτοκινήτου - Ζάντες και ελαστικά",
					"WINE_BEER_AND_LIQUOR": "Φαγητό & Ποτά - Κρασί, μπύρα και οινοπνευματώδη",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Νεανικά παπούτσια και ρούχα",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Περιορισμός ηλικίας - Τυχερά παιχνίδια, στοιχήματα, καζίνο και λαχεία",
					"CHARITIES_AND_NGO": "Άυλα προϊόντα - Φιλανθρωπίες και υπηρεσίες ΜΚΟ",
					"EROTIC_SERVICES": "Ερωτικά υλικά - Ερωτικές υπηρεσίες",
					"FINANCIAL_SERVICES_CRYPTO": "Χρηματοοικονομικές υπηρεσίες - Δραστηριότητες σχετικές με κρυπτονομίσματα",
					"FINANCIAL_SERVICES_MSB": "Χρηματοοικονομικές υπηρεσίες - Κλάδος χρηματικών υπηρεσιών",
					"FINANCIAL_SERVICES_E_WALLETS": "Χρηματοοικονομικές υπηρεσίες - Ηλεκτρονικά πορτοφόλια",
					"FINANCIAL_SERVICES_TRADING": "Χρηματοοικονομικές υπηρεσίες - Εμπόριο",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Άυλα προϊόντα - Κοινότητες σε κοινωνικές πλατφόρμες",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Ταξίδια - Πράκτορες αεροπορικών ταξιδιών & κρουαζιέρας",
					"TRAVEL_BROKER_AND_AGENCIES": "Ταξίδια - Μεσιτικές υπηρεσίες & πρακτορεία",
					"TRAVEL_GROUND_TRANSPORTATION": "Ταξίδια - Χερσαίες μεταφορές",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Ταξίδια - Καταλύματα & θέρετρα",
					"EVENT_ORGANIZER": "Εκδηλώσεις - Διοργανωτές",
					"EVENT_BROKER_AND_AGENCIES": "Εκδηλώσεις - Μεσιτικές υπηρεσίες & πρακτορεία"
				},
				"us_states": {
					"AL": "Αλαμπάμα",
					"AK": "Αλάσκα",
					"AZ": "Αριζόνα",
					"AR": "Άρκανσο",
					"CA": "Καλιφόρνια",
					"CO": "Κολοράντο",
					"CT": "Κονέκτικατ",
					"DC": "Περιφέρεια Κολούμπια",
					"DE": "Ντέλαγουερ",
					"FL": "Φλόριντα",
					"GA": "Τζόρτζια",
					"HI": "Χαβάη",
					"ID": "Άινταχο",
					"IL": "Ιλινόις",
					"IN": "Ιντιάνα",
					"IA": "Άιοβα",
					"KS": "Κάνσας",
					"KY": "Κεντάκι",
					"LA": "Λουιζιάνα",
					"ME": "Μέιν",
					"MD": "Μέριλαντ",
					"MA": "Μασαχουσέτη",
					"MI": "Μίσιγκαν",
					"MN": "Μινεσότα",
					"MS": "Μισισίπι",
					"MO": "Μιζούρι",
					"MT": "Μοντάνα",
					"NE": "Νεμπράσκα",
					"NV": "Νεβάδα",
					"NH": "Νιου Χάμσαϊρ",
					"NJ": "Νιου Τζέρσεϊ",
					"NM": "Νέο Μεξικό",
					"NY": "Νέα Υόρκη",
					"NC": "Βόρεια Καρολίνα",
					"ND": "Βόρεια Ντακότα",
					"OH": "Οχάιο",
					"OK": "Οκλαχόμα",
					"OR": "Όρεγκον",
					"PA": "Πενσυλβάνια",
					"RI": "Ρόουντ Άιλαντ",
					"SC": "Νότια Καρολίνα",
					"SD": "Νότια Ντακότα",
					"TN": "Τενεσί",
					"TX": "Τέξας",
					"UT": "Γιούτα",
					"VT": "Βερμόντ",
					"VA": "Βιρτζίνια",
					"WA": "Ουάσιγκτον",
					"WV": "Δυτική Βιρτζίνια",
					"WI": "Ουισκόνσιν",
					"WY": "Γουαϊόμινγκ"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Πρόσωπο",
						"COMPANY": "Εταιρεία"
					},
					"roles": {
						"OWNER": "Κάτοχος",
						"ULTIMATE_BENEFICIAL_OWNER": "Τελικός δικαιούχος",
						"CONTROL_OVER_MANAGEMENT": "Έλεγχος στη διαχείριση",
						"APPLICANT": "Εξουσιοδοτημένος υπογράφων",
						"SOLE_TRADER": "Ατομικός έμπορος",
						"PARTNER": "Εταίρος/Συνεργάτης"
					}
				},
				"payment_intervals": {
					"DAILY": "Ημερησίως",
					"WEEKLY": "Εβδομαδιαίως"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Παραδοσιακή πώληση αγαθών",
						"description": "Ο έμπορος πουλά προϊόντα ή υπηρεσίες με παραδοσιακό τρόπο: τα αγαθά θεωρούνται πλήρως καταναλωμένα κατά την πρώτη παράδοση και συνήθως δεν υπάρχει εκτεταμένη περίοδος μεταξύ παραγγελίας και παράδοσης"
					},
					"VOUCHER": {
						"label": "Κουπόνι",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από κουπόνια ή/και δωροκάρτες"
					},
					"MEMBERSHIP": {
						"label": "Ιδιότητα μέλους",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από ιδιότητες μέλους"
					},
					"SUBSCRIPTION": {
						"label": "Συνδρομή",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από συνδρομές"
					},
					"PHARMACIES": {
						"label": "Φαρμακεία",
						"description": "Ο έμπορος πουλά συνταγογραφούμενα ή μη συνταγογραφούμενα φάρμακα"
					},
					"US_PHARMACIES": {
						"label": "Φαρμακεία των ΗΠΑ",
						"description": "Ο έμπορος πουλά συνταγογραφούμενα ή μη συνταγογραφούμενα φάρμακα στις ΗΠΑ"
					},
					"MEDICAL_SERVICES": {
						"label": "Ιατρικές υπηρεσίες",
						"description": "Ο έμπορος πουλά ιατρικές υπηρεσίες, όπως τεστ, εξετάσεις και νοσηλευτική φροντίδα"
					},
					"MARKETPLACES": {
						"label": "Αγορές",
						"description": "Ο έμπορος έχει μια υποεμπορική σχέση"
					},
					"FIREARM_DEALERS": {
						"label": "Έμποροι πυροβόλων όπλων",
						"description": "Ο έμπορος πουλά όπλα και πυρομαχικά που απαιτούν άδεια"
					},
					"AUCTIONS": {
						"label": "Δημοπρασίες",
						"description": "Ο έμπορος είναι ένας οίκος δημοπρασιών"
					},
					"ALCOHOL": {
						"label": "Αλκοόλ",
						"description": "Ο έμπορος πουλά αλκοόλ"
					},
					"TOBACCO": {
						"label": "Είδη καπνιστού",
						"description": "Ο έμπορος πουλά είδη καπνιστού με ή χωρίς νικοτίνη, ή o έμπορος πουλά ηλεκτρονικά τσιγάρα"
					},
					"HEMP_CBD_THC": {
						"label": "Κάνναβη, CBD ή THC",
						"description": "Ο έμπορος πουλά προϊόντα που περιέχουν κάνναβη, CBD ή THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Δωρεές και φιλανθρωπία",
						"description": "Ο έμπορος είναι ένας οργανισμός δωρεών ή φιλανθρωπικός οργανισμός που ενσωματώνει την «Εκταμίευση μετά τον διακανονισμό»"
					},
					"TRAVEL": {
						"label": "Ταξίδια",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από ταξίδια"
					},
					"EVENTS": {
						"label": "Εκδηλώσεις",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από εκδηλώσεις"
					},
					"COURSES": {
						"label": "Μαθήματα",
						"description": "Πάνω από το 10% των πωλήσεων αποτελείται από μαθήματα"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Εκπαιδευτικά μαθήματα",
						"description": "Ο έμπορος πουλάει εκπαιδευτικά μαθήματα που διαρκούν για μια συγκεκριμένη χρονική περίοδο."
					},
					"FOOD_DELIVERY": {
						"label": "Παράδοση φαγητού",
						"description": "Ο έμπορος παρέχει υπηρεσία παράδοσης φαγητού."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Εξατομικευμένη προπαραγγελία/Έπιπλα",
						"description": "Ο έμπορος πουλάει προϊόντα προπαραγγελίας, όπως έπιπλα."
					},
					"DIGITAL_CONTENT": {
						"label": "Ψηφιακό περιεχόμενο",
						"description": "Ο έμπορος πουλάει ψηφιακό περιεχόμενο, όπως ηλεκτρονικά βιβλία και διαδικτυακά παιχνίδια."
					},
					"GAMING_INDUSTRY": {
						"label": "Κλάδος παιχνιδιών (Τυχερά παιχνίδια, στοιχήματα, καζίνο, λαχεία)",
						"description": "Ο έμπορος παρέχει υπηρεσίες σχετικές με τον κλάδο παιχνιδιών, όπως τυχερά παιχνίδια, στοιχήματα, καζίνο και λαχεία."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Γεια σας, {firstName}",
						"primary_title_without_name": "Γεια σας,",
						"sub_title": "Περισσότερο Klarna είναι πιο πολύ Klarna, είπε ο Σαίξπηρ.",
						"sub_title_no_products": "Ξεκινήστε την εμπειρία σας στην Klarna επιλέγοντας ένα προϊόν παρακάτω",
						"sub_title_kp_products": "Επιλέξτε ένα άλλο προϊόν Klarna",
						"sub_title_ongoing_product": "Συνεχίστε τη ρύθμιση του {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Προϊόντα πληρωμής",
							"text_blocks": [
								{
									"text": "Προσθέστε μια λύση στις ρυθμίσεις σας"
								}
							]
						}
					},
					"buttons": {
						"start": "Εκκίνηση",
						"continue": "Συνέχεια",
						"view_summary": "Προβολή σύνοψης",
						"add_another_product": "Προσθέστε ένα άλλο προϊόν"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Μεταβείτε στο Playground Environment για να εξερευνήσετε και να δημιουργήσετε διαπιστευτήρια Test API, ώστε να μπορείτε να δοκιμάσετε την πλατφόρμα σας.",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Στοιχεία μάρκετινγκ",
							"text": "Η χρήση της Klarna σημαίνει smoooth «πλοήγηση» για τους πελάτες σας. Χρησιμοποιήστε τα στοιχεία μάρκετινγκ που διαθέτουμε για να ενθουσιαστούν.",
							"link": "Λάβετε στοιχεία"
						},
						"your_application": {
							"title": "Η αίτησή σας",
							"text": "Κάντε κλικ εδώ για να ολοκληρώσετε τη ρύθμιση ή να δείτε τα στοιχεία της αίτησής σας, συμπεριλαμβανομένων των όρων & προϋποθέσεων.",
							"link": "Ανοιχτό"
						},
						"invite_more_users": {
							"title": "Προσκαλέστε περισσότερους χρήστες",
							"text": "Προσκαλέστε τους συνεργάτες σας στην Πύλη Εμπόρων, θα μπορείτε να ρυθμίσετε προσαρμοσμένες άδειες για καθέναν από αυτούς!",
							"link": "Προσκαλέστε χρήστες"
						}
					},
					"footer": {
						"title": "Περιλαμβάνεται πάντα με την Klarna",
						"list": {
							"merchant_portal": {
								"title": "Η Πύλη Εμπόρων",
								"text_blocks": [
									{
										"text": "Διαχειριστείτε οτιδήποτε Klarna με πλήρη πρόσβαση στο παρασκήνιο."
									}
								]
							},
							"global_products": {
								"title": "Παγκόσμια προϊόντα, τοπικά πρόσωπα",
								"text_blocks": [
									{
										"text": "Όλα τα προϊόντα μας είναι κατασκευασμένα για να πληρούν τις τοπικές προτιμήσεις και τη νομοθεσία."
									}
								]
							},
							"local_support": {
								"title": "Τοπική υποστήριξη για εσάς και τους πελάτες σας",
								"text_blocks": [
									{
										"text": "Έχουμε χιλιάδες ανθρώπους έτοιμους να βοηθήσουν τους πελάτες σας όταν χρειάζονται μια ανθρώπινη προσέγγιση."
									}
								]
							},
							"marketing_tool": {
								"title": "H Klarna ως εργαλείο μάρκετινγκ",
								"text_blocks": [
									{
										"text": "Θα σας παρέχουμε πρόσβαση σε υλικά της Klarna που μπορείτε να χρησιμοποιήσετε στις πρωτοβουλίες σας μάρκετινγκ."
									}
								]
							},
							"single_integration": {
								"title": "Ενιαία ενσωμάτωση, αυτόματες ενημερώσεις",
								"text_blocks": [
									{
										"text": "Μία ενσωμάτωση, χωρίς ενημερώσεις. Ποτέ."
									},
									{
										"text": "Μόλις ενσωματώσετε την Klarna, τελειώσατε. Είναι πάντα ενημερωμένη - και δεν χρειάζεται να σηκώσετε ούτε δαχτυλάκι."
									}
								]
							},
							"no_risk": {
								"title": "Κανένας κίνδυνος για εσάς ή τους πελάτες σας",
								"text_blocks": [
									{
										"text": "Οι πληρωμές σας είναι πάντα εγγυημένες και οι πελάτες σας καλύπτονται από την Προστασία Αγοραστή Klarna (Klarna Buyer Protection)."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Διαπιστευτήρια Klarna API",
							"text_blocks": [
								{
									"text": "Τα διαπιστευτήρια Klarna API συνδέουν το προϊόν μας με το κατάστημά σας, ώστε να ξεκινήσετε τις πωλήσεις."
								}
							]
						},
						"toc_key": {
							"title": "Όροι & προϋποθέσεις",
							"text_blocks": [
								{
									"text": "Πρέπει να ενημερώσετε τους όρους & προϋποθέσεις του ηλεκτρονικού εμπορίου σας"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Οδηγίες ενσωμάτωσης",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Πώς να χρησιμοποιήσετε τα διαπιστευτήρια Klarna API",
							"ordered_list": {
								"one": "Δημιουργήστε και κατεβάστε τα διαπιστευτήριά σας",
								"two": "Επικολλήστε τα διαπιστευτήρια (όνομα χρήστη και κωδικός πρόσβασης Klarna API) στην πλατφόρμα σας, όπως εξηγείται στις οδηγίες ενσωμάτωσης παρακάτω"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Συνολικά 5 διαπιστευτήρια Klarna API",
							"text": "Μπορείτε να δημιουργήσετε έως και πέντε διαπιστευτήρια Klarna API. Αποκτήστε το πρώτο εδώ και, στη συνέχεια, δημιουργήστε τα υπόλοιπα στις Ρυθμίσεις.",
							"button": "Δημιουργήστε διαπιστευτήρια Klarna API"
						},
						"how_to_update_toc": {
							"title": "Πώς να ενημερώσετε τους όρους & προϋποθέσεις",
							"ordered_list": {
								"one": "Επισκεφθείτε τον σύνδεσμο",
								"two": "Διαβάστε τις οδηγίες και αντιγράψτε το κείμενο",
								"three": "Συμπεριλάβετέ το στους όρους & προϋποθέσεις του ηλεκτρονικού σας καταστήματος"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Θυμηθείτε να ενημερώσετε το κείμενο με τα προϊόντα για τα οποία έχετε εγγραφεί.",
							"linkText": "Μεταβείτε στην ενημέρωση των όρων & προϋποθέσεων >"
						},
						"buttons": {
							"back": "Επιστροφή"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Η αίτησή σας βρίσκεται υπό εξέταση…",
						"TRANSACTION_DETAILS_STARTED": "Η αίτησή σας εξετάζεται από την ομάδα μας. Θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.",
						"TRANSACTIONS_REVIEW_MANUAL": "Η αίτησή σας εξετάζεται από την ομάδα μας. Θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.",
						"TRANSACTIONS_ENABLED": "Συγχαρητήρια. Είστε έτοιμοι να κάνετε πωλήσεις με την Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Το αίτημά σας για πληρωμές βρίσκεται υπό εξέταση…",
						"PAYOUTS_REVIEW_MANUAL": "Το αίτημά σας για πληρωμές εξετάζεται από την ομάδα μας. Θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Περιμένουμε την πρώτη σας πώληση με την Klarna...",
						"TRANSACTIONS_DISABLED": "Ο λογαριασμός σας είναι απενεργοποιημένος μέχρι να ολοκληρώσετε το βήμα ενεργοποίησης πληρωμών.",
						"SUSPENDED": "Ο λογαριασμός σας έχει διακοπεί προσωρινά.",
						"notice": "Αυτή τη στιγμή ο χρόνος αναμονής για τον έλεγχο της αίτησής σας είναι μεγαλύτερος από τον μέσο όρο. Μην ανησυχείτε, η αίτησή σας εξετάζεται και θα επικοινωνήσουμε μαζί σας για περισσότερες πληροφορίες σχετικά με τα επόμενα βήματα. Ευχαριστούμε για την υπομονή σας και την κατανόησή σας."
					},
					"statuses": {
						"pending": "Σε εκκρεμότητα",
						"done": "Ολοκληρώθηκε"
					},
					"in_review": {
						"title": "Εξετάζουμε την αίτησή σας.",
						"subtitle": "Αυτή τη στιγμή πραγματοποιούμε έναν τελικό έλεγχο της αίτησής σας με την Klarna για να βεβαιωθούμε ότι όλα τα στοιχεία στη σύμβαση είναι σωστά. Αυτή είναι μια μη αυτόματη διαδικασία, επομένως, οι χρόνοι χειρισμού μπορεί να διαφέρουν, αλλά θα την ολοκληρώσουμε όσο το δυνατόν γρηγορότερα.",
						"content": {
							"title": "Για να διασφαλίσετε ότι ο έλεγχος θα γίνει όσο το δυνατόν πιο γρήγορα, βεβαιωθείτε ότι τα ακόλουθα είναι ορατά στον ιστότοπό σας:",
							"list": {
								"default": {
									"item_1": "Η εγγεγραμμένη επωνυμία της εταιρείας σας",
									"item_2": "Ο αριθμός της εγγεγραμμένης εταιρείας σας",
									"item_3": "Η εγγεγραμμένη διεύθυνση της εταιρείας σας",
									"item_4": "Πολιτική επιστροφής τουλάχιστον 14 ημερών",
									"item_5": "Διεύθυνση email ή αριθμός της εξυπηρέτησης πελατών"
								},
								"US": {
									"item_1": "Εγγεγραμμένη επωνυμία εταιρείας",
									"item_2": "Πολιτική επιστροφών",
									"irem_3": "Διεύθυνση email ή αριθμός της εξυπηρέτησης πελατών"
								},
								"AU": {
									"item_1": "ABN (Αριθμός εταιρείας) ή εγγεγραμμένη επωνυμία επιχείρησης.",
									"item_3": "Η εγγεγραμμένη διεύθυνση της εταιρείας σας",
									"item_4": "Πολιτική επιστροφής τουλάχιστον 14 ημερών",
									"item_5": "Διεύθυνση email ή αριθμός της εξυπηρέτησης πελατών"
								}
							}
						},
						"footer": "Θα σας στείλουμε ένα email μόλις ολοκληρωθεί ο έλεγχος, ή εάν χρειαστούμε πρόσθετες πληροφορίες από εσάς."
					},
					"suspended": {
						"title": "Δυστυχώς…",
						"subtitle": "Αφού εξετάσαμε τα στοιχεία της σύμβασής σας, έπρεπε να απορρίψουμε την αίτησή σας. Μπορεί να υπάρχουν διάφοροι λόγοι για τους οποίους η αίτησή σας δεν εγκρίθηκε. Παρακάτω είναι μερικοί από τους πιο συνηθισμένους παράγοντες:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Το κατάστημά σας δεν συμμορφώνεται με τις κατευθυντήριες οδηγίες δεοντολογίας της Klarna.",
								"item_2": "Ήταν αδύνατη η επικοινωνία με το άτομο επικοινωνίας που υποβλήθηκε.",
								"item_3": "Άλλοι τεχνικοί ή διοικητικοί παράγοντες."
							}
						},
						"footer": "Σας ευχαριστούμε για το ενδιαφέρον σας στην Klarna. Επικοινωνήστε μαζί μας εάν έχετε οποιεσδήποτε σχετικές ερωτήσεις, ή εάν θελήσετε να εγγραφείτε με διαφορετικό κατάστημα στο μέλλον."
					},
					"disabled": {
						"title": "Η αίτησή σας έχει απενεργοποιηθεί.",
						"subtitle": "Ο λογαριασμός σας απενεργοποιήθηκε αυτόματα επειδή λείπουν οι νομικά απαιτούμενες πληροφορίες.",
						"content": {
							"title": "Αυτό συμβαίνει συνήθως όταν η Klarna σας έχει ζητήσει να παράσχετε κάποιες πληροφορίες και δεν απαντήσατε πριν από την καθορισμένη ημερομηνία λήξης."
						},
						"footer": "Εάν πιστεύετε ότι πρόκειται για λάθος ή θα θέλατε να υποβάλετε ξανά τις πληροφορίες, επικοινωνήστε με την Υποστήριξη Εμπόρων χρησιμοποιώντας τα στοιχεία επικοινωνίας στο υποσέλιδο αυτής της σελίδας."
					},
					"ready_to_connect": {
						"title": "Συνδέστε το κατάστημά σας",
						"subtitle": "Η σύμβασή σας ολοκληρώθηκε και μπορείτε πλέον να ενσωματώσετε την Klarna στο κατάστημά σας. Ακολουθήστε τα παρακάτω βήματα για να ολοκληρώσετε την ενσωμάτωση.",
						"status_messsage": {
							"title": "Η ενσωμάτωση δεν έχει ολοκληρωθεί ακόμη",
							"subtitle": "Ακολουθήστε τις οδηγίες ενσωμάτωσης για να συνδέσετε το κατάστημά σας. Αυτή η κατάσταση θα γίνει πράσινη μόλις πραγματοποιηθεί μια συναλλαγή χρησιμοποιώντας την Klarna."
						},
						"content": {
							"title": "Οδηγίες",
							"options": {
								"label_1": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
								"description_1": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε τα στον υπολογιστή σας. Θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα.",
								"label_2": "Εγκαταστήστε την Klarna στο κατάστημα Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Σχεδόν έτοιμοι",
						"subtitle": "Είστε ένα βήμα πιο κοντά στο να προσφέρετε smoooth εμπειρία αγορών στους πελάτες σας! Η σύμβασή σας ολοκληρώθηκε και το κατάστημά σας είναι έτοιμο για ενσωμάτωση.",
						"buttons": {
							"connect": "Συνδέστε το κατάστημά σας"
						},
						"additional_info": "Έχετε υπόψη ότι η ενσωμάτωση θα επισημανθεί ως ολοκληρωμένη μόνο όταν λάβουμε την πρώτη αγορά, η οποία μπορεί να χρειαστεί λίγο χρόνο, ανάλογα με την πλατφόρμα σας."
					},
					"store_connected": {
						"title": "Το κατάστημά σας είναι συνδεδεμένο",
						"subtitle": "Η ενσωμάτωση του καταστήματός σας στην Klarna έχει ολοκληρωθεί και οι πελάτες σας μπορούν να πληρώνουν χρησιμοποιώντας την Klarna.",
						"status_messsage": {
							"title": "Επιτυχής ενσωμάτωση",
							"subtitle": "Μια συναλλαγή Klarna διεκπεραιώθηκε με επιτυχία μέσω του καταστήματός σας.",
							"button_text": {
								"shown": "Εμφάνιση οδηγιών ενσωμάτωσης",
								"hidden": "Απόκρυψη οδηγιών ενσωμάτωσης"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Η αίτησή σας",
							"subtitle": "Ελέγξτε τα στοιχεία της αίτησής σας.",
							"button_text": "Προβολή σύνοψης"
						},
						"connect_store": {
							"title": "Διαπιστευτήρια Klarna API",
							"subtitle": "Δημιουργήστε διαπιστευτήρια Klarna API για να ενσωματώσετε το κατάστημά σας.",
							"button_text": "Δημιουργήστε διαπιστευτήρια Klarna API"
						},
						"add_product": {
							"title": "Προϊόντα",
							"subtitle": "Κάντε κλικ εδώ εάν θέλετε να προσθέσετε ένα προϊόν για αυτή τη ρύθμιση.",
							"button_text": "Προσθέστε προϊόντα"
						}
					},
					"timeline": {
						"application": {
							"title": "Η αίτησή σας",
							"alert": {
								"view_summary": "Προβολή σύνοψης",
								"rejected": "Έπρεπε να απορρίψουμε την αίτησή σας.",
								"review": "Ελέγξτε τα στοιχεία της αίτησής σας κάνοντας κλικ στον παρακάτω σύνδεσμο."
							}
						},
						"payouts": {
							"title": "Οι πληρωμές ενεργοποιήθηκαν"
						},
						"integration": {
							"title": "Η ενσωμάτωση δεν έχει ολοκληρωθεί ακόμη",
							"alert": "Ακολουθήστε τις οδηγίες ενσωμάτωσης για να συνδέσετε το κατάστημά σας."
						},
						"integration_complete": {
							"title": "Η ενσωμάτωση ολοκληρώθηκε!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Συγχαρητήρια, η ρύθμισή σας ολοκληρώθηκε!",
						"rejection": "Λυπούμαστε, δεν μπορέσαμε να ολοκληρώσουμε τη ρύθμισή σας."
					},
					"header_new": {
						"title": "Καλώς ήρθατε, Έμπορε Klarna",
						"subtitle": "Σύνοψη",
						"rejection": "Η αίτηση απορρίφθηκε"
					},
					"joy_section": {
						"approved": {
							"title": "Εγκρίθηκε!",
							"content": "Η αίτησή σας εξετάστηκε και εγκρίθηκε. Η πλήρης πρόσβαση στην υπηρεσία της Klarna είναι πλέον στα χέρια σας. Είμαστε ενθουσιασμένοι που θα συνεργαστούμε μαζί σας!",
							"button_title": "Ελέγξτε τις παραγγελίες σας",
							"link": "ή τα στοιχεία μας μάρκετινγκ"
						},
						"rejected": {
							"title": "Δυστυχώς...",
							"content_1": "Μετά τον έλεγχο της αίτησής σας, δεν μπορούμε να εγκρίνουμε τη σύμβαση εμπόρου.",
							"content_2": "Μη διστάσετε να επικοινωνήσετε με την ομάδα υποστήριξης εάν έχετε οποιεσδήποτε ερωτήσεις."
						}
					},
					"sidebar_left": {
						"application_details": "Τα στοιχεία της αίτησής σας",
						"store_details": {
							"title": "Στοιχεία καταστήματος",
							"text_blocks": [
								{
									"text": "Μια σύνοψη των στοιχείων σας"
								}
							]
						},
						"credentials": {
							"title": "Διαπιστευτήρια Klarna API",
							"text_blocks": [
								{
									"text": "Τα διαπιστευτήριά σας Klarna API"
								}
							]
						},
						"payouts": {
							"title": "Εκταμιεύσεις",
							"text_blocks": [
								{
									"text": "Τα τραπεζικά στοιχεία που υποβάλατε"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Επιπλέον τραπεζικοί λογαριασμοί",
							"text_block": null
						},
						"business_owners": {
							"title": "Ιδιοκτήτες επιχείρησης",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Υλικές επιρροές",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Ενδιαφερόμενα μέρη",
							"text_blocks": [
								{
									"text": "Οι πληροφορίες που υποβάλατε"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Ιδιοκτήτες επιχείρησης",
								"no_elements": "Δεν υποβάλατε κανέναν ιδιοκτήτη επιχείρησης"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Προεπιλεγμένος τραπεζικός λογαριασμός",
								"no_elements": "Δεν υπάρχει διαθέσιμος προεπιλεγμένος τραπεζικός λογαριασμός"
							},
							"additional_bank_accounts": {
								"title": "Επιπλέον τραπεζικοί λογαριασμοί",
								"no_elements": "Δεν υποβάλατε επιπλέον τραπεζικούς λογαριασμούς"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Ιδιοκτήτες",
								"no_elements": "Δεν υποβάλατε κανέναν ιδιοκτήτη"
							},
							"ultimate_beneficial_owner": {
								"title": "Δικαιούχοι ιδιοκτήτες",
								"no_elements": "Δεν υποβάλατε κανέναν δικαιούχο ιδιοκτήτη"
							},
							"applicant": {
								"title": "Αιτούντες",
								"no_elements": "Δεν υποβάλατε κανέναν αιτούντα"
							},
							"control_over_management": {
								"title": "Άτομα που ελέγχουν τη διαχείριση",
								"no_elements": "Δεν υποβάλατε ενδιαφερόμενα μέρη που ελέγχουν τη διαχείριση"
							}
						},
						"buttons": {
							"back": "Επιστροφή",
							"next_step": "Επόμενο"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Έχουμε ήδη τα δεδομένα σας",
							"text_blocks": [
								{
									"text": "Αυτές είναι οι πληροφορίες που μας έχετε ήδη παράσχει."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Δεν υποβάλατε κανέναν ιδιοκτήτη επιχείρησης"
						},
						"buttons": {
							"submit": "Υποβολή",
							"back": "Επιστροφή"
						}
					}
				},
				"checking_page": {
					"title": "Γίνεται έλεγχος...",
					"subtitle": "Ευχαριστούμε για την υποβολή της αίτησης. Περιμένετε μέχρι να την ελέγξουμε..."
				},
				"success_page": {
					"title": "Τώρα μπορείτε να συνδέσετε το κατάστημά σας",
					"subtitle": "Σας ευχαριστούμε για την υποβολή της αίτησης.",
					"buttons": {
						"next": "Επόμενο"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Βασικά",
						"business": "Επιχείρηση",
						"stakeholders": "Ενδιαφερόμενα μέρη",
						"bank_accounts": "Τραπεζικοί λογαριασμοί"
					}
				},
				"app_error": {
					"title": "Η εφαρμογή «Προϊόντα» δεν είναι διαθέσιμη αυτή τη στιγμή",
					"message": "Αντιμετωπίζουμε προβλήματα με την εφαρμογή μας και ήδη το εξετάζουμε. Προσπαθούμε να επιλύσουμε τα προβλήματα το συντομότερο δυνατό. Προσπαθήστε ξανά αργότερα."
				},
				"temporarily_down": {
					"title": "Αντιμετωπίζουμε τεχνικές δυσκολίες",
					"message": "Ζητούμε συγγνώμη για την όποια ταλαιπωρία και σας διαβεβαιώνουμε ότι κάνουμε ό,τι καλύτερο για να επιλύσουμε το πρόβλημα. Ελέγξτε ξανά αργότερα."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Η εφαρμογή μας «Προϊόντα» είναι προς το παρόν εκτός λειτουργίας λόγω συντήρησης",
						"signup_app": "Η εφαρμογή εγγραφής μας Signup είναι προς το παρόν εκτός λειτουργίας λόγω συντήρησης"
					},
					"message": "Εργαζόμαστε για να βελτιώσουμε την εμπειρία σας και ελπίζουμε να γίνει το συντομότερο δυνατό. Ελέγξτε ξανά αργότερα."
				},
				"unknown_merchant": {
					"before_link": "Εάν έχετε ήδη συμφωνία μαζί μας, επισκεφθείτε",
					"link_text": "αυτή την σελίδα",
					"after_link": "για να μάθετε περισσότερα για τα προϊόντα μας!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Προέκυψε σφάλμα.",
						"invalid_token": "Αυτός ο σύνδεσμος έχει λήξει"
					},
					"message": {
						"invalid_token_risk": " Επικοινωνήστε με το κανάλι #smooothforce-support slack και θα σας βοηθήσουμε.",
						"invalid_token": "Επικοινωνήστε με την επαφή πωλήσεών σας.",
						"invalid_flow_type": "Ο τύπος και η κατάσταση ενσωμάτωσης αυτού του εμπόρου δεν είναι συμβατοί. Εάν πιστεύετε ότι πρόκειται για σφάλμα, επικοινωνήστε με την Υποστήριξη Εμπόρων."
					}
				},
				"topbar": {
					"title": "Ρύθμιση",
					"widget_type": {
						"MANAGED_KYC": "Συλλογή KYC",
						"MANAGED_RISK": "Συλλογή προαξιολόγησης",
						"MANAGED_SME_RISK": "Συλλογή προαξιολόγησης SME"
					}
				},
				"product_card": {
					"incompatible_description": "Μη διαθέσιμο για τη χώρα/πλατφόρμα σας",
					"kco_footer_text": "Οι διαθέσιμες μέθοδοι πληρωμής στο Klarna Checkout εξαρτώνται από τη χώρα εγγραφής σας και τη χώρα στην οποία κάνετε πωλήσεις.",
					"products_link_text": "Περισσότερα"
				},
				"product_prices_card": {
					"title": "Προϊόντα",
					"subtitle": "{country}",
					"pricing": "Τιμολόγηση για {country}",
					"monthly_fee": "μηνιαίο τέλος",
					"transaction_fee": "τέλος συναλλαγής",
					"before_link": "Συμφωνώ με τους",
					"link_text": "όρους & προϋποθέσεις",
					"after_link_one_product": "για αυτό το προϊόν",
					"after_link_more_than_one_product": "για αυτά τα προϊόντα",
					"product_not_available_in_your_country": "* Αυτό το προϊόν δεν είναι διαθέσιμο για την εγχώρια αγορά σας, αλλά θα λειτουργήσει σε άλλες χώρες.",
					"edit_link": "Επεξεργασία",
					"merchant_agreement": {
						"before_link": "Συμφωνώ με την",
						"link_text": "Συμφωνία Εμπόρου",
						"after_link_one_product": "για αυτό το προϊόν",
						"after_link_more_than_one_product": "για αυτά τα προϊόντα"
					},
					"pricing_annex": {
						"before_link": "Συμφωνώ με τους",
						"link_text": "Όρους Τιμολόγησης",
						"after_link_one_product": "για αυτό το προϊόν"
					}
				},
				"support_footer": {
					"text": "Υποστήριξη στα αγγλικά",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Με την επιφύλαξη παντός δικαιώματος.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Όροι & Προϋποθέσεις.",
					"privacy_policy": "Πολιτική Απορρήτου",
					"merchant_id": "Αναγνωριστικό Εμπόρου {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Υποστήριξη Εμπόρων",
					"recaptcha": {
						"1_main_text": "Αυτός ο ιστότοπος προστατεύεται από το reCAPTCHA και την",
						"2_privacy_policy": "Πολιτική Απορρήτου",
						"3_and": "και",
						"4_terms_of_service": "οι Όροι Χρήσης",
						"5_apply": "ισχύουν."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Τιμές για όλες τις αγορές μας",
					"title_us": "Τιμές",
					"subtitle": "Χρεώνεστε μόνο ένα τέλος ανά συναλλαγή, αυτό θα πει smoooth!",
					"table": {
						"country": "Χώρα",
						"price_column_heading": "Τέλος ανά συναλλαγή",
						"global": "Παγκόσμιο",
						"title": {
							"kp": "Μέθοδοι πληρωμής",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Μέθοδος πληρωμής Klarna"
						},
						"headers": {
							"kp_one": "Χρέωση υπηρεσίας"
						}
					},
					"buttons": {
						"back": "Επιστροφή"
					},
					"foot_notes": {
						"global_price": "* Τοπικό νόμισμα του εμπόρου, διαφορετικά "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Πρώτη συναλλαγή",
						"content": "Για να μπορέσουμε να ελέγξουμε τα στοιχεία πληρωμής σας, χρειαζόμαστε μια πρώτη παραγγελία. Δεν θέλετε να σπαταλήσετε τα δικά σας χρήματα; Κανένα πρόβλημα!",
						"button": "Αυτοσχεδιάστε!"
					},
					"transactions": {
						"title": "Έγκριση συναλλαγών",
						"content": "Μπορείτε απλώς να αυτοσχεδιάσετε την έγκριση συναλλαγής του δυναμικού πωλήσεων",
						"button": "Έγκριση"
					},
					"payouts": {
						"title": "Έγκριση πληρωμών",
						"content": "Μπορείτε απλώς να αυτοσχεδιάσετε την έγκριση πληρωμών του δυναμικού πωλήσεων",
						"button": "Έγκριση"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Προεπιλεγμένος τραπεζικός λογαριασμός",
						"additional": "Επιπλέον τραπεζικός λογαριασμός {index}",
						"normal": "Τραπεζικός λογαριασμός {index}"
					},
					"currency_code": {
						"label": "Νόμισμα"
					},
					"country_of_bank_account": {
						"label": "Χώρα"
					},
					"account_number": {
						"label": {
							"default": "Αριθμός λογαριασμού",
							"MX_LOCAL": "Αριθμός CLABE"
						}
					},
					"account_holder": {
						"label": "Όνομα κατόχου λογαριασμού"
					},
					"routing_number": {
						"label": "Αριθμός δρομολόγησης"
					},
					"transit_number": {
						"label": "Αριθμός μεταφοράς"
					},
					"institution_number": {
						"label": "Αριθμός ιδρύματος"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Μπορείτε να επεξεργαστείτε τα στοιχεία του τραπεζικού λογαριασμού μετά την ολοκλήρωση της ενσωμάτωσής σας"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Νομική επωνυμία της εταιρείας"
					},
					"country": {
						"label": "Χώρα"
					},
					"registrationId": {
						"label": {
							"default": "Αριθμός εγγραφής",
							"AT": "Αριθμός εγγραφής",
							"AU": "ACN",
							"CA": "Αριθμός επιχείρησης",
							"ES": "NIF/NIE/DNI εταιρείας",
							"GB": "Αριθμός οργανισμού",
							"GR": "Αριθμός Γ.Ε.ΜΗ.",
							"US": "Αριθμός αναγνώρισης εργοδότη"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Δικαστήριο εγγραφής"
					},
					"goodsCategory": {
						"label": "Κατηγορία αγαθών"
					},
					"registered": {
						"label": {
							"default": "Εγγεγραμμένη εταιρεία",
							"AU": "Η εταιρεία διαθέτει ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Η εταιρεία υπόκειται σε ΦΠΑ",
							"AU": "Η εταιρεία υπόκειται σε ABN",
							"ES": "Η εταιρεία διαθέτει NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "ΑΦΜ",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI εταιρείας"
						}
					},
					"storeName": {
						"label": "Όνομα καταστήματος"
					},
					"website": {
						"label": "Ιστότοπος"
					},
					"email": {
						"label": "Διεύθυνση email της υποστήριξης πελατών"
					},
					"entityType": {
						"label": "Τύπος οντότητας"
					},
					"toc_data": {
						"label": "Όροι και προϋποθέσεις",
						"toc_approval_text": {
							"before_link": "Οι",
							"link_text": "όροι & προϋποθέσεις",
							"after_link": "που αποδεχθήκατε στις {date}",
							"merchant_agreement": {
								"before_link": "Η",
								"link_text": "Συμφωνία Εμπόρου",
								"after_link": "που αποδεχθήκατε στις {date}"
							},
							"pricing_annex": {
								"before_link": "Το",
								"link_text": "Παράρτημα Τιμολόγησης",
								"after_link": "που αποδεχθήκατε στις {date}"
							}
						}
					},
					"companyName": {
						"label": "Όνομα συνεταιρισμού"
					},
					"registeredCompanyName": {
						"label": "Επωνυμία εταιρείας"
					},
					"address": {
						"label": "Διεύθυνση"
					},
					"operatingAddress": {
						"label": "Λειτουργική διεύθυνση"
					},
					"organizationEntityType": {
						"label": "Φορολογική κατάταξη"
					}
				},
				"api_key_dialog": {
					"title": "Δημιουργήθηκαν διαπιστευτήρια Klarna API",
					"subtitle": "Τα διαπιστευτήρια θα εμφανιστούν μόνο μία φορά. Κάντε κλικ στο κουμπί παρακάτω για να κατεβάσετε τα διαπιστευτήριά σας πριν κλείσετε αυτό το παράθυρο.",
					"key_box": {
						"username": {
							"label": "Όνομα χρήστη Klarna API"
						},
						"password": {
							"label": "Κωδικός πρόσβασης Klarna API"
						},
						"file_name": "Διαπιστευτήρια_Klarna"
					},
					"buttons": {
						"download": "Λήψη ως .txt"
					}
				},
				"platform_instructions": {
					"step": "Βήμα {current}/{max}",
					"next": "Επόμενο",
					"back": "Επιστροφή",
					"shopify": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωσή σας στο Shopify, ακολουθήστε τον"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						},
						{
							"title": "Εγκαταστήστε την Klarna στο κατάστημα Shopify",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στον"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Οδηγός εγκατάστασης της Μεθόδου πληρωμής Klarna στο Shopify."
									}
								],
								[
									{
										"text": "Ακολουθήστε τις οδηγίες εκεί για να ολοκληρώσετε την ενσωμάτωσή σας."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωσή σας στο Shopify, ακολουθήστε τον"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωσή σας στο Shopify, ακολουθήστε τον"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna για το Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Για να μπορέσετε να εγκαταστήσετε το πρόσθετο Klarna, χρειάζεστε ένα λειτουργικό σύστημα Plentymarkets CERES. Το"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Πρόσθετο Ceres"
									},
									{
										"text": "είναι διαθέσιμο για λήψη στο plentyMarketplace. Από εκεί, ανακατευθύνεστε επίσης στις"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "οδηγίες εγκατάστασης."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση της Klarna με την Plentymarkets Ceres, ακολουθήστε"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "αυτόν τον σύνδεσμο."
									}
								]
							]
						},
						{
							"title": "Εγκατάσταση & Ρύθμιση",
							"step_instructions": [
								[
									{
										"text": "Η εγκατάσταση του Πρόσθετου Klarna γίνεται μέσω του"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Ανακατευθύνεστε επίσης στο plentyMarketplace από το παρασκήνιο του συστήματος plentymarkets. Οδηγίες"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "σχετικά με την εγκατάσταση των προσθέτων στο plentymarkets"
									},
									{
										"text": "μπορείτε να βρείτε στο plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση της Klarna με την Plentymarkets Ceres, ακολουθήστε"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "αυτόν τον σύνδεσμο."
									}
								]
							]
						},
						{
							"title": "Διαμόρφωση προσθέτου",
							"step_instructions": [
								[
									{
										"text": "Το πρόσθετο διαμορφώνεται απευθείας στις αντίστοιχες ρυθμίσεις. Κάνοντας κλικ στη γραμμή του"
									},
									{
										"bold": "προσθέτου Klarna,"
									},
									{
										"text": "ανοίγει η σελίδα διαμόρφωσης."
									}
								],
								[
									{
										"text": "Η διαμόρφωση χωρίζεται σε δύο τομείς:"
									},
									{
										"list": [
											[
												{
													"bold": "Επαλήθευση:"
												},
												{
													"text": "Η λειτουργία χρησιμοποιείται για να καθοριστεί εάν είναι δοκιμαστικό ή παραγωγικό. Ανάλογα με τη λειτουργία, το όνομα χρήστη και ο κωδικός πρόσβασης πρέπει να αποθηκευτούν."
												}
											],
											[
												{
													"bold": "Γενικές ρυθμίσεις:"
												},
												{
													"text": "Εδώ επιλέγετε το προϊόν που θέλετε να χρησιμοποιήσετε. Είτε τις ατομικές μεθόδους πληρωμής της Klarna (Πληρωμή Klarna), είτε ολόκληρη τη σελίδα πληρωμής Klarna (Klarna Checkout). Κατά την επιλογή των πληρωμών, η σελίδα πληρωμής στο κατάστημα θα αντικατασταθεί αυτόματα από το Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Δεν χρειάζονται περαιτέρω ρυθμίσεις και αν απενεργοποιήσετε το πρόσθετο, αυτό θα αναιρεθεί."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση της Klarna με την Plentymarkets Ceres, ακολουθήστε"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "αυτόν τον σύνδεσμο."
									}
								]
							]
						},
						{
							"title": "Τελικές πληροφορίες",
							"step_instructions": [
								[
									{
										"text": "Ισχύουν οι ακόλουθες απαιτήσεις συστήματος:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets Έκδοση 7"
											},
											{
												"text": "Εγκατάσταση Ceres και Πρόσθετων IO"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση της Klarna με την Plentymarkets Ceres, ακολουθήστε"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "αυτόν τον σύνδεσμο."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Ενεργοποιήστε το πρόσθετο Klarna Checkout για το WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, βεβαιωθείτε ότι έχετε εγκαταστήσει το πρόσθετο Klarna Checkout για το WooCommerce. Εάν δεν έχετε ακόμα το πρόσθετο, μεταβείτε σε"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να το λάβετε."
									}
								],
								[
									{
										"text": "Μόλις αποκτήσετε τα διαπιστευτήριά σας Klarna API, μεταβείτε στις «Ρυθμίσεις» και, στη συνέχεια, στην «Ολοκλήρωση αγορών» στον πίνακα WooCommerce. Επιλέξτε Klarna Checkout."
									}
								],
								[
									{
										"text": "Ενεργοποιήστε το Klarna Checkout επιλέγοντας το πλαίσιο ελέγχου «Ενεργοποίηση Klarna Checkout»."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ανατρέξτε στον δικό τους"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "εκτεταμένο οδηγό."
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε τις ρυθμίσεις σας",
							"step_instructions": [
								[
									{
										"text": "Διαμορφώστε τις ρυθμίσεις για το Klarna Checkout. Σημειώστε ότι το πεδίο «Τίτλος» χρησιμοποιείται για τον καθορισμό του τίτλου για τη μέθοδο πληρωμής που εμφανίζεται στα email της ολοκλήρωσης αγοράς και της επιβεβαίωσης παραγγελίας (δηλαδή, στο Klarna Checkout)."
									}
								],
								[
									{
										"text": "Επιλέξτε το πλαίσιο ελέγχου «Λειτουργία δοκιμής» εάν θέλετε να δημιουργήσετε παραγγελίες χρησιμοποιώντας δοκιμαστικά διαπιστευτήρια."
									}
								],
								[
									{
										"text": "Ήρθε η ώρα να συμπληρώσετε τις ρυθμίσεις χώρας. Εάν κατοικείτε στην Ευρώπη, κάντε κλικ στο «ανάπτυξη» στην ενότητα Ευρώπη. Εάν κατοικείτε στις ΗΠΑ, κάντε κλικ στο «ανάπτυξη» στην ενότητα Ηνωμένες Πολιτείες Αμερικής."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ανατρέξτε στον δικό τους"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "εκτεταμένο οδηγό."
									}
								]
							]
						},
						{
							"title": "Προσθέστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Προσθέστε τα διαπιστευτήριά σας Klarna API στα πεδία «Όνομα χρήστη Klarna API» και «Κωδικός πρόσβασης Klarna API»."
									}
								],
								[
									{
										"text": "Αποθηκεύστε τις ρυθμίσεις σας."
									}
								],
								[
									{
										"text": "Το τελευταίο πράγμα που πρέπει να κάνετε είναι να ορίσετε το Klarna Checkout ως την προεπιλεγμένη μέθοδο πληρωμής. Μεταβείτε στις «Ρυθμίσεις» και, στη συνέχεια, στις «Πληρωμές» στον πίνακα WooCommerce. Βρείτε την ενότητα «Μέθοδος πληρωμής» και ορίστε το Klarna Checkout ως την προεπιλεγμένη μέθοδο πληρωμής."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ανατρέξτε στον δικό τους"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "εκτεταμένο οδηγό."
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Βεβαιωθείτε ότι έχετε ενεργοποιήσει"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "όμορφους μόνιμους συνδέσμους"
									},
									{
										"text": "στην εγκατάσταση του WordPress. Διαφορετικά, οι ανακλήσεις από την Klarna προς το κατάστημά σας δεν θα λειτουργούν και οι παραγγελίες δεν θα ενημερώνονται με τη σωστή κατάσταση/πληροφορίες της παραγγελίας."
									}
								],
								[
									{
										"text": "Εάν θέλετε να χειριστείτε την παραγγελία σας Klarna απευθείας στο WooCommerce, πρέπει να εγκαταστήσετε το"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "πρόσθετο Διαχείρισης Παραγγελιών"
									},
									{
										"text": "Klarna."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι το Klarna Checkout εμφανίζεται όπως αναμένεται, προσθέτοντας ένα προϊόν στο καλάθι σας και μεταβαίνοντας στη σελίδα πληρωμής (μην κάνετε πραγματικά την παραγγελία)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ανατρέξτε στον δικό τους"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "εκτεταμένο οδηγό."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ακολουθήστε τον"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Εγκαταστήστε και ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna",
							"step_instructions": [
								[
									{
										"text": "Εγκαταστήστε το"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Πρόσθετο της Μεθόδου πληρωμής Klarna για το WooCommerce."
									}
								],
								[
									{
										"text": "Στον λογαριασμό σας WooCommerce, μεταβείτε στις"
									},
									{
										"bold": "Ρυθμίσεις → Πληρωμές → Μέθοδος πληρωμής Klarna."
									}
								],
								[
									{
										"text": "Ενεργοποιήστε τη Μέθοδο πληρωμής Klarna επιλέγοντας το πλαίσιο ελέγχου «Ενεργοποίηση μεθόδου πληρωμής Klarna»."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ακολουθήστε τον"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε τις ρυθμίσεις της χώρας σας",
							"step_instructions": [
								[
									{
										"text": "Συμπληρώστε τις ρυθμίσεις χώρας. Κάθε χώρα Klarna έχει το δικό της σύνολο ρυθμίσεων για τη συγκεκριμένη χώρα. Προσθέτοντας διαπιστευτήρια εμπόρου σε μια συγκεκριμένη χώρα, ενεργοποιείτε επίσης τη Μέθοδο πληρωμής Klarna ως διαθέσιμη μέθοδο πληρωμής για τη συγκεκριμένη χώρα."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ακολουθήστε τον"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Καταχωρίστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Καταχωρίστε τα διαπιστευτήριά σας Klarna API στα πεδία «Όνομα χρήστη Klarna API» και «Κωδικός πρόσβασης Klarna API»."
									}
								],
								[
									{
										"text": "Αποθηκεύστε τις ρυθμίσεις σας."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ακολουθήστε τον"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο WooCommerce, ακολουθήστε τον"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Διαμορφώστε τις ρυθμίσεις σας για να ενεργοποιήσετε το Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, βεβαιωθείτε ότι έχετε εγκαταστήσει τη μονάδα Klarna Checkout για το Magento. Εάν δεν έχετε ήδη τη μονάδα, μεταβείτε σε"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να τη λάβετε."
									}
								],
								[
									{
										"text": "Μόλις αποκτήσετε τα διαπιστευτήρια Klarna API, ανοίξτε τον πίνακα Magento. Μεταβείτε στο «Καταστήματα» → «Διαμόρφωση» → «Πωλήσεις» → «Μέθοδος Πληρωμής» → «Klarna» → «Klarna API»."
									}
								],
								[
									{
										"text": "Αναπτύξτε την ενότητα «Klarna API» και συμπληρώστε την έκδοση API, το όνομα χρήστη Klarna API και τον κωδικό πρόσβασης Klarna API. Βεβαιωθείτε ότι έχετε απενεργοποιήσει τη δοκιμαστική λειτουργία εάν είστε έτοιμοι να ενεργοποιήσετε τον ιστότοπό σας."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση στο Magento, ανατρέξτε στον δικό τους"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "εκτεταμένο οδηγό."
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Όταν διαμορφωθούν οι ρυθμίσεις σας, πρέπει να ελέγξετε ότι το Klarna Checkout είναι ενεργοποιημένο στις επιλογές ολοκλήρωσης αγορών."
									}
								],
								[
									{
										"text": "Μεταβείτε στα «Καταστήματα» → «Διαμόρφωση» → «Πωλήσεις» → «Ολοκλήρωση αγορών» → «Επιλογές Klarna Checkout», στον πίνακα Magento."
									}
								],
								[
									{
										"text": "Το Klarna Checkout θα πρέπει να είναι ενεργοποιημένο ως προεπιλογή. Εάν δεν είναι, αλλάξτε το σε"
									},
									{
										"bold": "«Ενεργοποίηση»"
									},
									{
										"text": "στο «Ενεργοποίηση Klarna Checkout»."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							]
						},
						{
							"title": "Εγκαταστήστε και ενεργοποιήστε τη μονάδα Μεθόδου πληρωμής Klarna",
							"step_instructions": [
								[
									{
										"text": "Επισκεφθείτε την ενότητα"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "«Ρύθμιση της Klarna» στον Οδηγό χρήσης Magento"
									},
									{
										"text": "και ακολουθήστε τις οδηγίες εκεί για να εγκαταστήσετε και να διαμορφώσετε τη μονάδα στον λογαριασμό σας Magento."
									}
								]
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, βεβαιωθείτε ότι έχετε εγκαταστήσει το πρόσθετο της Μεθόδου πληρωμής Klarna για το Shopware. Εάν δεν έχετε ακόμα το πρόσθετο, μεταβείτε στο"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να το λάβετε."
									}
								],
								[
									{
										"text": "Σε ένα επόμενο βήμα, πρέπει να εισαγάγετε το πρόσθετο της Μεθόδου πληρωμής Klarna στο Shopware κάνοντας κλικ"
									},
									{
										"bold": "Διαμόρφωση → Διαχείριση Προσθέτων → Εγκατάσταση → Μεταφόρτωση προσθέτου."
									},
									{
										"text": "Κάντε κλικ στο"
									},
									{
										"bold": "Επιλογή"
									},
									{
										"text": "και επιλέξτε το αρχείο ZIP για το πρόσθετο της Μεθόδου πληρωμής Klarna. Επιβεβαιώστε κάνοντας κλικ στο"
									},
									{
										"bold": "«Μεταφόρτωση προσθέτου»."
									},
									{
										"text": "Το πρόσθετο μπορεί πλέον να βρεθεί στη διαχείριση προσθέτων."
									}
								],
								[
									{
										"text": "Εγκαταστήστε το πρόσθετο κάνοντας κλικ στο"
									},
									{
										"bold": "πράσινο εικονίδιο"
									},
									{
										"text": "+."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε το πρόσθετο της Μεθόδου πληρωμής Klarna για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στις ρυθμίσεις του προσθέτου κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Βασικές ρυθμίσεις → Αναζήτηση για τη Μέθοδο πληρωμής Klarna"
									}
								],
								[
									{
										"text": "Καταχωρίστε τα διαπιστευτήριά σας Klarna API στα πεδία"
									},
									{
										"bold": "«Όνομα χρήστη Klarna API»"
									},
									{
										"text": "και"
									},
									{
										"bold": "«Κωδικός πρόσβασης Klarna API»"
									},
									{
										"text": "και αποθηκεύστε τις αλλαγές σας."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι χρησιμοποιείτε τη ζωντανή λειτουργία και τα διαπιστευτήριά σας Klarna API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε την/τις πύλη(ες) εισόδου της Μεθόδου πληρωμής Klarna",
							"step_instructions": [
								[
									{
										"text": "Πριν χρησιμοποιήσετε την Klarna, πρέπει να ενεργοποιήσετε την/τις πύλη(ες) εισόδου της Μεθόδου πληρωμής Klarna. Μπορείτε να τις βρείτε κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Μέθοδος πληρωμής"
									}
								],
								[
									{
										"text": "Ως προεπιλογή έχουν εγκατασταθεί όλες οι πύλες εισόδου της Μεθόδου πληρωμής Klarna. Ανοίξτε τις πύλες εισόδου της Μεθόδου πληρωμής Klarna στις οποίες εγγραφήκατε και ενεργοποιήστε τις επιλέγοντας το"
									},
									{
										"bold": "πλαίσιο ελέγχου"
									},
									{
										"text": "«Ενεργοποίηση». Αποθηκεύστε τις αλλαγές σας."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Προσαρμόστε το κόστος αποστολής σας",
							"step_instructions": [
								[
									{
										"text": "Προσαρμόστε το κόστος αποστολής σας για την/τις πύλη(ες) εισόδου της Μεθόδου πληρωμής Klarna κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Κόστος αποστολής"
									}
								],
								[
									{
										"text": "Επιλέξτε τις μεθόδους αποστολής που θα πρέπει να είναι διαθέσιμες για την Klarna κάνοντας κλικ στο"
									},
									{
										"bold": "εικονίδιο με το μολύβι."
									}
								],
								[
									{
										"text": "Επιλέξτε την καρτέλα επιλογής μεθόδου πληρωμής και μετακινήστε την/τις πύλη(ες) της Μεθόδου πληρωμής Klarna από"
									},
									{
										"bold": "«Διαθέσιμο»"
									},
									{
										"text": "σε"
									},
									{
										"bold": "«Επιλεγμένο»."
									},
									{
										"text": "Αποθηκεύστε τις ρυθμίσεις σας"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna",
							"step_instructions": [
								[
									{
										"text": "Στη συνέχεια, πρέπει να ενεργοποιήσετε το πρόσθετο της Μεθόδου πληρωμής Klarna. Κάντε κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Διαχείριση προσθέτου → Εγκατάσταση"
									},
									{
										"text": "για να μεταβείτε στη διαχείριση προσθέτου."
									}
								],
								[
									{
										"text": "Ενεργοποιήστε το πρόσθετο κάνοντας κλικ στο"
									},
									{
										"bold": "εικονίδιο του"
									},
									{
										"text": "κόκκινου «Χ»."
									}
								],
								[
									{
										"text": "Θα ερωτηθείτε εάν θέλετε να αδειάσετε την μνήμη cache. Κάντε κλικ στο"
									},
									{
										"bold": "Ναι."
									},
									{
										"text": "Σημειώστε ότι πρέπει να διαγράψετε την μνήμη cache και να δημιουργήσετε θέματα κάθε φορά που αλλάζετε κάτι στις ρυθμίσεις της μονάδας ή στις μεθόδους πληρωμής από την Klarna."
									}
								],
								[
									{
										"text": "Για να ενεργοποιήσετε πλήρως το πρόσθετο της Μεθόδου πληρωμής Klarna, το θέμα του καταστήματος πρέπει να δημιουργηθεί εκ νέου. Κάντε κλικ στο"
									},
									{
										"bold": "«Δημιουργία θεμάτων»"
									},
									{
										"text": "όταν σας ζητηθεί."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Για να αποφύγετε τυχόν σφάλματα στρογγυλοποίησης, βεβαιωθείτε ότι έχετε εγκαταστήσει την επέκταση PHP bcmath στον διακομιστή σας. Βρείτε τον οδηγό"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "εδώ"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Επανεκκινήστε το παρασκήνιό σας μία φορά για να βεβαιωθείτε ότι όλες οι προσαρμογές είναι διαθέσιμες στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι τα προϊόντα Πληρωμών Klarna εμφανίζονται όπως αναμένεται, προσθέτοντας ένα προϊόν στο καλάθι σας, επιλέγοντας την Klarna ως μέθοδο πληρωμής και προχωρώντας στη σελίδα πληρωμής (μην κάνετε πραγματικά την παραγγελία)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Ενεργοποιήστε το πρόσθετο Klarna Checkout για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, βεβαιωθείτε ότι έχετε εγκαταστήσει το πρόσθετο Klarna Checkout για το Shopware (Έκδοση 5.2.17 και νεότερη). Εάν δεν έχετε ακόμα το πρόσθετο, μεταβείτε σε"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να το λάβετε."
									}
								],
								[
									{
										"text": "Σε ένα επόμενο βήμα, πρέπει να εισαγάγετε το πρόσθετο Klarna Checkout στο Shopware κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Διαχείριση Προσθέτων → Εγκατάσταση → Μεταφόρτωση προσθέτου."
									},
									{
										"text": "Κάντε κλικ στο"
									},
									{
										"bold": "Επιλογή"
									},
									{
										"text": "και επιλέξτε το αρχείο ZIP του προσθέτου Klarna Checkout. Επιβεβαιώστε κάνοντας κλικ στο"
									},
									{
										"bold": "«Μεταφόρτωση προσθέτου»."
									},
									{
										"text": "Το πρόσθετο μπορεί πλέον να βρεθεί στη διαχείριση προσθέτων."
									}
								],
								[
									{
										"text": "Εγκαταστήστε το πρόσθετο κάνοντας κλικ στο"
									},
									{
										"bold": "πράσινο εικονίδιο"
									},
									{
										"text": "+."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Προσαρμόστε το πρόσθετο Klarna Checkout για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στις ρυθμίσεις του προσθέτου κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Βασικές ρυθμίσεις → Αναζήτηση για το Klarna Checkout"
									}
								],
								[
									{
										"text": "Καταχωρίστε τα διαπιστευτήριά σας Klarna API στα πεδία"
									},
									{
										"bold": "«Όνομα χρήστη Klarna API»"
									},
									{
										"text": "και"
									},
									{
										"bold": "«Κωδικός πρόσβασης Klarna API»"
									},
									{
										"text": "και αποθηκεύστε τις αλλαγές σας."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι χρησιμοποιείτε τη ζωντανή λειτουργία και τα διαπιστευτήριά σας Klarna API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε την πύλη εισόδου του Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Πριν χρησιμοποιήσετε την Klarna, πρέπει να ενεργοποιήσετε την πύλη εισόδου Πληρωμών Klarna. Μπορείτε να τις βρείτε κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Μέθοδος πληρωμής"
									}
								],
								[
									{
										"text": "Ανοίξτε την πύλη εισόδου Klarna Checkout και ενεργοποιήστε την επιλέγοντας το"
									},
									{
										"bold": "πλαίσιο ελέγχου"
									},
									{
										"text": "«Ενεργοποίηση». Αποθηκεύστε τις αλλαγές σας."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Προσαρμόστε το κόστος αποστολής σας",
							"step_instructions": [
								[
									{
										"text": "Προσαρμόστε το κόστος αποστολής σας για το Klarna Checkout κάνοντας κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Κόστος αποστολής"
									}
								],
								[
									{
										"text": "Επιλέξτε τις μεθόδους αποστολής που θα πρέπει να είναι διαθέσιμες για την Klarna κάνοντας κλικ στο"
									},
									{
										"bold": "εικονίδιο με το μολύβι."
									}
								],
								[
									{
										"text": "Επιλέξτε την καρτέλα επιλογής μεθόδου πληρωμής και μετακινήστε το Klarna Checkout από"
									},
									{
										"bold": "«Διαθέσιμο»"
									},
									{
										"text": "σε"
									},
									{
										"bold": "«Επιλεγμένο»."
									},
									{
										"text": "Αποθηκεύστε τις ρυθμίσεις σας"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε το πρόσθετο του Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Στη συνέχεια, πρέπει να ενεργοποιήσετε το πρόσθετο του Klarna Checkout. Κάντε κλικ στο"
									},
									{
										"bold": "Διαμόρφωση → Διαχείριση προσθέτου → Εγκατάσταση"
									},
									{
										"text": "για να μεταβείτε στη διαχείριση προσθέτου."
									}
								],
								[
									{
										"text": "Ενεργοποιήστε το πρόσθετο κάνοντας κλικ στο"
									},
									{
										"bold": "εικονίδιο του"
									},
									{
										"text": "κόκκινου Χ."
									}
								],
								[
									{
										"text": "Θα ερωτηθείτε εάν θέλετε να αδειάσετε την μνήμη cache. Κάντε κλικ στο"
									},
									{
										"bold": "Ναι."
									}
								],
								[
									{
										"text": "Για να ενεργοποιήσετε πλήρως το πρόσθετο του Klarna Checkout, το θέμα του καταστήματος πρέπει να δημιουργηθεί εκ νέου. Κάντε κλικ στο"
									},
									{
										"bold": "«Δημιουργία θεμάτων»"
									},
									{
										"text": "όταν σας ζητηθεί."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Για να αποφύγετε τυχόν σφάλματα στρογγυλοποίησης, βεβαιωθείτε ότι έχετε εγκαταστήσει την επέκταση PHP bcmath στον διακομιστή σας. Βρείτε τον οδηγό"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "εδώ"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι η «Πρόσθετη γραμμή διεύθυνσης 1» και η «Πρόσθετη γραμμή διεύθυνσης 2» δεν έχουν επισημανθεί ως υποχρεωτικές."
									}
								],
								[
									{
										"text": "Επανεκκινήστε το παρασκήνιό σας μία φορά για να βεβαιωθείτε ότι όλες οι προσαρμογές είναι διαθέσιμες στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι το Klarna Checkout εμφανίζεται όπως αναμένεται, προσθέτοντας ένα προϊόν στο καλάθι σας, επιλέγοντας την Klarna ως μέθοδο πληρωμής και προχωρώντας στη σελίδα πληρωμής (μην κάνετε πραγματικά την παραγγελία)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Για να μπορέσετε να εγκαταστήσετε το πρόσθετο Klarna, χρειάζεστε ένα λειτουργικό σύστημα Shopware 6. Μπορείτε να βρείτε τις οδηγίες εγκατάστασης"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "εδώ."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Εγκατάσταση & Ρύθμιση. Υπάρχουν διάφοροι τρόποι εγκατάστασης του προσθέτου Klarna.",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, εκτελέστε το Wizard."
									}
								],
								[
									{
										"text": "Εγκατάσταση μέσω Administration."
									}
								],
								[
									{
										"text": "Εγκατάσταση μέσω απευθείας λήψης από το Community Store."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε το πρόσθετο της Μεθόδου πληρωμής Klarna για το Shopware",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στην επισκόπηση των προσθέτων σας στο Shopware Administration. Μπορείτε να το προσπελάσετε μέσω"
									},
									{
										"bold": "Ρυθμίσεις > Σύστημα > Πρόσθετα."
									}
								],
								[
									{
										"text": "Επιλέξτε"
									},
									{
										"bold": "«Εγκατάσταση»"
									},
									{
										"text": "από το μενού περιβάλλοντος (\"...\"). Θα λάβετε ένα μήνυμα επιτυχίας από το Shopware ότι το πρόσθετο έχει εγκατασταθεί με επιτυχία."
									}
								],
								[
									{
										"text": "Για λόγους ασφαλείας, το πρόσθετο είναι πλέον εγκατεστημένο αλλά δεν έχει ακόμη ενεργοποιηθεί. Πρέπει πρώτα να το βελτιστοποιήσετε με τα δεδομένα πρόσβασής σας και τις μεμονωμένες ρυθμίσεις."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Wizard",
							"step_instructions": [
								[
									{
										"text": "Μόλις ενεργοποιηθεί το πρόσθετο, μεταβείτε στο"
									},
									{
										"bold": "μενού περιβάλλοντος (\"...\") > wizard.",
										"text": "Στη συνέχεια θα προωθηθείτε στη ρουτίνα."
									}
								],
								[
									{
										"text": "Η ρουτίνα θα σας καθοδηγήσει σε όλη τη διαδικασία εγκατάστασης και σας επιτρέπει να εγγραφείτε στην Klarna εάν δεν έχετε ακόμη λογαριασμό αντιπροσώπου."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Διαμόρφωση προσθέτου",
							"step_instructions": [
								[
									{
										"bold": "Κανάλια πωλήσεων."
									},
									{
										"text": "Εδώ καθορίζετε εάν οι ακόλουθες ρυθμίσεις για «όλα τα κανάλια πωλήσεων» θα ισχύουν, ή αν θα πρέπει να ισχύουν μόνο για ορισμένα μεμονωμένα κανάλια πωλήσεων."
									}
								],
								[
									{
										"bold": "Ρυθμίσεις API."
									},
									{
										"text": "Όνομα χρήστη API και κωδικός πρόσβασης API: Καταχωρίστε τα δεδομένα σας πρόσβασης στο API εδώ για τη ζωντανή και δοκιμαστική λειτουργία στις κατάλληλες ενότητες."
									}
								],
								[
									{
										"text": "Μπορείτε να δοκιμάσετε τα διαπιστευτήριά σας Klarna API κάνοντας κλικ στο κουμπί"
									},
									{
										"bold": "«Δοκιμή διαπιστευτηρίων API»",
										"text": "που βρίσκεται στην επικεφαλίδα. Στη συνέχεια, θα λάβετε ένα μήνυμα επιτυχίας ή μια ένδειξη ότι τα δεδομένα φαίνεται να είναι λανθασμένα."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Ενεργοποίηση/απενεργοποίηση προσθέτου",
							"step_instructions": [
								[
									{
										"text": "Εάν θέλετε να ενεργοποιήσετε/απενεργοποιήσετε το πρόσθετο της Μεθόδου πληρωμής Klarna ή απλά θέλετε να δείτε την τρέχουσα κατάσταση ενεργοποίησης, μεταβείτε στο Shopware Admin και επιλέξτε"
									},
									{
										"bold": "Ρυθμίσεις > Σύστημα > Πρόσθετα."
									}
								],
								[
									{
										"text": "Εδώ μπορείτε να βρείτε την τρέχουσα κατάσταση στον πίνακα"
									},
									{
										"bold": "«Τα πρόσθετά μου»."
									}
								],
								[
									{
										"text": "Η κατάσταση μπορεί να αλλάξει κάνοντας κλικ στο Slider."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Για να αποφύγετε τυχόν σφάλματα στρογγυλοποίησης, βεβαιωθείτε ότι έχετε την έκδοση PHP >= 7.2."
									}
								],
								[
									{
										"text": "Ολοκληρωμένη εγκατάσταση του Shopware"
									},
									{
										"bold": "(Storefront + Administration, όχι headless)."
									}
								],
								[
									{
										"text": "Το σύστημα πρέπει να είναι προσβάσιμο από έξω για την ενημέρωση της κατάστασης πληρωμής."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του Shopware, ανατρέξτε στον δικό μας"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "εκτεταμένο οδηγό. (Στα Γερμανικά)"
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του 3dcart, ακολουθήστε τον"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε τη Μέθοδο πληρωμής Klarna στην Online Διαχείριση Καταστήματος",
							"step_instructions": [
								[
									{
										"text": "Συνδεθείτε με την"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "Online Διαχείριση Καταστήματος 3dcart"
									},
									{
										"text": "και μεταβείτε στις"
									},
									{
										"bold": "Ρυθμίσεις → Πληρωμές."
									}
								],
								[
									{
										"text": "Στη σελίδα πληρωμών, κάντε κλικ στο"
									},
									{
										"bold": "κουμπί"
									},
									{
										"text": "«Επιλογή μεθόδων πληρωμής»."
									}
								],
								[
									{
										"text": "Θα δείτε μια λίστα με προεγκατεστημένες μονάδες. Εντοπίστε τη μονάδα Klarna και ενεργοποιήστε την χρησιμοποιώντας τον διακόπτη εναλλαγής."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του 3dcart, ακολουθήστε τον"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Καταχωρίστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Μόλις ενεργοποιήσετε τη μονάδα, καταχωρίστε το όνομα χρήστη Klarna API (UID) στο παρεχόμενο πεδίο. Θα το βρείτε στο αρχείο διαπιστευτηρίων που κατεβάσατε νωρίτερα."
									}
								],
								[
									{
										"text": "Στη συνέχεια, κάντε κλικ στον"
									},
									{
										"bold": "σύνδεσμο «Αλλαγή κωδικού πρόσβασης»"
									},
									{
										"text": "και καταχωρίστε τον κωδικό πρόσβασης Klarna API στο πεδίο του κωδικού πρόσβασης."
									}
								],
								[
									{
										"text": "Στην"
									},
									{
										"bold": "«Χώρα Γλώσσας»,"
									},
									{
										"text": "επιλέξτε τη γλώσσα της χώρας που θα χρησιμοποιηθεί για τις επιλογές πληρωμής Klarna στο κατάστημα."
									}
								],
								[
									{
										"text": "Πάνω από το πεδίο ονόματος χρήστη υπάρχει ένα πλαίσιο ελέγχου με την ένδειξη"
									},
									{
										"bold": "«Λειτουργία δοκιμής»."
									},
									{
										"text": "Επιλέξτε αυτήν την επιλογή για να ενεργοποιήσετε τη λειτουργία δοκιμής, επιτρέποντάς σας να κάνετε παραγγελίες χωρίς να επιβαρύνεστε με χρεώσεις ή ενέργειες πληρωμής κατά τη δοκιμή της μονάδας."
									}
								],
								[
									{
										"text": "Μόλις ολοκληρώσετε τη διαμόρφωση των ρυθμίσεών σας, κάντε κλικ στο «Αποθήκευση» επάνω δεξιά."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του 3dcart, ακολουθήστε τον"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								],
								[
									{
										"text": "Εάν ενεργοποιήσατε τη «Λειτουργία δοκιμής» στο προηγούμενο βήμα, επιστρέψτε στην επιλογή «Ενεργό» για να την αποεπιλέξετε και να κάνετε αποθήκευση πριν από την έναρξη λειτουργίας του καταστήματός σας, ώστε οι πραγματικές σας παραγγελίες να περάσουν σωστά."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του 3dcart, ακολουθήστε τον"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "εκτεταμένο οδηγό ενσωμάτωσης."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του BigCommerce, ακολουθήστε τον"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						},
						{
							"title": "Διαμορφώστε τις ρυθμίσεις σας για το BigCommerce",
							"step_instructions": [
								[
									{
										"text": "Στο BigCommerce, μεταβείτε στο"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Ρύθμιση καταστήματος › Πληρωμές,"
									},
									{
										"text": "και αναπτύξτε την ενότητα Online Μέθοδοι Πληρωμής. Στη συνέχεια, κάντε κλικ στο"
									},
									{
										"bold": "«Ρύθμιση»"
									},
									{
										"text": "δίπλα στη Μέθοδο πληρωμής Klarna."
									}
								],
								[
									{
										"text": "Θα μεταφερθείτε στην καρτέλα «Ρυθμίσεις μεθόδου πληρωμής Klarna». Καταχωρίστε το αρχείο διαπιστευτηρίων API που αποθηκεύσατε στην προηγούμενη ενότητα και αντιγράψτε το όνομα χρήστη και τον κωδικό πρόσβασης στα αντίστοιχα πεδία τους."
									}
								],
								[
									{
										"text": "Αποθηκεύστε τις αλλαγές σας όταν τελειώσετε."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του BigCommerce, ακολουθήστε τον"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								]
							],
							"alternate": [
								{
									"text": "Για πιο λεπτομερείς πληροφορίες σχετικά με την ενσωμάτωση του BigCommerce, ακολουθήστε τον"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "εκτεταμένο οδηγό ενσωμάτωσης."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Ενεργοποιήστε τη μονάδα Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Πρώτα απ’ όλα, βεβαιωθείτε ότι έχετε εγκαταστήσει την επίσημη μονάδα Klarna για το Prestashop. Εάν δεν την έχετε ακόμα, μεταβείτε σε"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να τη λάβετε."
									}
								],
								[
									{
										"text": "Δυστυχώς, από την 1η Ιανουαρίου 2023, αυτά τα plug-in που αναπτύχθηκαν και ανήκουν στην Prestasworks A.B (SI) δεν θα διανέμονται πλέον δωρεάν. Αν ενδιαφέρεστε για την Klarna, μπορείτε να αγοράσετε το plug-in ή να περιμένετε τα plug-in που ανήκουν στην Klarna, τα οποία αναμένεται να κυκλοφορήσουν το 2ο τρίμηνο του 2023."
									}
								],
								[
									{
										"text": "Συνδεθείτε στη σελίδα Prestashop admin και μεταβείτε στο"
									},
									{
										"bold": "Μονάδες → Μονάδες."
									}
								],
								[
									{
										"text": "Πληκτρολογήστε «Klarna» στη γραμμή αναζήτησης για να εντοπίσετε τη μονάδα Klarna από την Prestaworks AB. Κάντε κλικ στο"
									},
									{
										"bold": "«Διαμόρφωση»."
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε τις ρυθμίσεις της μονάδας Klarna",
							"step_instructions": [
								[
									{
										"text": "Τώρα βρίσκεστε στη σελίδα ρυθμίσεων της μονάδας. Στο επάνω μέρος των «Γενικών ρυθμίσεων», θα δείτε ένα κουμπί που ονομάζεται"
									},
									{
										"bold": "«Ενεργοποίηση KCO σε αυτό το κατάστημα»"
									},
									{
										"text": "(Klarna Checkout V3). Επιλέξτε"
									},
									{
										"bold": "Ναι."
									}
								],
								[
									{
										"text": "Κάντε κλικ στο"
									},
									{
										"bold": "«Αποθήκευση»"
									},
									{
										"text": "για να αποθηκεύσετε τις ρυθμίσεις σας."
									}
								],
								[
									{
										"text": "Τώρα, κάντε κλικ στη χώρα πωλήσεών σας στο μενού στα αριστερά και καταχωρίστε τα διαπιστευτήριά σας Klarna API στα πεδία"
									},
									{
										"bold": "«Όνομα χρήστη Klarna API»"
									},
									{
										"text": "και"
									},
									{
										"bold": "«Κωδικός πρόσβασης Klarna API»."
									}
								],
								[
									{
										"text": "Κάντε κλικ στο"
									},
									{
										"bold": "«Αποθήκευση»."
									}
								]
							]
						},
						{
							"title": "Τελικά βήματα",
							"step_instructions": [
								[
									{
										"text": "Ελέγξτε ότι η λειτουργία δοκιμής είναι απενεργοποιημένη εάν είστε έτοιμοι να θέσετε σε λειτουργία τον ιστότοπό σας. Μπορείτε να το κάνετε αυτό στην καρτέλα"
									},
									{
										"bold": "«Κοινές ρυθμίσεις»."
									},
									{
										"text": "Το κουμπί"
									},
									{
										"bold": "«Testdrive»"
									},
									{
										"text": "πρέπει να ρυθμιστεί σε"
									},
									{
										"bold": "«Όχι»."
									}
								],
								[
									{
										"text": "Ενώ βρίσκεστε στις"
									},
									{
										"bold": "«Κοινές ρυθμίσεις»,"
									},
									{
										"text": "βεβαιωθείτε ότι έχετε διαμορφώσει τις ρυθμίσεις σας σύμφωνα με τον τρόπο που θέλετε να χειρίζεστε τις παραγγελίες, τις ρυθμίσεις για τις αποστολές τιμολογίων κ.λπ."
									}
								],
								[
									{
										"text": "Βεβαιωθείτε ότι το Klarna Checkout εμφανίζεται όπως αναμένεται, προσθέτοντας ένα προϊόν στο καλάθι σας και προχωρώντας στη σελίδα πληρωμής (μην κάνετε πραγματικά την παραγγελία)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							]
						},
						{
							"title": "Εγκαταστήστε και ενεργοποιήστε τη μονάδα Μεθόδου πληρωμής Klarna",
							"step_instructions": [
								[
									{
										"text": "Ανοίξτε τη"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Σελίδα οδηγιών Prestashop για τη Μέθοδο πληρωμής Klarna"
									},
									{
										"text": "και ακολουθήστε τις οδηγίες εκεί για να εγκαταστήσετε και να διαμορφώστε τη μονάδα στον λογαριασμό σας στο Prestashop."
									}
								]
							]
						},
						{
							"title": "Πραγματοποιήστε μια δοκιμαστική αγορά",
							"step_instructions": [
								[
									{
										"text": "Για να επαληθεύσετε ότι η ενσωμάτωση έχει ρυθμιστεί σωστά, κάντε μια δοκιμαστική αγορά στο κατάστημά σας."
									}
								],
								[
									{
										"text": "Μετά την πραγματοποίηση της παραγγελίας, μεταβείτε στις"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "«Παραγγελίες» στην Πύλη Εμπόρων,"
									},
									{
										"text": "βρείτε την παραγγελία σας και ακυρώστε την, για να αποφύγετε να την πληρώσετε."
									}
								],
								[
									{
										"text": "Μόλις η ενσωμάτωσή σας είναι επιτυχής, το banner στο επάνω μέρος αυτής της σελίδας θα γίνει πράσινο και θα εμφανίσει τις λέξεις «Η ενσωμάτωση ολοκληρώθηκε»."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Δημιουργήστε τα διαπιστευτήριά σας Klarna API.",
							"step_instructions": [
								[
									{
										"text": "Θα χρειαστείτε αυτά τα διαπιστευτήρια για να ενσωματώσετε την Klarna στο κατάστημά σας."
									}
								]
							]
						},
						{
							"title": "Προσθέστε την Klarna ως νέα μέθοδο πληρωμής.",
							"step_instructions": [
								[
									{
										"text": "Στον πίνακα διαχειριστή Jumpseller μεταβείτε στις Ρυθμίσεις > Πληρωμές, βρείτε την \"Klarna\" στη λίστα πλαισίου ελέγχου και κάντε κλικ στο \"Προσθήκη μεθόδου\"."
									}
								]
							]
						},
						{
							"title": "Διαμορφώστε τη νέα μέθοδο πληρωμής.",
							"step_instructions": [
								[
									{
										"text": "Στον πίνακα διαμόρφωσης της Klarna (Πίνακας διαχειριστή Jumpseller και μεταβείτε στις Ρυθμίσεις > Πληρωμές > Klarna), (i) προσθέστε τα διαπιστευτήρια Klarna API που δημιουργήθηκαν στο πρώτο βήμα, (ii) επιλέξτε τα πακέτα EMD που θέλετε/χρειάζεστε να μοιραστείτε με την Klarna, και (iii) επιλέξτε αν χρειάζεστε αυτόματη καταγραφή των παραγγελιών (η προεπιλογή είναι όχι)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Ενσωματώστε το Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Δείτε τον οδηγό ενσωμάτωσης στα"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Αγγλικά"
									},
									{
										"text": "και στα"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Ολλανδικά"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Ενσωμάτωση Shoper",
							"step_instructions": [
								[
									{
										"text": "Δείτε τον οδηγό ενσωμάτωσης στον"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "ιστότοπο Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Ενσωμάτωση Timma",
							"step_instructions": [
								[
									{
										"text": "Δείτε τον οδηγό ενσωμάτωσης στον"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "ιστότοπος Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							]
						},
						{
							"title": "Ενσωματώστε με το SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Ακολουθήστε τις οδηγίες στον"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "ιστότοπο SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Δημιουργήστε και αποθηκεύστε τα διαπιστευτήριά σας Klarna API",
							"step_instructions": [
								[
									{
										"text": "Δημιουργήστε νέα διαπιστευτήρια API και κατεβάστε το αρχείο στον υπολογιστή σας. Ανοίξτε το αρχείο και διατηρήστε το ανοιχτό, καθώς θα χρειαστείτε αυτά τα διαπιστευτήρια API στην επόμενη ενότητα."
									}
								]
							]
						},
						{
							"title": "Ενσωματώστε με το Workstand",
							"step_instructions": [
								[
									{
										"text": "Ακολουθήστε τις οδηγίες στον"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "ιστότοπο Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Διαβάστε την τεκμηρίωση για το πρόσθετό μας",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στη"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "σελίδα τεκμηρίωσης"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε τη μονάδα Klarna Checkout για το JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Βεβαιωθείτε ότι έχετε εγκαταστήσει την επίσημη επέκταση Klarna. Εάν δεν την έχετε ακόμα,"
									},
									{
										"text": "μεταβείτε στη"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να τη λάβετε."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Διαβάστε την τεκμηρίωση για το πρόσθετό μας",
							"step_instructions": [
								[
									{
										"text": "Μεταβείτε στη"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "σελίδα τεκμηρίωσης"
									}
								]
							]
						},
						{
							"title": "Ενεργοποιήστε τη μονάδα Πληρωμές Klarna για το JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Βεβαιωθείτε ότι έχετε εγκαταστήσει την επίσημη επέκταση Klarna. Εάν δεν την έχετε ακόμα,"
									},
									{
										"text": "μεταβείτε στην"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "αυτή την σελίδα"
									},
									{
										"text": "για να τη λάβετε."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Τι πρέπει να κάνετε στη συνέχεια",
							"step_instructions": [
								[
									{
										"bold": "Δημιουργήστε τα διαπιστευτήριά σας Klarna API."
									},
									{
										"text": "Χρειάζεστε αυτά τα διαπιστευτήρια για να ενσωματώσετε την Klarna στο κατάστημά σας."
									}
								],
								[
									{
										"bold": "Προσθέστε τα διαπιστευτήρια Klarna API στο σύστημα υποστήριξης για να ενεργοποιήσετε την Klarna."
									},
									{
										"text": "Ελέγξτε την"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Πύλη προγραμματιστών μας"
									},
									{
										"text": "για περισσότερη υποστήριξη."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Όνομα",
							"error": "Καταχωρίστε ένα όνομα"
						},
						"last_name": {
							"label": "Επώνυμο",
							"error": "Καταχωρίστε ένα επώνυμο"
						},
						"dateOfBirth": {
							"label": {
								"default": "Ημερομηνία γέννησης (ΗΗ/ΜΜ/ΕΕΕΕ)",
								"without_format": "Ημερομηνία γέννησης",
								"US": "Ημερομηνία γέννησης (ΜΜ/ΗΗ/ΕΕΕΕ)"
							},
							"error": "Καταχωρίστε μια έγκυρη ημερομηνία",
							"error_too_young": "Πρέπει να είστε τουλάχιστον 18 ετών για να κάνετε πωλήσεις με την Klarna"
						},
						"address": {
							"label": "Διεύθυνση κατοικίας",
							"error": "Καταχωρίστε μια διεύθυνση"
						},
						"city": {
							"label": "Πόλη",
							"error": "Καταχωρίστε μια πόλη"
						},
						"country": {
							"label": "Χώρα",
							"error": "Επιλέξτε μια χώρα"
						},
						"postal_code": {
							"label": {
								"default": "Ταχυδρομικός κώδικας",
								"US": "Ταχ. κώδικας"
							},
							"error": {
								"default": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα",
								"US": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
							}
						},
						"region": {
							"label": "Πολιτεία/περιοχή (προαιρετικό)",
							"label_summary": "Πολιτεία/περιοχή"
						},
						"state": {
							"label": "Πολιτεία",
							"error": "Καταχωρίστε μια πολιτεία"
						},
						"role_question": {
							"OWNER": "Είναι ιδιοκτήτης αυτό το άτομο;",
							"BENEFICIAL_OWNER": "Ελέγχει αυτό το άτομο περισσότερο από το 25% των μετοχών ή των δικαιωμάτων ψήφου;",
							"ULTIMATE_BENEFICIAL_OWNER": "Κατέχει ή ελέγχει αυτό το άτομο περισσότερο από το 25% των μετοχών ή των δικαιωμάτων ψήφου"
						},
						"is_person_pep": [
							{
								"text": "Είναι αυτό το άτομο ένα"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "πολιτικώς εκτεθειμένο πρόσωπο (ΠΕΠ)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "άμεση οικογένεια"
							},
							{
								"text": "ή"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "γνωστός συνεργάτης"
							},
							{
								"text": "ενός τέτοιου προσώπου;"
							}
						],
						"pep_relationship": {
							"label": "Σχέση",
							"error": "Επιλέξτε τη σχέση που έχει αυτό το άτομο με ένα ΠΕΠ"
						},
						"pep_position": {
							"label": "ΠΕΠ-θέση",
							"error": "Επιλέξτε τη θέση που κατέχει το ΠΕΠ"
						},
						"personal_id_question": "Αυτό το άτομο δεν έχει Προσωπικό Αριθμό Αναγνώρισης",
						"personal_id": {
							"US": {
								"label": "Αριθμός Κοινωνικής Ασφάλισης (τελευταία 4 ψηφία)",
								"label_summary": "Αριθμός Κοινωνικής Ασφάλισης"
							},
							"US_FULL_SSN": {
								"label": "Αριθμός Κοινωνικής Ασφάλισης",
								"label_summary": "Αριθμός Κοινωνικής Ασφάλισης"
							},
							"CA": {
								"label": "Αριθμός Κοινωνικής Ασφάλισης (SIN) ή Αριθμός Διαβατηρίου",
								"label_summary": "Αριθμός Κοινωνικής Ασφάλισης (SIN) ή Αριθμός Διαβατηρίου"
							},
							"SE": {
								"label": "Προσωπικός Αριθμός Αναγνώρισης (PNO)",
								"label_summary": "Προσωπικός Αριθμός Αναγνώρισης (PNO)"
							},
							"FI": {
								"label": "Προσωπικός Κωδικός Αναγνώρισης (HETU)",
								"label_summary": "Προσωπικός Αριθμός Αναγνώρισης (HETU)"
							},
							"NO": {
								"label": "Αριθμός δελτίου εθνικής ταυτότητας",
								"label_summary": "Αριθμός δελτίου εθνικής ταυτότητας"
							},
							"DK": {
								"label": "Προσωπικός Αριθμός Αναγνώρισης",
								"label_summary": "Προσωπικός Αριθμός Αναγνώρισης (CPR)"
							},
							"IT": {
								"label": "Αριθμός φορολογικού μητρώου",
								"label_summary": "Αριθμός φορολογικού μητρώου"
							},
							"ES": {
								"label": "Προσωπικός Αριθμός Αναγνώρισης",
								"label_summary": "Προσωπικός Αριθμός Αναγνώρισης (DNI)"
							},
							"PL": {
								"label": "Προσωπικός Αριθμός Αναγνώρισης",
								"label_summary": "Προσωπικός Αριθμός Αναγνώρισης (PESEL)"
							},
							"default": {
								"label": "Αριθμός διαβατηρίου",
								"label_summary": "Αριθμός διαβατηρίου"
							},
							"value": "Εμπιστευτικός"
						},
						"registration_number": {
							"label": "Αριθμός Αναγνώρισης Επιχείρησης",
							"error": "Καταχωρίστε το EIN σε μορφή: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Όνομα καταστήματος",
							"error": "Καταχωρίστε μια έγκυρη επωνυμία εταιρείας"
						},
						"legal_company_name": {
							"label": "Νομική επωνυμία της εταιρείας",
							"error_label": "Καταχωρίστε τη νομική επωνυμία της εταιρείας"
						},
						"add_person": "Προσθήκη ατόμου",
						"remove": "Κατάργηση",
						"edit": "Επεξεργασία"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Αναγνωριστικό Εμπόρου: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Υλικό μάρκετινγκ",
						"text": "Τώρα είστε μέλος της οικογένειας Klarna. Εδώ είναι ένα πακέτο υλικών και πολλά άλλα για να σας βοηθήσουν.",
						"link": "Λήψη"
					},
					"invite_more_users": {
						"title": "Προσκαλέστε περισσότερους χρήστες",
						"text": "Προσκαλέστε τους συνεργάτες σας στην Πύλη Εμπόρων, θα μπορείτε να ρυθμίσετε προσαρμοσμένες άδειες για καθέναν από αυτούς!",
						"link": "Προσκαλέστε χρήστες"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Προϊόντα και τιμολόγηση",
					"subtitle": "{country}",
					"pricing": "Τιμολόγηση για {country}",
					"monthly_fee": "μηνιαίο τέλος",
					"transaction_fee": "τέλος συναλλαγής",
					"before_link": "Συμφωνώ με τους",
					"link_text": "όρους & προϋποθέσεις",
					"after_link_one_product": "για αυτό το προϊόν",
					"after_link_more_than_one_product": "για αυτά τα προϊόντα",
					"product_not_available_in_your_country": "* Αυτό το προϊόν δεν είναι διαθέσιμο για την εγχώρια αγορά σας, αλλά θα λειτουργήσει σε άλλες χώρες."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Εγκαταστάθηκε"
						},
						"in_progress": {
							"text": "Σε εξέλιξη"
						}
					}
				},
				"phone_collection_block": {
					"title": "Αντιμετωπίζετε προβλήματα με την ενσωμάτωσή σας στην Klarna;",
					"description": "Αφήστε τον αριθμό σας παρακάτω και ένας από τους εκπροσώπους μας θα σας καλέσει για να σας παρέχει υποστήριξη σχετικά με την προσθήκη της Klarna στο ηλεκτρονικό σας εμπόριο.",
					"success_banner": "Σας ευχαριστούμε! Η ομάδα μας θα επικοινωνήσει μαζί σας το συντομότερο δυνατό.",
					"submit": "Αποστολή",
					"fields": {
						"phone": {
							"label": "Αριθμός τηλεφώνου",
							"tooltip": "Πρέπει να συμπεριλάβετε τον κωδικό χώρας, π.χ. +1 541 754 3010",
							"errors": {
								"required": "Απαιτείται αριθμός τηλεφώνου",
								"invalid": "Μη έγκυρος αριθμός τηλεφώνου"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Ποιος υπογράφει τις συμβάσεις για την εταιρεία σας;",
						"managed": "Ποιος υπογράφει τις συμβάσεις για την εταιρεία;",
						"recollection": "Ποιος είναι εξουσιοδοτημένος να υπογράφει για λογαριασμό της επιχείρησής σας;"
					},
					"subtitle": {
						"unmanaged": "Η επιχείρησή σας πρόκειται να συνάψει σύμβαση με την Klarna. Πρέπει να επαληθεύσουμε ποιος είναι νόμιμα εξουσιοδοτημένος να υπογράφει συμβάσεις.",
						"managed": "Παρέχετε τις πληροφορίες για όλους τους εξουσιοδοτημένους υπογράφοντες της εταιρείας που συνάπτουν την συμφωνία. Είμαστε νομικά υποχρεωμένοι να επικυρώσουμε την υπογράφουσα αρχή αυτών των εκπροσώπων. Εάν κανείς από τη λίστα δεν υπέγραψε τη συμφωνία, κάντε κλικ στο «Προσθήκη ατόμου» και καταχωρίστε τις απαιτούμενες πληροφορίες.",
						"recollection": "Καθώς η επιχείρησή σας έχει ενεργή συμφωνία με την Klarna, είμαστε νομικά υποχρεωμένοι να συλλέγουμε και να επαληθεύουμε πληροφορίες για όλους τους νόμιμους εκπροσώπους σας."
					},
					"form_title": "Καταχωρίστε τις πληροφορίες",
					"robot_message": {
						"unmanaged": "Αυτοί είναι συνήθως οι επικεφαλής του διοικητικού συμβουλίου ή τα στελέχη, όπως ο CEO, ο CFO ή ο COO. Η καταχώριση δύο ή περισσότερων ατόμων μπορεί να βοηθήσει στην επιτάχυνση της έγκρισης της σύμβασης.",
						"managed": "Αυτοί είναι συνήθως οι επικεφαλής του διοικητικού συμβουλίου ή τα στελέχη, όπως ο CEO, ο CFO ή ο COO. Η καταχώριση δύο ή περισσότερων ατόμων μπορεί να βοηθήσει στην επιτάχυνση της έγκρισης της σύμβασης."
					},
					"error_tooltip": {
						"too_young": "Αυτό το άτομο δεν μπορεί να υποβάλει την αίτηση επειδή είναι κάτω των {minAge} ετών."
					},
					"alert_all_too_young": "Όλα τα άτομα που συνάπτουν τη συμφωνία πρέπει να είναι άνω των {minAge} ετών. Για να συνεχίσετε, προσθέστε και επιλέξτε έναν αιτούντα που είναι άνω των {minAge} ετών.",
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή",
						"add_person": "+ Προσθήκη ατόμου"
					},
					"role": {
						"recollection": "Νόμιμος εκπρόσωπος"
					}
				},
				"application_summary": {
					"title": "Ελέγξτε και υποβάλετε την αίτησή σας.",
					"subtitle": {
						"unmanaged": "Ρίξτε μια ματιά στα στοιχεία σας πριν την υποβολή.",
						"managed": "Ρίξτε μια ματιά στα στοιχεία πριν την υποβολή."
					},
					"stakeholders": {
						"title": "Διοίκηση επιχείρησης",
						"subtitle": "Ενδιαφερόμενο μέρος {index}"
					},
					"businessDetailsCard": {
						"title": "Στοιχεία επιχείρησης"
					},
					"businessDetailsCardFields": {
						"companyName": "Επωνυμία εταιρείας",
						"organizationEntityType": "Φορολογική κατάταξη",
						"organizationRegistrationAuthority": "Δικαστήριο εγγραφής",
						"goodsCategory": "Κατηγορία αγαθών",
						"registrationId": {
							"default": "Αριθμός εγγραφής",
							"AT": "Αριθμός εγγραφής",
							"AU": "ACN",
							"CA": "Αριθμός επιχείρησης",
							"ES": "NIF/NIE/DNI εταιρείας",
							"GB": "Αριθμός οργανισμού",
							"GR": "Αριθμός Γ.Ε.ΜΗ.",
							"NZ": "Αριθμός επιχείρησης",
							"US": "Αριθμός αναγνώρισης εργοδότη"
						},
						"registered": {
							"default": "Εγγεγραμμένη εταιρεία",
							"AU": "Η εταιρεία διαθέτει ACN"
						},
						"subjectToVat": {
							"default": "Η εταιρεία υπόκειται σε ΦΠΑ",
							"AU": "Η εταιρεία υπόκειται σε ABN"
						},
						"vatId": {
							"default": "ΑΦΜ",
							"AU": "ABN",
							"NZ": "Αριθμός GST",
							"ES": "NIF/NIE/DNI εταιρείας"
						},
						"storeName": "Όνομα καταστήματος",
						"storeName_us": "Επωνυμία / DBA",
						"website": "Ιστότοπος",
						"email": "Διεύθυνση email της υποστήριξης πελατών",
						"entityType": "Τύπος οντότητας"
					},
					"companyRegistrationAddressCard": {
						"title": "Διεύθυνση εγγραφής εταιρείας"
					},
					"companyAddressCard": {
						"title": "Διεύθυνση εταιρείας"
					},
					"operatingAddressCard": {
						"title": "Λειτουργική διεύθυνση εταιρείας"
					},
					"documentsCard": {
						"title": "Μεταφορτωμένα έγγραφα"
					},
					"buttons": {
						"edit": "Επεξεργασία",
						"back": "Επιστροφή",
						"submit": "Υποβολή"
					},
					"noTermsAccepted": "Διαβάστε και αποδεχτείτε τους όρους & προϋποθέσεις",
					"noTermsAcceptedWithPricingAnnex": "Διαβάστε και αποδεχτείτε τη Συμφωνία Εμπόρου και τους Όρους Τιμολόγησης"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Ποιος διοικεί την εταιρεία;"
					},
					"subtitle": {
						"default": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"US": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"CA": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					},
					"infobox": {
						"default": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας του CEO της εταιρείας.",
						"US": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας του πλειοψηφικού ιδιοκτήτη ή ενός διευθυντικού στελέχους υψηλού επιπέδου, όπως του CEO, του CFO ή του COO.",
						"CA": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας του πλειοψηφικού ιδιοκτήτη ή ενός διευθυντικού στελέχους υψηλού επιπέδου, όπως του CEO, του CFO ή του COO."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Είναι αυτή η επιχείρηση δημόσια εταιρεία ή ανήκει αποκλειστικά σε δημόσια εταιρεία;",
					"title_stakeholder": "Ποιος διοικεί την εταιρεία;",
					"subtitle": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες.",
					"subtitle_stakeholder": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας του CEO της εταιρείας.",
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"bank_account": {
					"title": {
						"default": "Ποια είναι τα στοιχεία του τραπεζικού σας λογαριασμού;"
					},
					"subtitle": {
						"US": "Οι συναλλαγές Klarna θα μεταφερθούν σε αυτόν τον τραπεζικό λογαριασμό.",
						"default": "Θα χρησιμοποιήσουμε αυτά τα στοιχεία τραπεζικού λογαριασμού για να μεταφέρουμε τις πληρωμές από τις πωλήσεις σας."
					},
					"no_more_bank_accounts": "Έχετε ήδη προσθέσει τραπεζικούς λογαριασμούς για όλα τα υποστηριζόμενα νομίσματα. Εξαιρετική δουλειά!",
					"robot_message_general": "Ο προεπιλεγμένος τραπεζικός λογαριασμός πρέπει να είναι σε τράπεζα της χώρας όπου είναι εγγεγραμμένη η εταιρεία. Θα χρειαστεί επίσης να προσθέσετε έναν τραπεζικό λογαριασμό για κάθε νόμισμα που σκοπεύετε να αποδεχτείτε.",
					"robot_message": "Το IBAN σημαίνει Διεθνής Αριθμός Τραπεζικού Λογαριασμού και παρέχεται από την τράπεζά σας για τον λογαριασμό σας. Π.χ. GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Ο αριθμός λογαριασμού παρέχεται από την τράπεζά σας και έχει από 6 έως 10 ψηφία. Π.χ. 12345678",
						"US": "Ο αριθμός λογαριασμού παρέχεται από την τράπεζά σας και έχει από 5 έως 17 ψηφία. Π.χ. 12345678",
						"GB": "Ο αριθμός λογαριασμού παρέχεται από την τράπεζά σας και έχει 8 ψηφία. Π.χ.: 12345678. Ορισμένες τράπεζες στο Ηνωμένο Βασίλειο παρέχουν μικρότερους αριθμούς λογαριασμών (δηλαδή, 7ψήφιους). Σε αυτή την περίπτωση, θα προστεθούν μηδενικά στην αρχή του αριθμού σας ώστε να έχει μήκος έως 8 ψηφία."
					},
					"robot_message_revolut": "Το IBAN που καταχωρίσατε δεν έχει δυνατότητα λήψης εγχώριων πληρωμών σε GBP. Θα χρειαστεί να επικοινωνήσετε με την τράπεζά σας και να ζητήσετε στοιχεία λογαριασμού που υποστηρίζουν εγχώριες μεταφορές σε GBP.",
					"robot_message_local": "Ο IBAN που καταχωρίσατε είναι ένα τοπικό IBAN για την τράπεζά σας, ο οποίος δεν υποστηρίζεται από εμάς. Θα χρειαστεί να επικοινωνήσετε με την τράπεζά σας και να ζητήσετε τον προσωπικό σας IBAN, ή να χρησιμοποιήσετε διαφορετικό λογαριασμό για να συνδεθείτε με την Klarna.",
					"buttons": {
						"add_bank_account": "+ Προσθήκη τραπεζικού λογαριασμού",
						"skip": "Παράλειψη (για τώρα)",
						"remove": "Κατάργηση",
						"submit": "Υποβολή",
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"fields": {
						"currency_code": {
							"label": "Νόμισμα",
							"disable_reason": {
								"account_in_merchant_currency_required": "Το προεπιλεγμένο νόμισμα είναι {currency} λόγω της χώρας στην οποία είναι εγγεγραμμένη η εταιρεία σας."
							},
							"errors": {
								"general": "Επιλέξτε νόμισμα"
							}
						},
						"country_of_bankaccount": {
							"label": "Χώρα",
							"errors": {
								"general": "Επιλέξτε μια χώρα"
							}
						},
						"iban_account_number": {
							"label": "Αριθμός λογαριασμού (IBAN)",
							"errors": {
								"general": "Καταχωρίστε έναν αριθμό τραπεζικού λογαριασμού (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Χρησιμοποιήστε αυτόν τον λογαριασμό για μη καθορισμένα νομίσματα",
							"tooltip": "Οι παραγγελίες σε νομίσματα που δεν αναφέρονται σε αυτήν τη σελίδα θα καταβάλλονται σε αυτόν τον λογαριασμό. Η τράπεζά σας ενδέχεται να χρεώσει ένα πρόσθετο τέλος για ορισμένα νομίσματα."
						},
						"local_account_number": {
							"label": {
								"default": "Αριθμός λογαριασμού",
								"MX": "Αριθμός CLABE"
							},
							"errors": {
								"general": {
									"default": "Καταχωρίστε έναν αριθμό τραπεζικού λογαριασμού",
									"MX": "Καταχωρίστε έναν έγκυρο αριθμό CLABE"
								}
							}
						},
						"account_holder": {
							"label": "Όνομα κατόχου λογαριασμού",
							"errors": {
								"general": "Καταχωρίστε το όνομα του κατόχου του λογαριασμού (70 χαρακτήρες μέγιστο)."
							}
						},
						"transit_number": {
							"label": "Αριθμός μεταφοράς",
							"errors": {
								"general": "Καταχωρίστε έναν έγκυρο αριθμό μεταφοράς"
							}
						},
						"institution_number": {
							"label": "Αριθμός ιδρύματος",
							"errors": {
								"general": "Καταχωρίστε έναν έγκυρο αριθμό ιδρύματος"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Καταχωρίστε ένα έγκυρο BSB (κρατικό υποκατάστημα τράπεζας)"
								}
							},
							"tooltip": {
								"AU": "Ο κωδικός BSB θα πρέπει να αποτελείται από 6 αριθμητικά ψηφία χωρισμένα με μια παύλα. Π.χ. 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Αριθμός δρομολόγησης",
								"GB": "Κωδικός υποκαταστήματος"
							},
							"errors": {
								"general": {
									"default": "Καταχωρίστε έναν έγκυρο αριθμό δρομολόγησης",
									"GB": "Καταχωρίστε έναν έγκυρο κωδικό υποκαταστήματος"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Ποιος διοικεί την εταιρεία;"
					},
					"subtitle": {
						"default": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"GB": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες. Βεβαιωθείτε ότι το αρχείο σας στο Companies House (Μητρώο Εταιρειών) είναι ενημερωμένο."
							}
						]
					},
					"infobox": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας των ατόμων που ασκούν έλεγχο στη διοίκηση της εταιρείας σας, όπως ο Διευθύνων Σύμβουλος ή τα μέλη του διοικητικού συμβουλίου.",
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή",
						"add_person": "+ Προσθήκη ατόμου"
					},
					"messages": {
						"lookup": "Διοικούν αυτά τα άτομα την εταιρεία σας; Ρίξτε μια ματιά και επιβεβαιώστε αν είναι σωστά."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Είναι η επιχείρησή σας εγγεγραμμένη εταιρεία;",
						"managed": "Είναι αυτή η επιχείρηση εγγεγραμμένη εταιρεία;"
					},
					"subtitle": {
						"unmanaged": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
						"managed": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης."
					},
					"question": {
						"title": {
							"unmanaged": "Καταχωρίστε τον αριθμό εγγραφής σας και το δικαστήριο εγγραφής",
							"managed": "Καταχωρίστε τον αριθμό εγγραφής και το δικαστήριο εγγραφής"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Αριθμός εγγραφής"
						},
						"registration_court": {
							"label": "Δικαστήριο εγγραφής",
							"errors": {
								"general": {
									"unmanaged": "Επιλέξτε το δικαστήριο εγγραφής σας",
									"managed": "Επιλέξτε το δικαστήριο εγγραφής"
								}
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"documents": {
					"title": "Ανεβάστε το έγγραφό σας",
					"subtitle": "Απαιτούμε από εσάς να στείλετε μερικά πρόσθετα έγγραφα που χρειάζονται για την επικύρωση της ταυτότητάς σας. Μεταφορτώστε μόνο αρχεία <strong>JPG</strong>, <strong>PNG</strong> ή <strong>PDF</strong> (μέγιστο μέγεθος αρχείου 10 MB).",
					"subheadline": {
						"default": "Καθώς η Klarna είναι τράπεζα με έδρα στη Σουηδία και επομένως ελέγχεται από τη Σουηδική Αρχή Χρηματοοικονομικής Εποπτείας, η Klarna πρέπει να συμμορφώνεται με την Οδηγία ΕΕ 2015/849. Η Klarna πρέπει να συλλέγει πληροφορίες σχετικά με τα άτομα που ελέγχουν την εταιρεία, ώστε να μπορείτε ξεκινήστε να χρησιμοποιείτε τις υπηρεσίες της Klarna. Ανεβάστε μόνο αρχεία <strong>JPG, PNG ή PDF</strong> (μέγιστο μέγεθος αρχείων 10MB)",
						"US": "Δεδομένου ότι η Klarna είναι τράπεζα με έδρα στη Σουηδία, και κατά συνέπεια ελέγχεται από την Αρχή Χρηματοοικονομικής Εποπτείας της Σουηδίας, η Klarna πρέπει να συμμορφώνεται με την Οδηγία ΕΕ 2015/849. Η Klarna απαιτείται να συλλέξει πληροφορίες σχετικά με τα άτομα που ελέγχουν την εταιρεία, προκειμένου να μπορείτε να αρχίσετε να χρησιμοποιείτε τις υπηρεσίες της Klarna. Παρακαλούμε να υποβάλετε τα ακόλουθα έγγραφα για την επικύρωση της ταυτότητάς σας. Μεταφορτώστε μόνο αρχεία JPG, PNG ή PDF (μέγιστο μέγεθος αρχείου 10 MB).",
						"IT": "Δεδομένου ότι η Klarna είναι τράπεζα με έδρα στη Σουηδία, και κατά συνέπεια ελέγχεται από την Αρχή Χρηματοοικονομικής Εποπτείας της Σουηδίας, η Klarna πρέπει να συμμορφώνεται με την Οδηγία ΕΕ 2015/849. Η Klarna πρέπει να συλλέξει πληροφορίες σχετικά με τα άτομα που ελέγχουν την εταιρεία, προκειμένου να μπορείτε να αρχίσετε να χρησιμοποιείτε τις υπηρεσίες της Klarna. Λάβετε υπόψη ότι για να προχωρήσετε με την αίτηση, η εταιρεία σας πρέπει να είναι εγγεγραμμένη στο Εμπορικό Επιμελητήριο. Μεταφορτώστε μόνο αρχεία JPG, PNG ή PDF (μέγιστο μέγεθος αρχείων 10 MB)"
					},
					"header_title": "Έγγραφα",
					"stakeholder": "Ενδιαφερόμενο μέρος",
					"business_documents": "Επιχειρηματικό έγγραφο",
					"browse_files": "Αναζήτηση αρχείων",
					"optional": "(προαιρετικό)",
					"upload_area": {
						"title": {
							"before_link": "Αποθέστε τα αρχεία σας εδώ ή",
							"link_text": "Επιλέξτε αρχεία"
						},
						"description": "{acceptedFileFormats} - Μέγιστο {maxFileSizeMB} MB/αρχείο"
					},
					"description": {
						"APPROVAL": "Μεταφορτώστε <strong>την έγκριση</strong>",
						"CONTRACT": "Μεταφορτώστε <strong>τη σύμβαση</strong>",
						"CORRECTION_NOTE": "Μεταφορτώστε <strong>το διορθωτικό σημείωμα</strong>",
						"COUNTERSIGNED_CONTRACT": "Μεταφορτώστε <strong>τη συνυπογεγραμμένη σύμβαση</strong>",
						"ID_DOCUMENT": "Μεταφορτώστε <strong>την ταυτότητα</strong> ή <strong>το διαβατήριο</strong>",
						"LICENSE": "Μεταφορτώστε <strong>την άδεια</strong>",
						"PROOF_OF_ADDRESS": "Μεταφορτώστε <strong>αποδεικτικό της διεύθυνσης κατοικίας</strong>",
						"SPECIAL_AGREEMENT": "Μεταφορτώστε <strong>ειδική συμφωνία</strong>",
						"SUPPORTING_DOCUMENT": "Μεταφορτώστε <strong>το έγγραφο υποστήριξης</strong>",
						"TAX_OFFICE_REGISTRATION": "Μεταφορτώστε <strong>την εγγραφή Δ.Ο.Υ.</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Έγκριση"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Σύμβαση"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Διορθωτικό σημείωμα"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Συνυπογεγραμμένη σύμβαση"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Απόδειξη ταυτότητας",
								"IT": "Δελτίο ταυτότητας"
							},
							"subtitle": {
								"default": "Παρακαλούμε στείλτε μας και τις δύο όψεις της ταυτότητας.",
								"AT": "Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας. Αν η διεύθυνσή σας δεν αναγράφεται στην ταυτότητά σας, θα χρειαστούμε πρόσθετα έγγραφα, όπως έναν λογαριασμό κοινής ωφέλειας, για να επαληθεύσουμε τη διεύθυνσή σας.",
								"AU": "Για ταχύτερη αξιολόγηση της αίτησής σας, παρακαλούμε να υποβάλετε ένα αντίγραφο έγκυρης ταυτότητας με φωτογραφία, όπως διαβατήριο ή αυστραλιανή άδεια οδήγησης, για τα ακόλουθα άτομα που σχετίζονται με την επιχείρηση: Ατομική επιχείρηση/Συνεταιρισμός - ο/οι ιδιοκτήτης/ες. Εταιρεία - ο νόμιμος εκπρόσωπος, όλοι οι διευθυντές και οποιοσδήποτε μέτοχος που κατέχει ποσοστό άνω του 25% των μετοχών.",
								"BE": "Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας, βεβαιωθείτε ότι η ποιότητα της εικόνας είναι επαρκής και ότι όλες οι πληροφορίες είναι ευανάγνωστες.",
								"DE": "Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας. Αν η διεύθυνσή σας δεν αναγράφεται στην ταυτότητά σας, θα χρειαστούμε πρόσθετα έγγραφα, όπως έναν λογαριασμό κοινής ωφέλειας, για να επαληθεύσουμε τη διεύθυνσή σας.",
								"FR": "Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας, βεβαιωθείτε ότι η ποιότητα της εικόνας είναι επαρκής και ότι όλες οι πληροφορίες είναι ευανάγνωστες.",
								"GB": "Σε περίπτωση δελτίου ταυτότητας, υποβάλετε και τις δύο πλευρές της ταυτότητας.",
								"IT": "Εμπρόσθια/πίσω όψη έγκυρου δελτίου ταυτότητας για καθένα από τα άτομα που αναφέρονται στην αίτηση. Άδεια οδήγησης, διαβατήριο, κάρτα/αριθμός κοινωνικής ασφάλισης δεν γίνονται δεκτά.",
								"NL": "Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας, βεβαιωθείτε ότι η ποιότητα της εικόνας είναι επαρκής και ότι όλες οι πληροφορίες είναι ευανάγνωστες.",
								"US": "Άδεια οδήγησης ή διαβατήριο - Υποβάλετε και τις δύο πλευρές του δελτίου ταυτότητας."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Άδεια"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Απόδειξη διεύθυνσης κατοικίας",
								"BE": "Απόδειξη διεύθυνσης κατοικίας",
								"CZ": "Απόδειξη διεύθυνσης κατοικίας",
								"ES": "Απόδειξη διεύθυνσης κατοικίας",
								"FI": "Απόδειξη διεύθυνσης κατοικίας",
								"FR": "Απόδειξη διεύθυνσης κατοικίας",
								"GR": "Απόδειξη διεύθυνσης κατοικίας",
								"IT": "Απόδειξη διεύθυνσης κατοικίας",
								"NL": "Απόδειξη διεύθυνσης κατοικίας",
								"PL": "Απόδειξη διεύθυνσης κατοικίας",
								"PT": "Απόδειξη διεύθυνσης κατοικίας"
							},
							"subtitle": {
								"default": "Δεχόμαστε τα ακόλουθα έγγραφα ως απόδειξη της διεύθυνσης κατοικίας (όχι παλαιότερα των 3 μηνών): Λογαριασμοί ρεύματος, νερού, φυσικού αερίου, Wi-Fi, φορολογική δήλωση,εκκαθαριστικό ή σύμβαση μίσθωσης. Εάν δεν έχετε κανένα από τα έγγραφα, ανεβάστε οποιοδήποτε άλλο αποδεικτικό της κατοικίας έχετε και προσθέστε μια σημείωση με τον λόγο.",
								"AU": "Για ταχύτερη αξιολόγηση της αίτησής σας, παρακαλούμε να υποβάλετε ένα από τα ακόλουθα έγγραφα με ημερομηνία εντός των τελευταίων 90 ημερών για την επαλήθευση της διεύθυνσης κατοικίας σας: Λογαριασμός κοινής ωφέλειας, λογαριασμός ίντερνετ, φορολογική δήλωση ή συμφωνητικό μίσθωσης/ενοικίασης. *Αν υποβάλλετε ένα διαβατήριο ως έγγραφο ταυτότητας ή αν η τρέχουσα διεύθυνσή σας δεν ταιριάζει με τη διεύθυνση στο παρεχόμενο έγγραφο ταυτότητας, αυτό το βήμα είναι υποχρεωτικό.",
								"BE": "Αποδεχόμαστε τα παρακάτω έγγραφα, τα οποία δεν είναι παλαιότερα των 3 μηνών, ως αποδεικτικό διεύθυνσης κατοικίας: Ηλεκτρικό ρεύμα, νερό, αέριο, φορολογική δήλωση ή συμφωνητικό μίσθωσης. Αν δεν έχετε κανένα από τα έγγραφα, μεταφορτώστε άλλο αποδεικτικό κατοικίας και προσθέστε μια σημείωση αναφέροντας τον λόγο.",
								"FR": "Αποδεχόμαστε τα παρακάτω έγγραφα, τα οποία δεν είναι παλαιότερα των 3 μηνών, ως αποδεικτικό διεύθυνσης κατοικίας: Ηλεκτρικό ρεύμα, νερό, αέριο, φορολογική δήλωση ή συμφωνητικό μίσθωσης. Αν δεν έχετε κανένα από τα έγγραφα, μεταφορτώστε άλλο αποδεικτικό κατοικίας και προσθέστε μια σημείωση αναφέροντας τον λόγο.",
								"NL": "Αποδεχόμαστε τα παρακάτω έγγραφα, τα οποία δεν είναι παλαιότερα των 3 μηνών, ως αποδεικτικό διεύθυνσης κατοικίας: Ηλεκτρικό ρεύμα, νερό, αέριο, φορολογική δήλωση ή συμφωνητικό μίσθωσης. Αν δεν έχετε κανένα από τα έγγραφα, μεταφορτώστε άλλο αποδεικτικό κατοικίας και προσθέστε μια σημείωση αναφέροντας τον λόγο.",
								"US": "Αποδεχόμαστε λογαριασμούς κοινής ωφέλειας (αέριο, νερό, ίντερνετ, τηλέφωνο, κ.λπ.), μισθωτήριο ή στεγαστικό δάνειο με αποδεικτικό διεύθυνσης - Δεν πρέπει να έχουν ημερομηνία άνω των 90 ημερών από την ημερομηνία της αίτησης.",
								"IT": "Αν το δελτίο ταυτότητάς σας έχει διαφορετική διεύθυνση από την τρέχουσα διεύθυνση κατοικίας σας, θα χρειαστούμε ένα επιπλέον έγγραφο για να επαληθεύσουμε την τρέχουσα κατοικία σας. Αποδεχόμαστε τα ακόλουθα έγγραφα τα οποία δεν είναι παλαιότερα των 3 μηνών ως αποδεικτικό διεύθυνσης κατοικίας των ατόμων που αναφέρονται στην αίτηση:"
							},
							"list": {
								"IT": [
									{
										"text": "Πιστοποιητικό κατοικίας που εκδόθηκε online (μέσω SPID) ή από τον Δήμο της κατοικίας σας"
									},
									{
										"text": "Λογαριασμοί ηλεκτρικού ρεύματος / νερού / αερίου / Wi-fi"
									},
									{
										"text": "μισθωτήριο"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Ειδική συμφωνία"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Έγγραφο υποστήριξης",
								"GB": "Αυτοπορτρέτο"
							},
							"subtitle": {
								"default": null,
								"AU": "Αν πουλάτε επώνυμα είδη υψηλής αξίας, παρακαλούμε να υποβάλετε 2-3 τιμολόγια προμηθευτή για αυτά τα προϊόντα εδώ. Βεβαιωθείτε ότι το τιμολόγιο περιλαμβάνει τα προϊόντα που αγοράστηκαν, το όνομα του προμηθευτή, το όνομα του παραλήπτη και τη διεύθυνση παράδοσης.",
								"GB": "Παρέχετε μια φωτογραφία αυτοπορτρέτου κρατώντας την ταυτότητα."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Έγγραφο εγγραφής στην εφορία",
								"AT": "Έγγραφο της εγγραφής στη φορολογική αρχή",
								"AU": "Ιδρυτική πράξη",
								"BE": "ΑΦΜ ενεργοποιημένος για διασυνοριακές συναλλαγές (VIES).",
								"DE": "Έγγραφο της εγγραφής στη φορολογική αρχή",
								"FR": "ΑΦΜ ενεργοποιημένος για διασυνοριακές συναλλαγές (VIES).",
								"IT": "ΑΦΜ ενεργοποιημένος για διασυνοριακές συναλλαγές (VIES).",
								"NL": "ΑΦΜ ενεργοποιημένος για διασυνοριακές συναλλαγές (VIES).",
								"NO": "Εγγραφή Δ.Ο.Υ.",
								"US": "Επιστολή EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Απόσπασμα εμπορικού μητρώου / άδεια ατομικής επιχείρησης",
								"AU": "Αν το ABN σας σχετίζεται με καταπίστευμα, παρακαλούμε να υποβάλετε ένα αντίγραφο του εγγράφου καταπιστεύματος, συμπεριλαμβανομένου του προγράμματος καταπιστεύματος. Λάβετε υπόψη ότι αυτό το βήμα είναι υποχρεωτικό για καταπιστεύματα.",
								"BE": "Βεβαιωθείτε ότι ο ΑΦΜ σας είναι ενεργοποιημένος για διασυνοριακές συναλλαγές. Αυτό είναι απαραίτητο ακόμη και αν πραγματοποιείτε συναλλαγές μόνο στη χώρα σας, καθώς η Klarna είναι αλλοδαπή οντότητα. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Μπορείτε να επικοινωνήσετε με την τοπική φορολογική υπηρεσία για να ζητήσετε δωρεάν ενεργοποίηση VIES του ΑΦΜ σας.",
								"CZ": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Βεβαίωση εγγραφής στο Δημόσιο Μητρώο ή απόσπασμα εμπορικού μητρώου ατομικής επιχείρησης.",
								"DE": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Απόσπασμα εμπορικού μητρώου / άδεια ατομικής επιχείρησης",
								"ES": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Καταστατικό για εγγεγραμμένες επιχειρήσεις, για ατομικές επιχειρήσεις - Πιστοποίηση κατάστασης απογραφής / Υπόδειγμα 036 / Υπόδειγμα 037",
								"FI": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Καταστατικό για ατομικές επιχειρήσεις - Πιστοποίηση κατάστασης απογραφής /Υπόδειγμα 036 / Υπόδειγμα 037",
								"FR": "Βεβαιωθείτε ότι ο ΑΦΜ σας είναι ενεργοποιημένος για διασυνοριακές συναλλαγές. Αυτό είναι απαραίτητο ακόμη και αν πραγματοποιείτε συναλλαγές μόνο στη χώρα σας, καθώς η Klarna είναι αλλοδαπή οντότητα. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Μπορείτε να επικοινωνήσετε με την τοπική φορολογική υπηρεσία για να ζητήσετε δωρεάν ενεργοποίηση VIES του ΑΦΜ σας.",
								"GR": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Εγγραφή Δ.Ο.Υ. / Έναρξη επιχειρηματικής δραστηριότητας / Έγγραφο Μητρώου Επιχειρήσεων που εκδίδεται από την Αρμόδια Υπηρεσία Γ.Ε.ΜΗ (<link>Κεντρική Ένωση Επιμελητηρίων</link>)",
								"IT": "Μπορείτε να επικοινωνήσετε με την Υπηρεσία Δημοσίων Εσόδων (Agenzia delle Entrate) για να ζητήσετε δωρεάν ενεργοποίηση VIES του ΑΦΜ σας. Αυτό θα είναι απαραίτητο ακόμη και αν πραγματοποιείτε συναλλαγές μόνο στην Ιταλία, καθώς η Klarna είναι αλλοδαπή οντότητα.",
								"NL": "Βεβαιωθείτε ότι ο ΑΦΜ σας είναι ενεργοποιημένος για διασυνοριακές συναλλαγές. Αυτό είναι απαραίτητο ακόμη και αν πραγματοποιείτε συναλλαγές μόνο στη χώρα σας, καθώς η Klarna είναι αλλοδαπή οντότητα. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Μπορείτε να επικοινωνήσετε με την τοπική φορολογική υπηρεσία για να ζητήσετε δωρεάν ενεργοποίηση VIES του ΑΦΜ σας.",
								"NO": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Εταιρικά έγγραφα",
								"PL": "Αποδεχόμαστε τα παρακάτω έγγραφα ως επιχειρηματικά έγγραφα: Πιστοποιητικό εγγραφής στο μητρώο επιχειρήσεων CEIDG, απόσπασμα από το Εθνικό Δικαστικό Μητρώο (KRS)",
								"PT": "Δεχόμαστε τα ακόλουθα έγγραφα ως επιχειρηματικά έγγραφα:  Certidão Permanente (Υποχρεωτικό), Πιστοποιητικό Σύστασης. Για ελεύθερους επαγγελματίες, εγγραφή αυτοαπασχόλησης (Declaração de Início de Atividade).",
								"US": "Αυτή είναι η επιστολή που έχει ληφθεί από την Υπηρεσία Δημοσίων Εσόδων (IRS) και σας εκχωρεί ένα EIN (Επιστολή IRS CP575 EIN). Αν η επιχείρησή σας είναι ατομική επιχείρηση και υποβάλλετε αίτηση με το SSN σας, παρακαλούμε να παράσχετε ένα αντίγραφο της κάρτας SSN"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Επικυρωμένο έγγραφο ταυτοποίησης"
							},
							"subtitle": {
								"default": "Αποδεχόμαστε τα παρακάτω έγγραφα: Δελτίο ταυτότητας, διαβατήριο, άδεια οδήγησης. Τα έγγραφα πρέπει να πληρούν τα παρακάτω κριτήρια:"
							},
							"list": [
								{
									"text": "Να είναι πιστοποιημένα από εξουσιοδοτημένο υπάλληλο πιστοποίησης (για παράδειγμα, συμβολαιογράφο, επίτροπο ορκωμοσιών, δικηγόρο, πληρεξούσιο ή/και ορκωτό λογιστή)."
								},
								{
									"text": "Να φέρουν υπογραφή και σφραγίδα. Η σφραγίδα πρέπει να εμφανίζει ορατά και επαληθεύσιμα στοιχεία του πιστοποιούντος, όπως το ονοματεπώνυμο, τη διεύθυνση και, κατά περίπτωση, τον αριθμό μητρώου."
								},
								{
									"text": "Να φέρουν ημερομηνία - η ημερομηνία πιστοποίησης δεν πρέπει να είναι άνω των 6 μηνών."
								},
								{
									"text": "Να επικυρώνονται ως γνήσιο αντίγραφο ενός πρωτοτύπου δηλώνοντας σαφώς ότι το πρωτότυπο έγγραφο προσκομίστηκε."
								}
							]
						}
					},
					"modal": {
						"title": "Γιατί χρειαζόμαστε τα έγγραφά σας;",
						"close": "Κλείσιμο",
						"content": [
							{
								"title": "Περιγραφή της διαδικασίας",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Απαιτήσεις αρχείων",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Πώς να σαρώσετε έγγραφα;",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Η μεταφόρτωση απέτυχε",
						"too_large_file": "Το αρχείο είναι πολύ μεγάλο <strong>(μέγιστο {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Επιτρέπεται να μεταφορτώσετε μόνο {number} αρχεία.",
						"invalid_file_format": "Μη έγκυρη μορφή αρχείου. Οι μόνοι αποδεκτοί τύποι αρχείων είναι {acceptedFileFormats}",
						"duplicate_file_name": "Διπλό όνομα αρχείου. Όλα τα μεταφορτωμένα αρχεία πρέπει να έχουν μοναδικά ονόματα.",
						"try_again": "Δοκιμάστε ξανά ή <u>επιλέξτε άλλο αρχείο</u>"
					},
					"buttons": {
						"modal": "Γιατί χρειαζόμαστε τα έγγραφά σας;",
						"next": "Επόμενο",
						"back": "Επιστροφή",
						"submit": "Υποβολή εγγράφων"
					}
				},
				"document_upload_success": {
					"title": "Η μεταφόρτωση ολοκληρώθηκε.",
					"message": "Σας ευχαριστούμε! Τα έγγραφά σας μεταφορτώθηκαν επιτυχώς."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Μπορείτε να καταχωρίσετε τον αριθμό εγγραφής σας;",
							"AT": "Μπορείτε να καταχωρίσετε τον αριθμό εγγραφής σας;",
							"CA": "Μπορείτε να καταχωρίσετε το ομοσπονδιακό BN σας;",
							"GR": "Μπορείτε να καταχωρίσετε τον αριθμό σας Γ.Ε.ΜΗ.;",
							"NZ": "Μπορείτε να καταχωρίσετε τον αριθμό της επιχείρησής σας;"
						},
						"managed": {
							"default": "Μπορείτε να καταχωρίσετε τον αριθμό εγγραφής της εταιρείας;",
							"AT": "Μπορείτε να καταχωρίσετε τον αριθμό εγγραφής της εταιρείας;",
							"CA": "Μπορείτε να καταχωρίσετε το ομοσπονδιακό BN σας;",
							"GR": "Μπορείτε να καταχωρίσετε τον αριθμό Γ.Ε.ΜΗ. της εταιρείας;",
							"NZ": "Μπορείτε να καταχωρίσετε τον αριθμό επιχείρησης της εταιρείας;"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"CA": "Χρειαζόμαστε τον ομοσπονδιακό αριθμό μητρώου επιχείρησης που έχει χορηγηθεί στην εταιρεία σας από την CRA (Υπηρεσία Δημοσίων Εσόδων του Καναδά) για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"GR": "Χρειαζόμαστε τον αριθμό σας Γ.Ε.ΜΗ. για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"NZ": "Χρειαζόμαστε τον αριθμό επιχείρησης της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας."
						},
						"managed": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"CA": "Χρειαζόμαστε τον ομοσπονδιακό αριθμό μητρώου επιχείρησης που έχει χορηγηθεί στην εταιρεία σας από την CRA (Υπηρεσία Δημοσίων Εσόδων του Καναδά) για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"GR": "Χρειαζόμαστε τον αριθμό Γ.Ε.ΜΗ. για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"NZ": "Χρειαζόμαστε τον αριθμό επιχείρησης της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Να σημειωθεί ότι η Klarna δεν μπορεί να παρέχει επί του παρόντος τις υπηρεσίες πληρωμών της για Καναδικές ατομικές επιχειρήσεις. Εάν συνεχίσετε με την αίτησή σας αυτή θα απορριφθεί."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Αριθμός εγγραφής",
								"AT": "Αριθμός εγγραφής",
								"CA": "Αριθμός επιχείρησης",
								"GR": "Αριθμός Γ.Ε.ΜΗ.",
								"NZ": "Αριθμός επιχείρησης"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Ποια είναι η φορολογική σας κατάταξη;",
						"managed": "Μπορείτε να καταχωρίσετε τη φορολογική κατάταξη της εταιρείας;"
					},
					"subtitle": {
						"unmanaged": "Θα σας ζητήσουμε διαφορετικές πληροφορίες ανάλογα με τη νομική κατάσταση της εταιρείας.",
						"managed": "Θα σας ζητήσουμε διαφορετικές πληροφορίες ανάλογα με τη νομική κατάσταση της εταιρείας."
					},
					"info": {
						"unmanaged": "Μπορείτε να βρείτε το EIN (Αριθμός Αναγνώρισης Εργοδότη) της επιχείρησής σας σε φορολογικές δηλώσεις, πιστωτικές εκθέσεις, έγγραφα μισθοδοσίας, ή σε άδειες",
						"managed": "Μπορείτε να βρείτε το EIN (Αριθμός Αναγνώρισης Εργοδότη) της εταιρείας σε φορολογικές δηλώσεις, πιστωτικές εκθέσεις, έγγραφα μισθοδοσίας, ή σε άδειες"
					},
					"fields": {
						"registration_number": {
							"label": "Αριθμός αναγνώρισης εργοδότη",
							"errors": {
								"general": "Καταχωρίστε έναν έγκυρο αριθμό αναγνώρισης εργοδότη",
								"invalid": "Ο αριθμός αναγνώρισης εργοδότη πρέπει να αποτελείται από 9 ψηφία με παύλα μετά τα δύο πρώτα. Π.χ. 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Ομοσπονδιακή φορολογική κατάταξη",
								"managed": "Είδος επιχείρησης"
							},
							"errors": {
								"is_one_of": "Επιλέξτε ένα από τα αναφερόμενα είδη επιχείρησης"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Μπορείτε να καταχωρίσετε τον ΑΦΜ σας;",
							"AU": "Μπορείτε να καταχωρίσετε το ABN σας;",
							"ES": "Ποιος είναι ο αριθμός φορολογικού μητρώου σας;",
							"NZ": "Μπορείτε να καταχωρίσετε τον αριθμό GST σας;"
						},
						"managed": {
							"default": "Μπορείτε να καταχωρίσετε τον ΑΦΜ;",
							"AU": "Μπορείτε να καταχωρίσετε το ABN;",
							"ES": "Ποιος είναι ο αριθμός φορολογικού μητρώου σας;",
							"NZ": "Μπορείτε να καταχωρίσετε τον αριθμό GST;"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Με τον ΑΦΜ σας, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"AU": "Με το ABN σας, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"NZ": "Με τον αριθμό GST σας, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"ES": "Με τον αριθμό NIF, NIE ή DNI, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας."
						},
						"managed": {
							"default": "Χρησιμοποιούμε τον ΑΦΜ για την επαλήθευση των στοιχείων της εταιρείας.",
							"AU": "Χρησιμοποιούμε το ABN για την επαλήθευση των στοιχείων της εταιρείας.",
							"NZ": "Χρησιμοποιούμε τον αριθμό GST για την επαλήθευση των στοιχείων της εταιρείας.",
							"ES": "Χρησιμοποιούμε τον αριθμό NIF, NIE ή DNI για την επαλήθευση των στοιχείων της εταιρείας."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "ΑΦΜ",
								"AU": "ABN",
								"NZ": "Αριθμός GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Ποιο είναι το είδος της επιχείρησής σας;",
						"managed": "Τι είδους επιχείρηση είναι αυτή η εταιρεία;"
					},
					"subtitle": {
						"unmanaged": "Πρέπει να κάνουμε ορισμένες συγκεκριμένες ερωτήσεις με βάση το είδος της επιχείρησής σας.",
						"managed": "Πρέπει να κάνουμε ορισμένες συγκεκριμένες ερωτήσεις με βάση το είδος της επιχείρησης."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Τύπος νομικής οντότητας",
							"errors": {
								"is_one_of": "Επιλέξτε ένα από τα αναφερόμενα είδη επιχείρησης"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Είναι η επιχείρησή σας εγγεγραμμένη εταιρεία;",
							"AU": "Διαθέτει η επιχείρησή σας ένα ACN;",
							"ES": "Είναι η εταιρεία σας στο Registro Mercantil;"
						},
						"managed": {
							"default": "Είναι αυτή η επιχείρηση εγγεγραμμένη εταιρεία;",
							"AU": "Διαθέτει αυτή η επιχείρηση ένα ACN;",
							"ES": "Είναι η εταιρεία σας στο Registro Mercantil;"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"AU": "Εάν έχετε ένα ACN καταχωρίστε το, διαφορετικά, επιλέξτε όχι και προχωρήστε στο επόμενο βήμα.",
							"ES": "Απαντήστε Ναι εάν είστε SL, SA, SCP, ...κ.λπ. Απαντήστε Όχι εάν είστε αυτόνομος, ελεύθερος επαγγελματίας ...κ.λπ.",
							"GB": "Χρειαζόμαστε τον αριθμό οργανισμού της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"GR": "Χρειαζόμαστε τον αριθμό σας Γ.Ε.ΜΗ. για να επαληθεύσουμε τα στοιχεία της επιχείρησης."
						},
						"managed": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"AU": "Εάν αυτή η εταιρεία διαθέτει ένα ACN καταχωρίστε το, διαφορετικά, επιλέξτε όχι και προχωρήστε στο επόμενο βήμα.",
							"ES": "Απαντήστε Ναι εάν είστε SL, SA, SCP, ...κ.λπ. Απαντήστε Όχι εάν είστε αυτόνομος, ελεύθερος επαγγελματίας ...κ.λπ.",
							"GB": "Χρειαζόμαστε τον αριθμό οργανισμού της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"GR": "Χρειαζόμαστε τον αριθμό Γ.Ε.ΜΗ. της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Καταχωρίστε τον αριθμό εγγραφής σας",
							"AT": "Καταχωρίστε τον αριθμό εγγραφής σας",
							"AU": "Καταχωρίστε το ACN σας",
							"ES": "Καταχωρίστε το NIF/NIE/DNI της εταιρείας σας",
							"GB": "Καταχωρίστε τον αριθμό οργανισμού σας",
							"GR": "Καταχωρίστε τον αριθμό σας Γ.Ε.ΜΗ."
						},
						"managed": {
							"default": "Καταχωρίστε τον αριθμό εγγραφής",
							"AT": "Καταχωρίστε τον αριθμό εγγραφής",
							"AU": "Καταχωρίστε το ACN",
							"ES": "Καταχωρίστε το NIF/NIE/DNI της εταιρείας σας",
							"GB": "Καταχωρίστε τον αριθμό οργανισμού",
							"GR": "Καταχωρίστε τον αριθμό Γ.Ε.ΜΗ."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Αριθμός εγγραφής",
								"AT": "Αριθμός εγγραφής",
								"AU": "Αριθμός εταιρείας Αυστραλίας (ACN)",
								"ES": "NIF/NIE/DNI εταιρείας",
								"GB": "Αριθμός οργανισμού",
								"GR": "Αριθμός Γ.Ε.ΜΗ."
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"mid-selector": {
					"title": "Επιλέξτε ένα κατάστημα",
					"subtitle": "Αυτή η διεύθυνση email σχετίζεται με πολλά καταστήματα. Επιλέξτε ένα κατάστημα για να συνεχίσετε.",
					"mid-selector": "Αναγνωριστικό εμπόρου / Όνομα καταστήματος",
					"buttons": {
						"next": "Συνέχεια"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Είναι η επιχείρησή σας εγγεγραμμένη εταιρεία;",
						"managed": "Είναι αυτή η επιχείρηση εγγεγραμμένη εταιρεία;"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας."
						},
						"managed": {
							"default": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης.",
							"AT": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας για να επαληθεύσουμε τα στοιχεία της επιχείρησης."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Καταχωρίστε τον αριθμό εγγραφής σας",
							"AT": "Καταχωρίστε τον αριθμό εγγραφής σας"
						},
						"managed": {
							"default": "Καταχωρίστε τον αριθμό εγγραφής",
							"AT": "Καταχωρίστε τον αριθμό εγγραφής"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Αριθμός εγγραφής",
								"AT": "Αριθμός εγγραφής"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Είναι η επιχείρησή σας εγγεγραμμένη για ΑΦΜ;",
							"ES": "Διαθέτει η εταιρεία σας NIF/NIE/DNI;",
							"NZ": "Είναι η επιχείρησή σας εγγεγραμμένη για GST (Φόρος Αγαθών και Υπηρεσιών);"
						},
						"managed": {
							"default": "Είναι αυτή η επιχείρηση εγγεγραμμένη για ΑΦΜ;",
							"ES": "Διαθέτει η εταιρεία σας NIF/NIE/DNI;",
							"NZ": "Είναι αυτή η επιχείρηση εγγεγραμμένη για GST (Φόρος Αγαθών και Υπηρεσιών);"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Εάν έχετε ΑΦΜ, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"ES": "Εάν διαθέτει η εταιρεία σας αριθμό NIF/NIE/DNI, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"NZ": "Εάν έχετε αριθμό GST, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας."
						},
						"managed": {
							"default": "Χρησιμοποιούμε τον ΑΦΜ για την επαλήθευση των στοιχείων της εταιρείας.",
							"ES": "Εάν διαθέτει η εταιρεία σας αριθμό NIF/NIE/DNI, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
							"NZ": "Χρησιμοποιούμε τον αριθμό GST για την επαλήθευση των στοιχείων της εταιρείας."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Καταχωρίστε τον ΑΦΜ σας",
							"ES": "Καταχωρίστε το NIF/NIE/DNI της εταιρείας σας",
							"NZ": "Καταχωρίστε τον αριθμό GST"
						},
						"managed": {
							"default": "Καταχωρίστε τον ΑΦΜ",
							"ES": "Καταχωρίστε το NIF/NIE/DNI της εταιρείας σας",
							"NZ": "Καταχωρίστε τον αριθμό GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "ΑΦΜ",
							"ES": "NIF/NIE/DNI εταιρείας",
							"NZ": "Αριθμός GST"
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Είναι η επιχείρησή σας εγγεγραμμένη για ΑΦΜ;",
						"managed": "Είναι αυτή η επιχείρηση εγγεγραμμένη για ΑΦΜ;"
					},
					"subtitle": {
						"unmanaged": "Εάν έχετε ΑΦΜ, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
						"managed": "Χρησιμοποιούμε τον ΑΦΜ για την επαλήθευση των στοιχείων της εταιρείας."
					},
					"form_title": {
						"unmanaged": "Καταχωρίστε τον ΑΦΜ σας",
						"managed": "Καταχωρίστε τον ΑΦΜ"
					},
					"vat_id": {
						"label": {
							"default": "ΑΦΜ",
							"NZ": "Αριθμός GST"
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Ποια είναι η διεύθυνση της επιχείρησής σας;",
						"managed": "Ποια είναι η επιχειρηματική διεύθυνση της εταιρείας;"
					},
					"subtitle": {
						"unmanaged": "Πρέπει να γνωρίζουμε την τοποθεσία της επιχείρησής σας.",
						"managed": "Πρέπει να γνωρίζουμε την τοποθεσία της επιχείρησης."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"fields": {
						"partnership_name": {
							"label": "Όνομα συνεταιρισμού",
							"errors": {
								"general": "Καταχωρίστε ένα όνομα συνεταιρισμού"
							}
						},
						"street": {
							"label": "Διεύθυνση",
							"errors": {
								"general": "Καταχωρίστε μια έγκυρη διεύθυνση"
							}
						},
						"postal_code": {
							"label": "Ταχυδρομικός κώδικας",
							"errors": {
								"general": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
							}
						},
						"city": {
							"label": "Πόλη",
							"errors": {
								"general": "Καταχωρίστε μια έγκυρη πόλη"
							}
						},
						"country": {
							"label": "Χώρα",
							"errors": {
								"general": "Καταχωρίστε μια έγκυρη χώρα"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Ποιος είναι ο ιδιοκτήτης της εταιρείας;",
						"GB": "Ποιος διοικεί την εταιρεία;"
					},
					"subtitle": {
						"default": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					},
					"infobox": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας όλων των συνεργατών και των εντολέων που ασκούν έλεγχο στη διοίκηση της εταιρείας σας.",
					"buttons": {
						"add_person": "+ Προσθήκη ατόμου",
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"payouts_summary": {
					"title": "Τραπεζικοί λογαριασμοί",
					"default_bank_accounts": {
						"no_elements": "Δεν υπάρχει διαθέσιμος προεπιλεγμένος τραπεζικός λογαριασμός"
					},
					"additional_bank_accounts": {
						"no_elements": "Δεν υποβάλατε επιπλέον τραπεζικούς λογαριασμούς"
					}
				},
				"pre_assessment_company_details": {
					"title": "Συμπληρώστε περισσότερες λεπτομέρειες ευκαιρίας.",
					"subtitle": "Παρέχετέ μας μερίδιο του όγκου της κάρτας και τα στοιχεία της εταιρείας για αυτόν τον έμπορο. Επίσης, προσδιορίστε εάν η εταιρεία δραστηριοποιείται από άλλη αγορά εκτός της χώρας εγγραφής, καθώς αυτό απαιτείται για την εκτίμηση κινδύνων.",
					"fields": {
						"volume_by_card": {
							"label": "Μερίδιο του όγκου της κάρτας από τον συνολικό όγκο (%)",
							"errors": {
								"invalid": "Ο όγκος της κάρτας πρέπει να είναι ένας αριθμός μεταξύ 0 και 100",
								"invalid_hint": "Προσθέστε το μερίδιο του όγκου των συναλλαγών με κάρτα από τον συνολικό όγκο της Klarna για αυτή την ευκαιρία. Καταχωρίστε 0% εάν η ευκαιρία σας δεν έχει πληρωμές με κάρτα"
							}
						},
						"average_order_value": {
							"label": "Μέση αξία παραγγελίας (σε SEK)",
							"tooltip": "Θα πρέπει να είναι ένα θετικό ποσό σε SEK",
							"errors": {
								"invalid": "Θα πρέπει να είναι ένα θετικό ποσό σε SEK"
							}
						},
						"registration_country": {
							"label": "Χώρα εγγραφής",
							"errors": {
								"required": "Απαιτείται χώρα εγγραφής"
							}
						},
						"operating_country": {
							"label": "Χώρα λειτουργίας",
							"errors": {
								"required": "Απαιτείται χώρα λειτουργίας"
							}
						},
						"registration_number": {
							"label": {
								"default": "Αριθμός εγγραφής (απαιτείται για εγγεγραμμένες εταιρείες)",
								"AU": "ACN (απαιτείται για εγγεγραμμένες εταιρείες)",
								"ES": "NIF/NIE/DNI εταιρείας (απαιτείται για εγγεγραμμένες εταιρείες)",
								"GR": "Γ.Ε.ΜΗ. (απαιτείται για εγγεγραμμένες εταιρείες)",
								"NZ": "Αριθμός επιχείρησης (απαιτείται για εγγεγραμμένες εταιρείες)",
								"US": "TIN/EIN (απαιτείται για εγγεγραμμένες εταιρείες)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Καταχωρίστε ACN ή ABN",
								"invalid": "Το ABN πρέπει να αποτελείται από 11 ψηφία"
							}
						},
						"registration_authority": {
							"label": "Αρχή εγγραφής",
							"errors": {
								"required": "Επιλέξτε την αρχή εγγραφής σας"
							}
						},
						"company_name": {
							"label": "Επωνυμία νομικής οντότητας",
							"errors": {
								"required": "Απαιτείται η επωνυμία νομικής οντότητας"
							}
						},
						"sales_contact": {
							"label": "Email αντιπροσώπου πωλήσεων",
							"errors": {
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση email"
							}
						},
						"store_url": {
							"label": "Διεύθυνση URL καταστήματος",
							"errors": {
								"required": "Απαιτείται URL καταστήματος",
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση URL ιστότοπου"
							}
						},
						"goods_category": {
							"label": "Κύρια κατηγορία αγαθών που πωλούνται",
							"errors": {
								"invalid": "Πρέπει να επιλέξετε μία από τις επιλογές"
							}
						},
						"is_managed": {
							"label": "Η διαχειριζόμενη ανάρτηση θα προβληθεί;"
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"pre_assessment_products": {
					"title": "Αναφέρετε όλα τα προϊόντα",
					"subtitle": "Για την εκτίμηση κινδύνων, απαιτούνται όλα τα προϊόντα ανά χώρα πώλησης",
					"select": {
						"label": "Αναζήτηση προϊόντος"
					},
					"selected": {
						"label": "Επιλεγμένα προϊόντα:"
					},
					"clear": "Διαγραφή όλων",
					"errors": {
						"invalid": "Θα πρέπει να επιλεγεί τουλάχιστον ένα προϊόν ανά χώρα"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "Στο κατάστημα",
						"TELESALES": "Τηλεπωλήσεις",
						"SELLER_APP": "Εφαρμογή πωλητή"
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"wrong_prefill_data": {
					"title": "Παρασχέθηκαν μη έγκυρα δεδομένα",
					"subtitle": "Παρασχέθηκαν μη έγκυρες ή μη συμβατές πληροφορίες προσυμπλήρωσης από το Δυναμικό Πωλήσεων.",
					"details": "Στοιχεία: ",
					"fields": {
						"goodsCategory": "Κατηγορία αγαθών",
						"paymentInterval": "Συχνότητα πληρωμών",
						"paymentDelay": "Καθυστέρηση πληρωμής",
						"registrationCountry": "Χώρα εγγραφής",
						"storeUrl": "Διεύθυνση URL καταστήματος",
						"mainSellingCountry": "Κύρια χώρα πώλησης",
						"products": "Προϊόντα",
						"products_item": "Προϊόν {index}",
						"products_item_yearlyAcquiredVolume": "Ο ετήσιος αποκτώμενος όγκος {index} προϊόντος",
						"products_item_sellingCountry": "Η χώρα πώλησης {index} προϊόντος",
						"products_item_productName": "Το όνομα {index} προϊόντος",
						"products_item_channels": "Τα κανάλια {index} προϊόντος",
						"products_item_channels_item": "Το κανάλι {index} προϊόντος"
					},
					"error_types": {
						"fallback": "δεν είναι έγκυρο",
						"any": {
							"required": "απαιτείται και δεν παρέχεται κανένα"
						}
					}
				},
				"selling_countries": {
					"title": "Αναφέρετε όλες τις χώρες πώλησης",
					"subtitle": "Ο πλήρης κατάλογος των χωρών απαιτείται για την εκτίμηση κινδύνων",
					"select": {
						"label": "Αναζήτηση χώρας"
					},
					"selected": {
						"label": "Επιλεγμένες χώρες:"
					},
					"fields": {
						"selling_countries": {
							"label": "Επιλογή χώρας",
							"errors": {
								"invalid": "Πρέπει να επιλέξετε τουλάχιστον μία χώρα"
							}
						}
					},
					"clear": "Διαγραφή όλων",
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"main_selling_country": {
					"title": "Ποια είναι η κύρια αγορά Klarna για τον έμπορο;",
					"subtitle": "Επιλέξτε την αγορά με τον υψηλότερο αναμενόμενο όγκο Klarna",
					"errors": {
						"invalid": "Πρέπει να επιλέξετε χώρα"
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"fca_number": {
					"title": "Καταχωρίστε τον αριθμό FCA",
					"subtitle": "Είμαστε νομικά υποχρεωμένοι να επαληθεύσουμε την άδεια μεσίτη πιστώσεων.",
					"fields": {
						"fca_number": {
							"label": "Αριθμός FCA",
							"errors": {
								"general": "Καταχωρίστε έναν έγκυρο αριθμό FCA"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"sole_trader": {
					"title": "Ποιος είναι ο ιδιοκτήτης της εταιρείας;",
					"subtitle": {
						"default": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					},
					"infobox": {
						"unmanaged": "Καταχωρίστε τα προσωπικά σας στοιχεία και τη διεύθυνση κατοικίας.",
						"managed": "Καταχωρίστε τα στοιχεία του ιδιοκτήτη και τη διεύθυνση κατοικίας."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Το άτομο που υποβάλλει την αίτηση είναι το ίδιο με τον ατομικό έμπορο",
							"error": "Λυπούμαστε, αλλά μπορείτε να συνεχίσετε μόνο εάν εσείς ως ατομικός έμπορος υποβάλετε αυτή την αίτηση."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Δραστηριοποιήστε από διαφορετική διεύθυνση;",
								"managed": "Δραστηριοποιείται αυτή η εταιρεία από διαφορετική διεύθυνση;"
							},
							"subtitle": {
								"unmanaged": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται η επιχείρησή σας από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας σας.",
								"managed": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται αυτή η εταιρεία από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας του ατομικού εμπόρου."
							}
						},
						"title": "Καταχωρίστε τη διεύθυνση της επιχείρησης",
						"fields": {
							"street": {
								"label": "Διεύθυνση",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη διεύθυνση"
								}
							},
							"postal_code": {
								"label": "Ταχυδρομικός κώδικας",
								"errors": {
									"general": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
								}
							},
							"city": {
								"label": "Πόλη",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη πόλη"
								}
							},
							"country": {
								"label": "Χώρα",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη χώρα"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Μπορείτε να επιβεβαιώσετε δύο ακόμη πράγματα;",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Είστε ο ατομικός έμπορος",
							"label": "Το άτομο που υποβάλλει την αίτηση είναι το ίδιο με τον ατομικό έμπορο"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Μόνο εσείς ελέγχετε τα οικονομικά",
							"label": "Ο ιδιοκτήτης είναι το μόνο άτομο που ελέγχει τα οικονομικά στους τραπεζικούς λογαριασμούς της επιχείρησής σας"
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"robot_message": "Λυπούμαστε, αλλά πρέπει να επιβεβαιώσουμε αυτά τα δύο πράγματα"
				},
				"underwriting_info": {
					"title": "Προσδιορίστε τον όγκο και την καθυστέρηση πληρωμής της ευκαιρίας",
					"subtitle": "Αναφέρετε τον συνολικό αναμενόμενο ετήσιο όγκο Klarna για αυτήν την ευκαιρία για όλες τις αγορές και την καθυστέρηση πληρωμής. Σε περίπτωση που η καθυστέρηση πληρωμής διαφέρει ανά χώρα, χρησιμοποιήστε την επιλεγμένη κύρια χώρα πώλησης.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Συνολικός ετήσιος όγκος αγοράς (σε SEK)",
							"errors": {
								"invalid": "Ο συνολικός ετήσιος όγκος αγοράς θα πρέπει να είναι ένα θετικό ποσό σε SEK",
								"too_long": "Ο Ο συνολικός ετήσιος όγκος αγοράς δεν μπορεί να έχει περισσότερα από 16 ψηφία"
							}
						},
						"payment_delay": {
							"label": "Καθυστέρηση πληρωμής",
							"errors": {
								"general": "Καταχωρίστε μια τιμή καθυστέρησης πληρωμής",
								"invalid": "Η καθυστέρηση πληρωμής πρέπει να είναι ένας αριθμός μεταξύ {min} και {max}"
							}
						},
						"payment_interval": {
							"label": "Συχνότητα πληρωμών",
							"errors": {
								"invalid": "Πρέπει να επιλέξετε μία από τις επιλογές"
							}
						},
						"volume_by_card": {
							"label": "Μερίδιο ολοκλήρωσης αγορών (%)",
							"errors": {
								"invalid": "Το μερίδιο ολοκλήρωσης αγορών πρέπει να είναι ένας αριθμός μεταξύ 0 και 100",
								"invalid_hint": "Προσθέστε το μερίδιο του όγκου των συναλλαγών με κάρτα από τον συνολικό όγκο της Klarna για αυτή την ευκαιρία. Καταχωρίστε 0% εάν η ευκαιρία σας δεν έχει πληρωμές με κάρτα"
							}
						},
						"average_order_value": {
							"label": "Μέση αξία παραγγελίας (σε SEK)"
						}
					},
					"buttons": {
						"back": "Επιστροφή",
						"next": "Επόμενο"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Ποια είναι τα στοιχεία του καταστήματός σας;"
						},
						"managed": "Ποια είναι τα στοιχεία του καταστήματος;"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Θα χρησιμοποιήσουμε τις πληροφορίες για τη δημιουργία του επιχειρηματικού σας λογαριασμού.",
							"default": "Θα χρησιμοποιήσουμε τα στοιχεία που παρασχέθηκαν ως κύρια στοιχεία επικοινωνίας και για να ρίξουμε μια ματιά στο κατάστημά σας."
						},
						"managed": "Θα χρησιμοποιήσουμε τα στοιχεία που παρασχέθηκαν ως κύρια στοιχεία επικοινωνίας για καταναλωτές και για να ρίξουμε μια ματιά στο κατάστημα."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Επωνυμία / DBA",
								"MX": "Επωνυμία / DBA",
								"US": "Επωνυμία / DBA",
								"default": "Όνομα καταστήματος"
							},
							"errors": {
								"required": "Απαιτείται όνομα καταστήματος",
								"required_us": "Απαιτείται επωνυμία / DBA",
								"invalid": "Καταχωρίστε ένα όνομα καταστήματος με τουλάχιστον 2 χαρακτήρες",
								"invalid_us": "Καταχωρίστε μια επωνυμία / DBA με τουλάχιστον 2 χαρακτήρες",
								"invalid_characters": "Το όνομα καταστήματος δεν μπορεί να περιέχει τους ακόλουθους χαρακτήρες: < >",
								"invalid_characters_us": "Το όνομα επωνυμίας / DBA δεν μπορεί να περιέχει τους ακόλουθους χαρακτήρες: < >"
							}
						},
						"website": {
							"label": "Ιστότοπος online καταστήματος",
							"errors": {
								"required": "Απαιτείται ιστότοπος",
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση URL ιστότοπου"
							}
						},
						"goods_category": {
							"label": "Κύρια κατηγορία αγαθών που πωλούνται",
							"errors": {
								"required": "Απαιτείται κατηγορία αγαθών"
							}
						},
						"email": {
							"label": "Διεύθυνση email της υποστήριξης πελατών",
							"errors": {
								"required": "Απαιτείται διεύθυνση email της υποστήριξης πελατών",
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση email"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Αλλαγή προϊόντων"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Ποια είναι η εγγεγραμμένη διεύθυνση της επιχείρησή σας;",
						"managed": "Ποια είναι η εγγεγραμμένη επιχειρηματική διεύθυνση της εταιρείας;"
					},
					"subtitle": {
						"unmanaged": "Πρέπει να γνωρίζουμε σε ποια διεύθυνση είναι εγγεγραμμένη η επιχείρησή σας.",
						"managed": "Πρέπει να γνωρίζουμε σε ποια διεύθυνση είναι εγγεγραμμένη η επιχείρηση."
					},
					"question": {
						"title": {
							"unmanaged": "Δραστηριοποιήστε από διαφορετική διεύθυνση;",
							"managed": "Δραστηριοποιείται αυτή η εταιρεία από διαφορετική διεύθυνση;"
						},
						"subtitle": {
							"unmanaged": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται η επιχείρησή σας από άλλη διεύθυνση εκτός της εγγεγραμμένης επιχειρηματικής διεύθυνσης.",
							"managed": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται αυτή η εταιρεία από άλλη διεύθυνση εκτός της εγγεγραμμένης επιχειρηματικής διεύθυνσης."
						}
					},
					"toggle": {
						"title": "Προσθέστε τη διεύθυνση του κύριου τόπου επιχειρηματικής δραστηριότητας"
					},
					"fields": {
						"company_name": {
							"label": "Νομική επωνυμία της εταιρείας",
							"errors": {
								"general": "Καταχωρίστε μια επωνυμία εταιρείας"
							}
						},
						"street": {
							"label": "Διεύθυνση",
							"errors": {
								"general": "Καταχωρίστε μια διεύθυνση"
							}
						},
						"postal_code": {
							"label": "Ταχυδρομικός κώδικας",
							"errors": {
								"general": "Καταχωρίστε έναν ταχυδρομικό κώδικα"
							}
						},
						"city": {
							"label": "Πόλη",
							"errors": {
								"general": "Καταχωρίστε μια πόλη"
							}
						},
						"country": {
							"label": "Χώρα",
							"errors": {
								"general": "Καταχωρίστε μια χώρα"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"messages": {
						"lookup": "Αυτή είναι η εταιρεία σας; Ρίξτε μια ματιά και επιβεβαιώστε αν είναι σωστά."
					}
				},
				"uk_sole_trader": {
					"title": "Ποιος είναι ο ιδιοκτήτης αυτής της εταιρείας;",
					"subtitle": {
						"unmanaged": "Πρόκειται να συνάψετε σύμβαση με την Klarna. Επομένως, πρέπει να συλλέξουμε τα προσωπικά σας στοιχεία.",
						"managed": "Είμαστε υποχρεωμένοι να συλλέγουμε και να επαληθεύουμε τα προσωπικά στοιχεία του ιδιοκτήτη."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Δραστηριοποιήστε από διαφορετική διεύθυνση;",
								"managed": "Δραστηριοποιείται αυτή η εταιρεία από διαφορετική διεύθυνση;"
							},
							"subtitle": {
								"unmanaged": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται η επιχείρησή σας από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας σας.",
								"managed": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται αυτή η εταιρεία από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας του ατομικού εμπόρου."
							}
						},
						"title": "Καταχωρίστε τη διεύθυνση της επιχείρησης",
						"fields": {
							"street": {
								"label": "Διεύθυνση",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη διεύθυνση"
								}
							},
							"postal_code": {
								"label": "Ταχυδρομικός κώδικας",
								"errors": {
									"general": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
								}
							},
							"city": {
								"label": "Πόλη",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη πόλη"
								}
							},
							"country": {
								"label": "Χώρα",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη χώρα"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Ποιος είναι ο ιδιοκτήτης της εταιρείας;",
					"subtitle": {
						"default": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
					},
					"infobox": {
						"unmanaged": "Καταχωρίστε τα προσωπικά σας στοιχεία και τη διεύθυνση κατοικίας.",
						"managed": "Καταχωρίστε τα στοιχεία του ιδιοκτήτη και τη διεύθυνση κατοικίας."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Δραστηριοποιήστε από διαφορετική διεύθυνση;",
								"managed": "Δραστηριοποιείται αυτή η εταιρεία από διαφορετική διεύθυνση;"
							},
							"subtitle": {
								"unmanaged": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται η επιχείρησή σας από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας σας.",
								"managed": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται αυτή η εταιρεία από άλλη διεύθυνση εκτός της διεύθυνσης κατοικίας του ατομικού εμπόρου."
							}
						},
						"title": "Καταχωρίστε τη διεύθυνση της επιχείρησης",
						"fields": {
							"street": {
								"label": "Διεύθυνση",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη διεύθυνση"
								}
							},
							"postal_code": {
								"label": "Ταχυδρομικός κώδικας",
								"errors": {
									"general": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
								}
							},
							"city": {
								"label": "Πόλη",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη πόλη"
								}
							},
							"country": {
								"label": "Χώρα",
								"errors": {
									"general": "Καταχωρίστε μια έγκυρη χώρα"
								}
							},
							"region": {
								"label": "Πολιτεία",
								"errors": {
									"general": "Καταχωρίστε μια πολιτεία"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Υπάρχουν άτομα που κατέχουν περισσότερο από το 25% της εταιρείας;"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"default": [
							{
								"text": "Πρέπει να γνωρίζουμε τα άτομα που κατέχουν περισσότερο από το 25% των μετοχών ή των δικαιωμάτων ψήφου της εταιρείας ή που ασκούν παρόμοιο έλεγχο. Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					},
					"infobox": {
						"default": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας κάθε ατόμου.",
						"AU": "Καταχωρίστε τα προσωπικά στοιχεία και τη διεύθυνση κατοικίας κάθε ατόμου. Αυτά πρέπει να είναι φυσικά πρόσωπα για εταιρείες με πολύπλοκες ιδιοκτησιακές δομές."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή",
						"add_person": "+ Προσθήκη ατόμου"
					},
					"messages": {
						"lookup": "Κατέχουν αυτά τα άτομα περισσότερο από το 25% της εταιρείας σας; Ρίξτε μια ματιά και επιβεβαιώστε αν είναι σωστά."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Ποια είναι η διεύθυνση της επιχείρησής σας;",
						"managed": "Ποια είναι η εγγεγραμμένη επιχειρηματική διεύθυνση της εταιρείας;"
					},
					"subtitle": {
						"unmanaged": "Εδώ είναι νομίμως εγγεγραμμένη η επιχείρησή σας και θα εμφανίζεται στα τιμολόγια πελατών της Klarna.",
						"managed": "Πρέπει να γνωρίζουμε σε ποια διεύθυνση είναι εγγεγραμμένη η επιχείρηση."
					},
					"question": {
						"title": {
							"unmanaged": "Δραστηριοποιήστε από διαφορετική διεύθυνση;",
							"managed": "Δραστηριοποιείται αυτή η εταιρεία από διαφορετική διεύθυνση;"
						},
						"subtitle": {
							"unmanaged": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται η επιχείρησή σας από άλλη διεύθυνση εκτός της εγγεγραμμένης επιχειρηματικής διεύθυνσης.",
							"managed": "Επιλέξτε Ναι μόνο εάν δραστηριοποιείται αυτή η εταιρεία από άλλη διεύθυνση εκτός της εγγεγραμμένης επιχειρηματικής διεύθυνσης."
						}
					},
					"toggle": {
						"title": "Προσθέστε τη διεύθυνση του κύριου τόπου επιχειρηματικής δραστηριότητας"
					},
					"fields": {
						"company_name": {
							"label": "Εγγεγραμμένη επωνυμία εταιρείας",
							"errors": {
								"general": "Καταχωρίστε μια επωνυμία εταιρείας"
							}
						},
						"street": {
							"label": "Διεύθυνση",
							"errors": {
								"general": "Καταχωρίστε μια διεύθυνση"
							}
						},
						"postal_code": {
							"label": "Ταχυδρομικός κώδικας",
							"errors": {
								"general": "Καταχωρίστε έναν ταχυδρομικό κώδικα"
							}
						},
						"city": {
							"label": "Πόλη",
							"errors": {
								"general": "Καταχωρίστε μια πόλη"
							}
						},
						"country": {
							"label": "Χώρα",
							"errors": {
								"general": "Καταχωρίστε μια χώρα"
							}
						},
						"state_of_incorporation": {
							"label": "Πολιτεία σύστασης",
							"errors": {
								"general": "Καταχωρίστε μια πολιτεία σύστασης"
							}
						},
						"state": {
							"label": "Πολιτεία",
							"errors": {
								"general": "Καταχωρίστε μια πολιτεία"
							}
						},
						"region": {
							"label": "Περιοχή",
							"errors": {
								"puerto_rico": "Μη επιτρεπόμενα στο Πουέρτο Ρίκο"
							}
						}
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"select_products": {
					"title": "Οι υπηρεσίες μας",
					"title_kco_hidden": "Μέθοδοι πληρωμής που αυξάνουν τις πωλήσεις.",
					"subtitle": "Επιλέξτε τις υπηρεσίες που σας ενδιαφέρουν.",
					"subtitle_kco_hidden": "«Ξεκλειδώστε» την αγοραστική δύναμη του πελάτη σας. Προσφέρετε περισσότερες επιλογές πληρωμής, ώστε να μπορούν να αποφασίσουν εκείνοι πότε και πώς να πληρώσουν.",
					"platform_alert": null,
					"buttons": {
						"next": "Επόμενο"
					}
				},
				"signup_products": {
					"title_line_1": "Προϊόντα Klarna για το κατάστημά σας.",
					"title_kco_hidden_line_1": "Μέθοδοι πληρωμής που",
					"title_kco_hidden_line_2": "αυξάνουν τις πωλήσεις.",
					"subtitle": "Η προσφορά των μεθόδων πληρωμής Klarna οδηγεί σε μια μέση αύξηση κατά 30% στο conversion rate, 41% στη μέση αξία παραγγελίας (AOV) και 36% στη συχνότητα αγορών.",
					"subtitle_kco_hidden": "«Ξεκλειδώστε» την αγοραστική δύναμη του πελάτη σας. Προσφέρετε περισσότερες επιλογές πληρωμής, ώστε να μπορούν να αποφασίσουν εκείνοι πότε και πώς να πληρώσουν.",
					"info_block": "Εμφάνιση διαθέσιμων προϊόντων για",
					"special_offer": "Ειδική προσφορά: {percentageFee}% + {fixedFee} ανά συναλλαγή. Ισχύει έως {validUntil}.",
					"buttons": {
						"contact_sales": "Επικοινωνήστε με το τμήμα πωλήσεων",
						"next": "Δημιουργία λογαριασμού",
						"back": "Επιστροφή"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Επιστροφή",
						"next": "Επόμενο"
					}
				},
				"business_concepts": {
					"title": "Επιλέξτε τις ισχύουσες επιχειρηματικές ιδέες.",
					"subtitle": "Επιλέξτε μόνο αυτά που ισχύουν. Αυτά μπορεί να είναι πολλά.",
					"errors": {
						"select_at_least_one": "Επιλέξτε τουλάχιστον μία επιχειρηματική ιδέα."
					},
					"buttons": {
						"next": "Επόμενο",
						"back": "Επιστροφή"
					}
				},
				"confirm_copy": {
					"title": "Επιβεβαίωση αντιγραφής",
					"disclaimer": "Οποιεσδήποτε υπάρχουσες πληροφορίες στο τρέχον MID θα αντικατασταθούν με δεδομένα από ",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Όχι αντιγραφή",
						"confirmCopy": "Αντιγραφή δεδομένων"
					}
				},
				"pre_assessment_summary": {
					"title": "Σύνοψη",
					"subtitle": "Ελέγξτε προσεκτικά τα δεδομένα πριν την υποβολή για ασφαλιστική κάλυψη",
					"banner": {
						"mcc_deal": "Αυτή είναι μια συμφωνία MCC, ακολουθήστε τη ρουτίνα κλιμάκωσης MCC / ECC"
					},
					"selling_countries": {
						"title": "Επιλέξτε την αγορά με τον υψηλότερο αναμενόμενο όγκο.",
						"main_selling_country": "Κύρια χώρα πώλησης"
					},
					"pre_assessment_products": {
						"title": "Προϊόντα"
					},
					"company_details": {
						"title": "Στοιχεία εταιρείας"
					},
					"fca_number": {
						"title": "Αριθμός FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Ερωτηματολόγια υψηλής έκθεσης"
					},
					"mia_questionnaires": {
						"title": "Ερωτηματολόγια MIA"
					},
					"buttons": {
						"back": "Επιστροφή",
						"edit": "Επεξεργασία",
						"submit": "Υποβολή"
					}
				},
				"pre_assessment_overview": {
					"title": "Επισκόπηση προαξιολόγησης",
					"subtitle_APPROVED": "Βρείτε τους εγκεκριμένους όρους για αυτήν την ευκαιρία παρακάτω.",
					"subtitle_REJECTED": "Βρείτε τους όρους που απορρίφθηκαν για αυτήν την ευκαιρία παρακάτω.",
					"subtitle_UNRESOLVED": "Μπορείτε να τροποποιήσετε τις υποβληθείσες πληροφορίες σε περίπτωση που εντοπίσετε λάθη. Αυτό δεν προκαλεί άνοιγμα νέας υπόθεσης.",
					"status": {
						"APPROVED": "Η υπόθεση εγκρίθηκε",
						"REJECTED": "Η υπόθεση απορρίφθηκε",
						"UNRESOLVED": "Αναμονή απόφασης για ασφαλιστική κάλυψη...",
						"UNRESOLVED_TIMED_OUT": "Η υπόθεση θα περάσει από μη αυτόματο έλεγχο ασφαλιστικής κάλυψης. Λάβετε υπόψη ότι αυτό μπορεί να διαρκέσει αρκετές ημέρες.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Δείτε την υπόθεση στο GUI της Κριτικής Εμπόρου",
						"STARTED": "Η υπόθεση υποβάλλεται για έλεγχο"
					},
					"buttons": {
						"change": "Αλλαγή",
						"new_case": "Νέα υπόθεση"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Γεια σας!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Ως ελεγχόμενη εταιρεία υπό την εποπτεία της Αρχής Χρηματοοικονομικής Εποπτείας της Σουηδίας, η Klarna υποχρεούται να αποτρέπει τη νομιμοποίηση εσόδων από παράνομες δραστηριότητες όπως ορίζεται στην οδηγία ΕΕ 2015/849 (όπως τροποποιήθηκε ή αντικαταστάθηκε). Για εσάς ως έμπορο, η οδηγία σημαίνει ότι η Klarna θα συλλέξει πληροφορίες σχετικά με τα άτομα που ελέγχουν την εταιρεία σας (πραγματικοί ιδιοκτήτες) προτού αρχίσετε να χρησιμοποιείτε τις υπηρεσίες της Klarna. Οι υφιστάμενοι έμποροι παρέχουν αυτές τις πληροφορίες σε τακτική βάση ώστε να διασφαλίζεται ότι είναι ενημερωμένες. Μπορείτε να βρείτε περισσότερες πληροφορίες στην οδηγία της ΕΕ "
							},
							{
								"text": "εδώ",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Επόμενο"
					}
				},
				"recollection_confirmation": {
					"title": "Επιβεβαίωση",
					"subtitle": "Ελέγξτε προσεκτικά τα δεδομένα πριν την υποβολή για ασφαλιστική κάλυψη",
					"stakeholder": "Ενδιαφερόμενο μέρος {index}",
					"buttons": {
						"back": "Επιστροφή",
						"submit": "Υποβολή"
					}
				},
				"recollection_overview": {
					"title": "Σας ευχαριστούμε!",
					"subtitle": "Ακολουθεί μια επισκόπηση των πληροφοριών που υποβάλατε.",
					"stakeholder": "Ενδιαφερόμενο μέρος {index}",
					"notice": "Τα στοιχεία σας υποβλήθηκαν με επιτυχία."
				},
				"volume_separation": {
					"title_line_1": "Ποιο είναι το μέγεθος της online επιχείρησής σας;",
					"subtitle": "Η Klarna είναι εξοπλισμένη με τις καλύτερες λύσεις που ταιριάζουν στην επιχείρησή σας — ανεξάρτητα από το μέγεθος.",
					"selector_title": "Ετήσια έσοδα",
					"below": "Κάτω από {threshold}",
					"between": "Μεταξύ {belowThreshold} και {aboveThreshold}",
					"over": "Πάνω από {threshold}",
					"buttons": {
						"back": "Επιστροφή"
					}
				},
				"basic_info": {
					"title_line_1": "Ξεκινήστε τη συνεργασία σας",
					"title_line_2": "με την Klarna.",
					"subtitle": "Χρειαζόμαστε κάποιες βασικές πληροφορίες για να σας οδηγήσουμε στο σωστό μέρος.",
					"fields": {
						"email": {
							"label": "Διεύθυνση email επιχείρησης",
							"field_link": "Δεν είστε επιχείρηση;",
							"errors": {
								"required": "Απαιτείται διεύθυνση email",
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση email"
							}
						},
						"email_confirmation": {
							"label": "Επιβεβαίωση επιχειρηματικής διεύθυνσης email",
							"tooltip": "Η διεύθυνση email της επιχείρησής σας θα είναι ο κύριος τρόπος επικοινωνίας με την Klarna. Βεβαιωθείτε ότι είναι σωστή",
							"errors": {
								"required": "Απαιτείται επιβεβαίωση της διεύθυνσης email",
								"invalid": "Βεβαιωθείτε ότι έχετε καταχωρίσει την ίδια διεύθυνση email δύο φορές"
							}
						},
						"website": {
							"label": "Διεύθυνση URL ηλεκτρονικού εμπορίου",
							"errors": {
								"required": "Απαιτείται διεύθυνση URL ηλεκτρονικού εμπορίου",
								"invalid": "Καταχωρίστε μια έγκυρη διεύθυνση URL"
							}
						},
						"country": {
							"label": "Χώρα εγγραφής",
							"errors": {
								"general": "Επιλέξτε μία από τις διαθέσιμες χώρες"
							}
						}
					},
					"buttons": {
						"continue": "Συνέχεια"
					}
				},
				"contact_details": {
					"title_line_1": "Ας συνομιλήσουμε.",
					"subtitle": "Συμπληρώστε αυτή τη φόρμα και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό με λύσεις προσαρμοσμένες στην επιχείρησή σας.",
					"fields": {
						"full_name": {
							"label": "Ονοματεπώνυμο",
							"errors": {
								"required": "Απαιτείται ονοματεπώνυμο"
							}
						},
						"phone": {
							"label": "Αριθμός τηλεφώνου",
							"tooltip": "Πρέπει να συμπεριλάβετε τον κωδικό χώρας, π.χ. +1 541 754 3010",
							"errors": {
								"required": "Απαιτείται αριθμός τηλεφώνου",
								"invalid": "Μη έγκυρος αριθμός τηλεφώνου"
							}
						},
						"tell_us_more": {
							"label": "Πείτε μας περισσότερα για την επιχείρησή σας (προαιρετικό)"
						}
					},
					"buttons": {
						"back": "Επιστροφή",
						"submit": "Υποβολή στοιχείων επικοινωνίας"
					}
				},
				"contact_received": {
					"title": "Θα τα πούμε σύντομα!",
					"message_1": "Το τμήμα πωλήσεων θα επικοινωνήσει μαζί σας το συντομότερο δυνατό.",
					"message_2": "Η ομάδα μας θα επικοινωνήσει μαζί σας το συντομότερο δυνατό. Έχουμε στείλει επίσης μια επιβεβαίωση των πληροφοριών που υποβάλατε στο "
				},
				"we_are_sorry": {
					"title": "Λυπούμαστε πολυ. Δεν μπορούμε να εγκρίνουμε την αίτησή σας σε αυτό το σημείο.",
					"message_1_unsupported_country": "Αυτή τη στιγμή, η Klarna δεν υποστηρίζει τη χώρα που επιλέξατε:",
					"message_1_sensitive_goods": "Η Klarna δεν υποστηρίζει τις επιλεγμένες κατηγορίες αγαθών:",
					"message_1_platform": "Η Klarna δεν υποστηρίζει την επιλεγμένη e-commerce πλατφόρμα:",
					"message_2": "Πάντοτε προσπαθούμε να δημιουργήσουμε νέες συνεργασίες, οπότε θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατόν ώστε να προχωρήσουμε με την αίτησή σας στο μέλλον.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Μπορείτε να χρησιμοποιήσετε το"
							},
							{
								"text": "πρόσθετο",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "από τη συνεργαζόμενη Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Σε ποια πλατφόρμα βρίσκεστε;",
					"subtitle": "Επιλέξτε την πλατφόρμα ηλεκτρονικού εμπορίου σας και θα ενσωματώσουμε την επιχείρησή σας αμέσως.",
					"custom": "Ενσωμάτωση ιδίας κατασκευής",
					"other_platform": "Άλλες λύσεις ενσωμάτωσης",
					"platform_search": {
						"label": "Πλατφόρμα ηλεκτρονικού εμπορίου",
						"no_match": "Δεν βρέθηκαν αντιστοιχίσεις για «{input}»"
					},
					"buttons": {
						"back": "Επιστροφή"
					}
				},
				"partner": {
					"title_line_1": "Με ποιον εταίρο υπηρεσιών πληρωμής θα θέλατε να συνεργαστείτε;",
					"subtitle": "Επιλέξτε τον εταίρο υπηρεσιών πληρωμής που ταιριάζει καλύτερα στις ανάγκες σας."
				},
				"account_creation_loading": {
					"title": "Δημιουργία λογαριασμού...",
					"message": "Δημιουργία αναγνωριστικού επιχείρησης..."
				},
				"application_checking": {
					"title": "Γίνεται έλεγχος της αιτήσής σας…",
					"message": "Ανάλυση δεδομένων καταστήματος"
				},
				"application_review": {
					"title": "Εξετάζουμε την αίτησή σας.",
					"title_approved": "Η αίτησή σας εγκρίθηκε!",
					"message": "Αυτή είναι μια μη αυτόματη διαδικασία, επομένως, οι χρόνοι χειρισμού μπορεί να διαφέρουν, αλλά θα το κάνουμε όσο το δυνατόν γρηγορότερα.",
					"email_info_1": "Σας έχουμε στείλει ένα email με γραμμή θέματος «{subject}».",
					"email_info_2": "Ακολουθήστε τα βήματα εκεί για να συνδεθείτε και να παρακολουθήσετε την κατάσταση της αίτησής σας.",
					"email_info_2_approved": "Ακολουθήστε τα βήματα εκεί για να συνδεθείτε και να ενσωματώσετε την Klarna στο κατάστημά σας ηλεκτρονικού εμπορίου.",
					"email_subject": "Καλωσορίσατε στην Πύλη Εμπόρων της Klarna",
					"resend_email": "Επαναποστολή email"
				},
				"user_already_exists": {
					"title": "Συνδεθείτε στην Πύλη Εμπόρων για να συνεχίσετε.",
					"message_1": "Αυτή η διεύθυνση email σχετίζεται ήδη με έναν λογαριασμό στην Πύλη Εμπόρων. Για να κάνετε αλλαγές στον υφιστάμενο λογαριασμό σας, συνδεθείτε",
					"log_in": "Συνδεθείτε στην Πύλη Εμπόρων",
					"forgot_password": "Ξεχάσατε τον κωδικό πρόσβασης;"
				},
				"otherPlatform": {
					"info": "Έχουμε ήδη ενσωμάτωση για {platform}",
					"link": "Ξεκινήστε την ενσωμάτωση εδώ",
					"title": "Smoooth, μπορείτε να ενσωματωθείτε απευθείας!",
					"info2": "Καλά νέα! Μπορείτε να ενσωματώσετε την Klarna στο ηλεκτρονικό σας εμπόριο απευθείας από το <strong>{platform}</strong>.",
					"link2": "Μεταβείτε στο {platform} + Ενσωμάτωση Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Επικοινωνήστε απευθείας με το τμήμα πωλήσεων",
							"SE": "Επικοινωνήστε απευθείας με το τμήμα πωλήσεων στο"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Προσφέρετε κάποια από τα ακόλουθα προϊόντα ή υπηρεσίες;",
					"subtitle_2": "Η Klarna ενδέχεται να ορίσει ορισμένα είδη ως περιορισμένα με βάση την αγορά, τους νόμους, τον όγκο πωλήσεων, την ανάληψη κινδύνου και άλλους περιορισμούς που μπορούν να επιτραπούν, τα οποία δεν θα υποβάλλονται σε επεξεργασία χωρίς την έγκριση της Klarna.",
					"titleV2": "Επιλέξτε ποια από τα παρακάτω ισχύουν για την επιχείρησή σας.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Προϊόντα για τα οποία επιβάλλονται περιορισμοί λόγω ηλικίας",
							"description_2": "Καπνός, ηλεκτρονικά τσιγάρα, προϊόντα ατμίσματος, προϊόντα κάνναβης, αλκοόλ, περιεχόμενο για ενήλικες"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Ταξίδια, περιηγήσεις και εκδηλώσεις",
							"description_2": "Μεταφορές, εκδηλώσεις, πλατφόρμα εισιτηρίων, ξενοδοχεία ή διαμονή, ενοικιάσεις, πρακτορεία ταξιδίων"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Αδειοδοτημένα όπλα",
							"description_2": "Πυρομαχικά, μαχαίρια μάχης, εξοπλισμός κυνηγιού, κλομπ, σπρέι πιπεριού"
						},
						"MARKETPLACE": {
							"title_2": "Αγορά peer to peer",
							"description_2": "Υπηρεσίες που επιτρέπουν σε τρίτους να πωλούν εκ νέου αγαθά ή να προσφέρουν υπηρεσίες μέσω της online πλατφόρμας τους"
						},
						"PHARMACEUTICALS": {
							"title_2": "Φαρμακευτικές και ιατρικές υπηρεσίες",
							"description_2": "Διανομή συνταγογραφούμενων φαρμάκων, ιατρικές επεμβάσεις, συμπεριλαμβανομένων αισθητικών και τατουάζ"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Συμμετοχές, συνδρομές και υπηρεσίες",
							"description_2": "Συνδρομή σε υλικά αγαθά, ψηφιακό περιεχόμενο, υπηρεσίες streaming, ιστότοποι γνωριμιών κτλ."
						},
						"NONE": {
							"title_2": "Προσφέρω ένα διαφορετικό προϊόν/υπηρεσία"
						}
					},
					"link": "Περισσότερα για τα υπό περιορισμό προϊόντα",
					"buttons": {
						"next": "Επόμενο",
						"continue": "Συνέχεια"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Καταχωρίστε τον ταχυδρομικό σας κώδικα για να συμπληρώσετε αυτόματα άλλα μέρη της διεύθυνσής σας",
						"US": "Καταχωρίστε τον ταχυδρομικό σας κώδικα για να συμπληρώσετε αυτόματα άλλα μέρη της διεύθυνσής σας"
					},
					"label": {
						"default": "Ταχυδρομικός κώδικας",
						"US": "Ταχ. κώδικας"
					},
					"error": {
						"default": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα",
						"US": "Καταχωρίστε έναν έγκυρο ταχυδρομικό κώδικα"
					}
				},
				"city": {
					"label": "Πόλη",
					"error": "Καταχωρίστε μια πόλη"
				},
				"street": {
					"label": "Διεύθυνση",
					"error": "Καταχωρίστε μια διεύθυνση",
					"tooltip": "Ξεκινήστε να πληκτρολογείτε για να δείτε περισσότερες προτάσεις οδών",
					"no_suggestion_found": "Δεν υπάρχουν αποτελέσματα για {input}"
				},
				"country": {
					"label": "Χώρα",
					"error": "Επιλέξτε μια χώρα"
				},
				"region": {
					"label": "Πολιτεία/περιοχή (προαιρετικό)"
				},
				"state": {
					"label": "Πολιτεία",
					"error": "Καταχωρίστε μια πολιτεία"
				}
			},
			"platforms": {
				"custom": "Ενσωμάτωση API",
				"other": "Δεν μπορώ να βρω την πλατφόρμα μου"
			},
			"buttons": {
				"back": "Επιστροφή"
			},
			"products": {
				"not_available": "Μη διαθέσιμο στο {reason}",
				"not_available_country": "Δεν είναι διαθέσιμο στη χώρα σας",
				"not_available_platform": "Μη διαθέσιμο στο {platform}",
				"why_product": "Γιατί την Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Ολοκλήρωση αγορών"
					},
					"description": {
						"default": "Αντικαταστήστε τη σελίδα πληρωμής του καταστήματός σας με τις ολοκληρωμένες υπηρεσίες πληρωμών της Klarna."
					},
					"description_expanded": {
						"default": "Αντικαταστήστε τη σελίδα πληρωμής του καταστήματός σας με τις ολοκληρωμένες υπηρεσίες πληρωμών της Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Πληρωμή τώρα"
							},
							"description": {
								"default": "Προσφέρετε άμεσες πληρωμές με κάρτα ή τραπεζική μεταφορά."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Πληρωμή σε 30 ημέρες"
							},
							"description": {
								"default": "Προσφέρετε 30 ημέρες για πληρωμή. Άτοκα."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Χρηματοδότηση"
							},
							"description": {
								"default": "Προσφορά για πληρωμή σε διάστημα 6-36 μηνών.",
								"DE": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών",
								"AT": "Προσφορά για πληρωμή σε διάστημα 6-24 μηνών."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 3 άτοκες δόσεις.",
								"GB": "Προσφέρετε 3 άτοκες δόσεις."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Χωρίστε τις σε 4 δόσεις",
								"US": "Δόσεις",
								"AU": "Πληρωμή σε 4 δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 4 άτοκες δόσεις.",
								"GB": "Προσφέρετε 4 άτοκες δόσεις."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Άλλες επιλογές πληρωμής"
							},
							"description": {
								"default": "Πιστωτικές κάρτες, χρεωστικές κάρτες και άλλα"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "On-site messaging"
							}
						},
						"billing": {
							"name": {
								"default": "Αυτόματη αναγνώριση και χρέωση"
							}
						},
						"shipping": {
							"name": {
								"default": "Εξατομικευμένες επιλογές αποστολής"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Υποστήριξη μετά την αγορά"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Μέθοδος πληρωμής"
					},
					"description": {
						"default": "Προσθέστε μεθόδους πληρωμής Klarna στην υπάρχουσα σελίδα πληρωμής σας"
					},
					"description_expanded": {
						"default": "Η προσφορά των μεθόδων πληρωμής Klarna οδηγεί σε μια μέση αύξηση κατά 30% στο conversion rate, 41% στη μέση αξία παραγγελίας (AOV) και 36% στη συχνότητα αγορών."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Πληρωμή τώρα"
							},
							"description": {
								"default": "Προσφέρετε άμεσες πληρωμές με κάρτα ή τραπεζική μεταφορά."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Πληρωμή σε 30 ημέρες"
							},
							"description": {
								"default": "Οι πελάτες πληρώνουν 30 ημέρες μετά την αγορά, χωρίς τόκο."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Χρηματοδότηση"
							},
							"description": {
								"default": "Οι πελάτες μπορούν να πληρώσουν σε 6-36 μήνες.",
								"DE": "Οι πελάτες μπορούν να πληρώσουν σε 6-24 μήνες",
								"AT": "Οι πελάτες μπορούν να πληρώσουν σε 6-24 μήνες."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 3 άτοκες δόσεις.",
								"GB": "Προσφέρετε 3 άτοκες δόσεις."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Χωρίστε τις σε 4 δόσεις",
								"US": "4 Πληρωμές",
								"CA": "4 πληρωμές",
								"AU": "Πληρωμή σε 4 δόσεις"
							},
							"description": {
								"default": "Προσφέρετε 4 άτοκες δόσεις.",
								"GB": "Προσφέρετε 4 άτοκες δόσεις.",
								"US": "Οι παραγγελίες από 35 $ έως 1000 $ μπορούν να χωριστούν σε 4 άτοκες πληρωμές, που οφείλονται κάθε 2 εβδομάδες.",
								"CA": "Οι παραγγελίες από 35 $ έως 1000 $ μπορούν να χωριστούν σε 4 άτοκες πληρωμές, με προθεσμία πληρωμής κάθε 2 εβδομάδες."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Πληρωμή με κάρτα"
							},
							"description": {
								"default": "Προσφέρετε άμεσες πληρωμές με κάρτα ή τραπεζική μεταφορά."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Πώς σχεδιάζετε να κάνετε τις πωλήσεις σας;",
					"options": {
						"IN_STORE": "Φυσικό κατάστημα",
						"TELESALES": "Απομακρυσμένες πωλήσεις"
					},
					"description": {
						"IN_STORE": "Οι πωλήσεις γίνονται κυρίως αυτοπροσώπως και ο πελάτης παίρνει τα προϊόντα αμέσως.",
						"TELESALES": "Οι πωλήσεις γίνονται κυρίως τηλεφωνικώς από εισερχόμενες κλήσεις των πελατών. Ο πελάτης δεν παίρνει τα προϊόντα αμέσως."
					}
				},
				"country": {
					"label": "Χώρα"
				},
				"organization_category": {
					"label": "Τύπος νομικής οντότητας",
					"options": {
						"SOLE_TRADER": "Ατομικός έμπορος",
						"PARTNERSHIP": "Συνεταιρισμός",
						"UNDEFINED": "ΜΗ ΚΑΘΟΡΙΣΜΕΝΟ",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "Εταιρεία C",
						"S_CORP": "Εταιρεία S",
						"TRUST_ESTATE": "Καταπίστευμα/περιουσία",
						"INDIVIDUAL": "Άτομο",
						"SOLE_PROPRIETORSHIP": "Ατομική επιχείρηση",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Μονοπρόσωπη ΕΠΕ",
						"LIMITED_LIABILITY_COMPANY": "Εταιρεία περιορισμένης ευθύνης",
						"PUBLIC_LISTED_COMPANY": "Εισηγμένη εταιρεία",
						"PRIVATE_COMPANY": "ΙΔΙΩΤΙΚΗ_ΕΤΑΙΡΕΙΑ"
					}
				},
				"store_category": {
					"label": "Κύρια κατηγορία αγαθών που πωλούνται",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Παπούτσια και ρούχα για ενήλικες",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Προϊόντα αυτοκινήτου - Ανταλλακτικά και αξεσουάρ αυτοκινήτου",
						"BAGS_AND_WALLETS": "Κοσμήματα & Αξεσουάρ - Τσάντες και πορτοφόλια",
						"BODY_AND_HAIR_CARE": "Υγεία & Ομορφιά - Περιποίηση σώματος και μαλλιών",
						"BOOK_AND_MAGAZINES": "Ψυχαγωγία - Βιβλία και περιοδικά",
						"CANDY": "Φαγητό & Ποτά - Γλυκά",
						"CAR_ELECTRONICS": "Ηλεκτρονικά - Ηλεκτρονικά αυτοκινήτων",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Παιδικά προϊόντα - Παιδικά ρούχα και προϊόντα περιποίησης",
						"CHILDREN_TOYS": "Παιδικά προϊόντα - Παιδικά παιχνίδια",
						"CLEANING_AND_SANITARY": "Σπίτι & Κήπος - Καθαριότητα και υγιεινή",
						"COLLECTIBLES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Συλλεκτικά αντικείμενα",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Καταστήματα Concept και διάφορα",
						"COSMETICS": "Υγεία & Ομορφιά - Καλλυντικά",
						"COSTUMES_AND_PARTY_SUPPLIES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Στολές και είδη πάρτι",
						"DATING_SERVICES": "Άυλα προϊόντα - Υπηρεσίες γνωριμιών",
						"DECORATION_AND_ART": "Σπίτι & Κήπος - Διακόσμηση και τέχνη",
						"DIETARY_SUPPLEMENTS": "Υγεία & Ομορφιά - Συμπληρώματα διατροφής",
						"DIGITAL_SERVICES": "Άυλα προϊόντα - Ψηφιακές υπηρεσίες",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Παιδικά προϊόντα - Διαφοροποιημένα παιδικά προϊόντα",
						"DIVERSIFIED_ELECTRONICS": "Ηλεκτρονικά - Διαφοροποιημένα ηλεκτρονικά προϊόντα",
						"DIVERSIFIED_ENTERTAINMENT": "Ψυχαγωγία - Διαφοροποιημένη ψυχαγωγία",
						"DIVERSIFIED_EROTIC_MATERIAL": "Ερωτικά υλικά - Διαφοροποιημένο ερωτικό υλικό",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Υγεία & Ομορφιά - Διαφοροποιημένα προϊόντα υγείας και ομορφιάς",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Σπίτι & Κήπος - Διαφοροποιημένα προϊόντα σπιτιού και κήπου",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Κοσμήματα & Αξεσουάρ - Διαφοροποιημένα κοσμήματα και αξεσουάρ",
						"EDUCATION": "Άυλα προϊόντα - Εκπαίδευση",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Ηλεκτρονικά - Ηλεκτρονικός εξοπλισμός και σχετικά αξεσουάρ",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Ερωτικά υλικά - Ερωτικά ρούχα και αξεσουάρ",
						"EVENT_TICKETS": "Άυλα προϊόντα - Εισιτήρια εκδηλώσεων",
						"FOOD_AND_BEVERAGE": "Φαγητό & Ποτά - Φαγητό και ποτά",
						"FRAGRANCES": "Υγεία & Ομορφιά - Αρώματα",
						"FURNITURE": "Σπίτι & Κήπος - Έπιπλα",
						"GENERAL_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Γενικά παπούτσια και ρούχα",
						"HOBBY_ARTICLES": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Αντικείμενα για χόμπι",
						"HOUSEHOLD_ELECTRONICS": "Ηλεκτρονικά - Οικιακά ηλεκτρονικά προϊόντα",
						"JEWELRY_AND_WATCHES": "Κοσμήματα & Αξεσουάρ - Κοσμήματα και ρολόγια",
						"KITCHENWARE": "Σπίτι & Κήπος - Είδη κουζίνας",
						"MARKETPLACES": "Άυλα προϊόντα - Αγορές",
						"MUSIC_AND_MOVIES": "Ψυχαγωγία - Μουσική και ταινίες",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Μουσικά όργανα και εξοπλισμός",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Κοσμήματα & Αξεσουάρ - Μη συνταγογραφούμενα γυαλιά ηλίου και φακοί επαφής",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Ηλεκτρονικά - Μηχανήματα γραφείου και σχετικά αξεσουάρ",
						"OTHER_SERVICES": "Άυλα προϊόντα - Άλλες υπηρεσίες",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Υγεία & Ομορφιά - Προσωπική φροντίδα και βελτίωση σώματος",
						"PET_SUPPLIES": "Σπίτι & Κήπος - Προμήθειες για κατοικίδια",
						"PHARMACEUTICAL_PRODUCTS": "Υγεία & Ομορφιά - Φαρμακευτικά προϊόντα",
						"PLANTS_AND_FLOWERS": "Σπίτι & Κήπος - Φυτά και λουλούδια",
						"PRESCRIPTION_OPTICS": "Υγεία & Ομορφιά - Συνταγογραφούμενα οπτικά είδη",
						"PRINTS_AND_PHOTOS": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Εκτυπώσεις και φωτογραφίες",
						"SAFETY_PRODUCTS": "Σπίτι & Κήπος - Προϊόντα ασφάλειας",
						"SEX_TOYS": "Ερωτικά υλικά - Σεξουαλικά παιχνίδια",
						"SPORTS_GEAR_AND_OUTDOOR": "Ψυχαγωγικές δραστηριότητες, Άθληση & Χόμπι - Αθλητικός εξοπλισμός και προϊόντα εξωτερικού χώρου",
						"TOBACCO": "Φαγητό & Ποτά - Είδη καπνιστού",
						"TOOLS_AND_HOME_IMPROVEMENT": "Σπίτι & Κήπος - Εργαλεία και ανακαίνιση",
						"TRAVEL_SERVICES": "Άυλα προϊόντα - Ταξιδιωτικές υπηρεσίες",
						"UNDERWEAR": "Ρούχα & Παπούτσια - Εσώρουχα",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Ψυχαγωγία - Βιντεοπαιχνίδια και σχετικά αξεσουάρ",
						"WHEELS_AND_TIRES": "Προϊόντα αυτοκινήτου - Ζάντες και ελαστικά",
						"WINE_BEER_AND_LIQUOR": "Φαγητό & Ποτά - Κρασί, μπύρα και οινοπνευματώδη",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Ρούχα & Παπούτσια - Νεανικά παπούτσια και ρούχα"
					}
				},
				"currency": {
					"label": "Νόμισμα"
				},
				"account_type": {
					"label": "Είδος τραπεζικού λογαριασμού",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Τοπικός Σουηδίας",
						"LOCAL_US": "Τοπικός Η.Π.Α.",
						"LOCAL_GENERIC": "Τοπικός Νορβηγίας/Δανίας",
						"SPECIAL": "Ειδικός",
						"BANKGIRO": "Τοπικός Σουηδίας Bankgiro",
						"PLUSGIRO": "Τοπικός Σουηδίας Plusgiro"
					}
				},
				"person_role": {
					"label": "Ρόλος",
					"options": {
						"LEGAL_REPRESENTATIVE": "Νόμιμος εκπρόσωπος",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Εναλλακτικός δικαιούχος",
						"ULTIMATE_BENEFICIAL_OWNER": "Τελικός δικαιούχος",
						"OWNER": "Κάτοχος"
					}
				},
				"business_size": {
					"label": "Μέγεθος επιχείρησης",
					"options": {
						"LARGE": "μεγάλο",
						"MEDIUM": "μεσαίο",
						"small": "μικρό"
					}
				},
				"sensitive_good_category": {
					"label": "Προσφέρετε κάποια από τα ακόλουθα προϊόντα ή υπηρεσίες στο φυσικό σας κατάστημα;",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Προϊόντα για τα οποία επιβάλλονται περιορισμοί λόγω ηλικίας",
						"LICENSED_WEAPONS": "Αδειοδοτημένα όπλα",
						"PHARMA_AND_MEDICAL_SERVICES": "Φαρμακευτικές και ιατρικές υπηρεσίες",
						"TRAVEL_TOURS_EVENTS": "Ταξίδια, περιηγήσεις και εκδηλώσεις",
						"PEER_TO_PEER_MARKETPLACE": "Αγορά peer to peer",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Συμμετοχές, συνδρομές και υπηρεσίες",
						"NONE": "Προσφέρω ένα διαφορετικό προϊόν/υπηρεσία"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Καπνός, ηλεκτρονικά τσιγάρα, προϊόντα ατμίσματος, προϊόντα κάνναβης, αλκοόλ, περιεχόμενο για ενήλικες",
						"LICENSED_WEAPONS": "Πυρομαχικά, μαχαίρια μάχης, εξοπλισμός κυνηγιού, κλομπ, σπρέι πιπεριού",
						"PHARMA_AND_MEDICAL_SERVICES": "Διανομή συνταγογραφούμενων φαρμάκων, ιατρικές επεμβάσεις, συμπεριλαμβανομένων αισθητικών και τατουάζ",
						"TRAVEL_TOURS_EVENTS": "Μεταφορές, εκδηλώσεις, πλατφόρμα εισιτηρίων, ξενοδοχεία ή διαμονή, ενοικιάσεις, πρακτορεία ταξιδίων",
						"PEER_TO_PEER_MARKETPLACE": "Υπηρεσίες που επιτρέπουν σε τρίτους να πωλούν εκ νέου αγαθά ή να προσφέρουν υπηρεσίες μέσω της online πλατφόρμας τους",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Συνδρομή σε υλικά αγαθά, ψηφιακό περιεχόμενο, υπηρεσίες streaming, ιστότοποι γνωριμιών κτλ.",
						"NONE": "Προσφέρω ένα διαφορετικό προϊόν/υπηρεσία"
					},
					"error_message": "Λυπούμαστε. Δεν μπορούμε να συνεχίσουμε με την αίτησή σας γιατί επί του παρόντος δεν υποστηρίζουμε τον τύπο προϊόντος ή υπηρεσιών που επιλέξατε."
				}
			},
			"common": {
				"country": {
					"label": "Χώρα"
				},
				"address": {
					"city": {
						"label": "Πόλη"
					},
					"postal_code": {
						"label": "Ταχυδρομικός κώδικας"
					},
					"region": {
						"label": "Πολιτεία/περιοχή"
					},
					"street_address": {
						"label": "Διεύθυνση φυσικού καταστήματος"
					},
					"street_address2": {
						"label": "Γραμμή διεύθυνσης 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Επωνυμία εταιρείας"
					},
					"registration_authority": {
						"label": "Αρχή εγγραφής"
					},
					"registration_id": {
						"label": "Αριθμός εγγραφής"
					},
					"subject_to_vat": {
						"label": "Είναι η επιχείρησή σας εγγεγραμμένη για ΑΦΜ;"
					},
					"vat_id": {
						"label": "ΑΦΜ"
					},
					"persons": {
						"date_of_birth": {
							"label": "Ημερομηνία γέννησης"
						},
						"first_name": {
							"label": "Όνομα"
						},
						"last_name": {
							"label": "Επώνυμο"
						},
						"person_identity_document": {
							"label": "Έγγραφο ταυτότητας"
						},
						"person_proof_of_address": {
							"label": "Αποδεικτικό διεύθυνσης κατοικίας"
						},
						"personal_identifier": {
							"label": "Ατομική ταυτότητα"
						}
					},
					"should_auto_capture_orders": {
						"label": "Θέλετε να αποτυπώνετε αυτόματα τις παραγγελίες;",
						"tooltip": "Οι παραγγελίες πρέπει να αποτυπώνονται όταν παραδίδονται στο κατάστημα ή όταν αποστέλλονται από μια αποθήκη. Επιλέγοντας την αυτόματη αποτύπωση, η παραγγελία θα αποτυπώνεται αυτόματα όταν ο καταναλωτής επιβεβαιώσει την αγορά."
					}
				},
				"contract_entity": {
					"label": "Συμβατική οντότητα"
				},
				"contract_onboarding_type": {
					"label": "Τύπος ενσωμάτωσης επιχειρηματικού εταίρου"
				},
				"underwriting_inquiry_email": {
					"label": "Email ασφαλιστικής κάλυψης"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Όνομα κατόχου λογαριασμού"
					},
					"account_number": {
						"label": "Αριθμός λογαριασμού"
					},
					"bic": {
						"label": "Κωδικός BIC"
					},
					"iban": {
						"label": "Αριθμός λογαριασμού (IBAN)"
					},
					"is_default": {
						"label": "Χρησιμοποιήστε αυτόν τον λογαριασμό για μη καθορισμένα νομίσματα"
					},
					"routing_number": {
						"label": "Αριθμός δρομολόγησης"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Email επικοινωνίας"
					},
					"name": {
						"label": "Όνομα καταστήματος"
					},
					"support_email": {
						"label": "Email υποστήριξης πελατών"
					},
					"support_phone": {
						"label": "Τηλεφωνικός αριθμός υποστήριξης"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Παραδοσιακή πώληση αγαθών",
							"VOUCHER": "Κουπόνι",
							"MEMBERSHIP": "Ιδιότητα μέλους",
							"SUBSCRIPTION": "Συνδρομή",
							"PHARMACIES": "Φαρμακεία",
							"US_PHARMACIES": "Φαρμακεία των ΗΠΑ",
							"MEDICAL_SERVICES": "Ιατρικές υπηρεσίες",
							"MARKETPLACES": "Αγορές",
							"FIREARM_DEALERS": "Έμποροι πυροβόλων όπλων",
							"AUCTIONS": "Δημοπρασίες",
							"ALCOHOL": "Αλκοόλ",
							"TOBACCO": "Είδη καπνιστού",
							"HEMP_CBD_THC": "Κάνναβη, CBD ή THC",
							"DONATIONS_CHARITY": "Δωρεές και φιλανθρωπία",
							"TRAVEL": "Ταξίδια",
							"EVENTS": "Εκδηλώσεις",
							"COURSES": "Μαθήματα",
							"EDUCATIONAL_COURSES": "Εκπαιδευτικά μαθήματα",
							"FOOD_DELIVERY": "Παράδοση φαγητού",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Εξατομικευμένη προπαραγγελία/Έπιπλα",
							"DIGITAL_CONTENT": "Ψηφιακό περιεχόμενο",
							"GAMING_INDUSTRY": "Κλάδος παιχνιδιών (Τυχερά παιχνίδια, στοιχήματα, καζίνο, λαχεία)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Όροι και προϋποθέσεις",
					"UPSELL_WEBSTORE_TO_KPOS": "Όροι για την υπηρεσία Klarna στο κατάστημα"
				},
				"pricing_terms": {
					"default": "Όροι τιμολόγησης",
					"UPSELL_WEBSTORE_TO_KPOS": "Τιμολόγηση για την υπηρεσία Klarna στο κατάστημα"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Πρόσθετες πληροφορίες",
				"bank_account": "Ποια είναι τα στοιχεία του τραπεζικού σας λογαριασμού;",
				"business_size": "Ποιος είναι ο αναμενόμενος ετήσιος όγκος σας μέσω του Σημείου Πώλησης Klarna;",
				"in_store_get_started": "Ξεκινήστε την επιχείρησή σας με την Klarna.",
				"in_store_legal_form": "Ποιο είναι το είδος της επιχείρησής σας;",
				"in_store_registered_address": "Ποια είναι η εγγεγραμμένη διεύθυνσή σας;",
				"in_store_registration": "Είναι η επιχείρησή σας εγγεγραμμένη εταιρεία;",
				"in_store_stakeholder": "Ποιος διοικεί την εταιρεία;",
				"in_store_stores": "Ποια είναι τα στοιχεία του καταστήματός σας για το Σημείο Πώλησης Klarna;",
				"in_store_vat": "Είναι η επιχείρησή σας εγγεγραμμένη για ΑΦΜ;",
				"product_channel": "Πώς η επιχείρησή σας σκοπεύει να χρησιμοποιήσει το Σημείο Πώλησης Klarna;",
				"sensitive_goods": "Ποια κατηγορία προϊόντων θα πουλάτε με το Σημείο Πώλησης Klarna;",
				"ads_manager_get_started": "Σχεδόν έτοιμοι.",
				"content_store_get_started": "Σχεδόν έτοιμοι."
			},
			"subtitle": {
				"additional_data": "Πραγματοποιούμε έλεγχο της αίτησής σας και χρειαζόμαστε λίγες πληροφορίες ακόμα για να προχωρήσουμε.",
				"bank_account": "Οι συναλλαγές Klarna θα μεταφερθούν σε αυτόν τον τραπεζικό λογαριασμό.",
				"business_size": "Χρειαζόμαστε κάποιες βασικές πληροφορίες σχετικά με την επιχείρησή σας για να επεξεργαστούμε την αίτησή σας.",
				"in_store_get_started": "Χρειαζόμαστε κάποιες βασικές πληροφορίες για να σας οδηγήσουμε στο σωστό μέρος.",
				"in_store_legal_form": "Πρέπει να κάνουμε ορισμένες συγκεκριμένες ερωτήσεις με βάση το είδος της επιχείρησής σας.",
				"in_store_registered_address": "Εδώ είναι νομίμως εγγεγραμμένη η επιχείρησή σας και θα εμφανίζεται στα τιμολόγια πελατών της Klarna.",
				"in_store_registration": "Χρειαζόμαστε τον αριθμό εγγραφής της εταιρείας σας για να επαληθεύσουμε τα στοιχεία της επιχείρησής σας.",
				"in_store_stakeholder": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες.",
				"in_store_stores": "Θα χρησιμοποιήσουμε τις πληροφορίες για τη δημιουργία του νέου σας λογαριασμού Σημείου Πώλησης Klarna.",
				"in_store_vat": "Εάν έχετε ΑΦΜ, μπορούμε πιο εύκολα να επαληθεύσουμε τα στοιχεία της εταιρείας σας.",
				"product_channel": "Επιλέξτε το κύριο κανάλι πωλήσεων. Θα μπορείτε να χρησιμοποιήσετε το Σημείο Πώλησης Klarna και για τα δύο κανάλια.",
				"sensitive_goods": "Η ενσωμάτωση self-service για το Σημείο Πώλησης Klarna δεν σας επιτρέπει να πουλάτε προϊόντα τα οποία τελούν υπό περιορισμό από την Klarna.",
				"ads_manager_get_started": "Δηλώστε μια διεύθυνση email χρέωσης όπου θα αποστέλλονται τα τιμολόγια της καμπάνιας. Πρέπει να είστε διαχειριστής για να ενεργοποιήσετε τον λογαριασμό. Έπειτα, ο διαχειριστής μπορεί να χορηγήσει άδειες σε άλλους χρήστες.",
				"content_store_get_started": "Πριν αποκτήσετε πρόσβαση στο Content Manage, διαβάστε και αποδεχτείτε τους όρους και τις προϋποθέσεις μας."
			},
			"summary": {
				"title": "Πριν υποβάλετε την αίτησή σας, ελέγξτε τα στοιχεία σας"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Επεξεργαζόμαστε την αίτησή σας. Αυτό μπορεί να διαρκέσει λίγα λεπτά.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Παρακαλούμε περιμένετε...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Παρακαλούμε περιμένετε..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Η αίτησή σας υποβάλλεται σε επεξεργασία και δημιουργούμε το νέο σας αναγνωριστικό εμπόρου."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Ετοιμάζουμε τα πάντα για τον λογαριασμό σας Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Ετοιμάζουμε τα πάντα για τον λογαριασμό σας \"Διαχειριστής Περιεχομένου\"."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Συγχαρητήρια! Η αίτησή σας εγκρίθηκε.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Είστε έτοιμοι!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Είστε έτοιμοι!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Τώρα ας ενσωματώσουμε την Klarna στο online κατάστημά σας. Μεταβείτε στην καρτέλα Προϊόντα στον λογαριασμό σας της πύλης εμπόρων για να βρείτε τα διαπιστευτήριά σας ενσωμάτωσης και οδηγίες για το πώς να τα χρησιμοποιήσετε."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Τώρα ας ρυθμίσουμε το κατάστημά σας για να μπορείτε να αρχίσετε να λαμβάνετε πληρωμές αμέσως."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Μεταβείτε στο Ads Manager για να ξεκινήσετε τη δημιουργία της πρώτης σας καμπάνιας."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Μεταβείτε στο Content Manager και δημοσιεύστε την πρώτη σας προσφορά σήμερα."
							}
						]
					},
					"second_title": {
						"default": "Επισκεφτείτε τα έγγραφα Klarna για περισσότερες πληροφορίες σχετικά με το πώς θα ενσωματωθείτε στην Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Χρειάζεστε βοήθεια με τη ρύθμιση του καταστήματός σας; Είμαστε εδώ για να σας βοηθήσουμε",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Χρειάζεστε βοήθεια με τη χρήση του Ads Manager; Διαβάστε τις συχνές ερωτήσεις ή επικοινωνήστε με την υποστήριξη εμπόρων. Θα χαρούμε να σας εξυπηρετήσουμε.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Χρειάζεστε βοήθεια με τη χρήση του Content Manager; Διαβάστε τις συχνές ερωτήσεις ή επικοινωνήστε με την υποστήριξη εμπόρων. Θα χαρούμε να σας εξυπηρετήσουμε."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Οι καλύτερες οδηγίες πρακτικής μας μπορούν να σας βοηθήσουν να εκμεταλλευτείτε τη συνεργασία σας με μας με τον καλύτερο τρόπο."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Πληρωμές Klarna",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Επικοινωνήστε με την υποστήριξη εμπόρων. Θα χαρούμε να σας εξυπηρετήσουμε."
							},
							{
								"text": "Επικοινωνήστε με την υποστήριξη",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Επισκεφθείτε την ενότητα Συχνές ερωτήσεις.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Επισκεφθείτε την ενότητα Συχνές ερωτήσεις.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Πάμε.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Πάμε",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Πάμε",
						"UPSELL_WEBSTORE_TO_KPOS": "Ξεκινήστε τις πωλήσεις"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Σας ευχαριστούμε! Εξετάζουμε την αίτησή σας.",
					"badge": "Περίπου 5-7 ημέρες",
					"paragraphs": [
						{
							"text": "Θα λάβετε ένα email όταν o έλεγχός μας ολοκληρωθεί ή αν χρειαστούμε επιπρόσθετες πληροφορίες."
						}
					],
					"second_title": "Στο μεσοδιάστημα ελέγξτε το email σας",
					"second_paragraphs": [
						{
							"text": "Σας στείλαμε ένα email με τον τίτλο «Καλωσορίσατε στην Πύλη Εμπόρων της Klarna». Ακολουθήστε τα βήματα εκεί για να συνδεθείτε και να ενεργοποιήσετε τον λογαριασμό σας."
						}
					]
				},
				"SUSPENDED": {
					"title": "Δυστυχώς η αίτησή σας δεν εγκρίθηκε.",
					"paragraphs": [
						{
							"text": "Μετά από έλεγχο των στοιχείων της επιχείρησής σας, δεν μπορούμε να προχωρήσουμε με την αίτηση σας για <strong>{businessName}</strong>."
						},
						{
							"text": "Αυτοί είναι κάποιοι από τους πιο συχνούς λόγους:"
						},
						{
							"list": [
								{
									"text": "Το κατάστημά σας δεν συμμορφώνεται με τις κατευθυντήριες οδηγίες δεοντολογίας της Klarna."
								},
								{
									"text": "Δεν είναι δυνατή η επικοινωνία με την εξυπηρέτηση πελατών σας."
								},
								{
									"text": "Άλλοι διαχειριστικοί παράγοντες."
								}
							]
						},
						{
							"text": "Ευχαριστούμε για το ενδιαφέρον σας στην υπηρεσία <strong>Klarna [στο κατάστημα]</strong>. Ελπίζουμε ότι θα μπορέσουμε να συνεργαστούμε μαζί σας στο μέλλον."
						}
					],
					"second_title": "Αν έχετε περισσότερες ερωτήσεις",
					"second_paragraphs": [
						{
							"text": "Σχετικά με την απόφασή μας ή οποιοδήποτε άλλο προϊόν Klarna, παρακαλούμε επικοινωνήστε μαζί μας και θα σας βοηθήσουμε με χαρά."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Ποιος υπογράφει τις συμβάσεις για την εταιρεία σας;"
					},
					"subtitle": {
						"default": [
							{
								"text": "Η επιχείρησή σας πρόκειται να συνάψει σύμβαση με την Klarna. Πρέπει να επαληθεύσουμε ποιος είναι νόμιμα εξουσιοδοτημένος να υπογράφει συμβάσεις."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Υπάρχουν άτομα που κατέχουν περισσότερο από το 25% της εταιρείας;"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"default": [
							{
								"text": "Πρέπει να γνωρίζουμε τα άτομα που κατέχουν περισσότερο από το 25% των μετοχών ή των δικαιωμάτων ψήφου της εταιρείας ή που ασκούν παρόμοιο έλεγχο. Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Ποιος διοικεί την εταιρεία;"
					},
					"subtitle": {
						"default": [
							{
								"text": "Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"US": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"CA": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Υπάρχουν άτομα που κατέχουν περισσότερο από το 25% της εταιρείας;"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Ως χρηματοπιστωτικό ίδρυμα, είμαστε νομικά υποχρεωμένοι να συλλέγουμε αυτές τις πληροφορίες."
							}
						],
						"default": [
							{
								"text": "Πρέπει να γνωρίζουμε τα άτομα που κατέχουν περισσότερο από το 25% των μετοχών ή των δικαιωμάτων ψήφου της εταιρείας ή που ασκούν παρόμοιο έλεγχο. Είμαστε νομικά υποχρεωμένοι από την οδηγία της ΕΕ για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες ("
							},
							{
								"text": "ΕΕ 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") να συλλέγουμε αυτές τις πληροφορίες."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Λύσεις",
					"title_2": "Μέθοδοι πληρωμής",
					"note": "Όλες οι τιμές είναι ανά συναλλαγή.",
					"per_transaction": "ανά συναλλαγή",
					"cross_border_notice": "Ενδέχεται να ισχύουν πρόσθετες διασυνοριακές χρεώσεις",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "δείτε",
						"link_text": "το παράρτημα τιμών"
					},
					"not_available_for_business": "Δεν είναι διαθέσιμο για την επιχείρησή σας",
					"not_available_for_country": "Μπορείτε να κάνετε πωλήσεις μόνο σε άλλες αγορές",
					"not_compatible_with_platform": "Δεν είναι διαθέσιμο για την πλατφόρμα σας",
					"installed": "Εγκαταστάθηκε"
				},
				"buttons": {
					"next": "Επόμενο"
				}
			}
		}
	}
};